import { storage, firebase, db } from "./firebase";
import { getDownloadURL, getMetadata, ref } from "firebase/storage";
import { v4 as uuid } from "uuid";
export const getUUID = () => {
  const unique_id = uuid().replace(/-/gi, "");
  return unique_id;
};
/* import { doc, getDoc, getFirestore } from "firebase/firestore" */

export const getAudioFile = function (audioFileURL) {
  const audioFileRef = ref(storage, audioFileURL);
  return getDownloadURL(audioFileRef);
};
export const updateWixID = function (tourID, wixID) {
  return new Promise(async (resolve, reject) => {
    try {
      await db.collection("tours").doc(tourID).update({
        wixID: wixID,
      });
      resolve("Product ID saved successfully!");
    } catch (error) {
      console.error("Error saving product ID: ", error);
      reject("Failed to save Product ID. Please try again.");
    }
  });
};

export const updateBokunID = function (
  tourID,
  bokunID,
  gID,
  validityDays,
  maxUsage,
) {
  return new Promise(async (resolve, reject) => {
    try {
      /*  await db.collection("tours").doc(tourID).update({
        bokunID: bokunID,
      }); */

      // Ensure all required parameters are provided
      if (!tourID || !bokunID || !gID) {
        throw new Error("Missing required parameters: tourID, bokunID, or gID");
      }

      await db
        .collection("bokunExperienceMap")
        .doc(bokunID)
        .set({
          bokunID: bokunID,
          gID: gID,
          tID: tourID,
          validityDays: validityDays || 21,
          maxUsage: maxUsage || 2,
          createdAt: new Date(),
          updatedAt: new Date(),
        });
      resolve("Experience ID saved successfully!");
    } catch (error) {
      console.error("Error saving Experience ID: ", error);
      reject("Failed to save Experience ID. Please try again.");
    }
  });
};

export const uploadFilePromise = function (files, basePath, setPercent, name) {
  return new Promise(function (myResolve, myReject) {
    if (files === "") {
      myReject(`The is no file`);
    }
    try {
      const uploadTask = storage.ref(`${basePath}/${name}`).put(files[0]);
      //initiates the firebase side uploading
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          //takes a snap shot of the process as it is happening
          const percent = Math.round(
            (snapShot.bytesTransferred / snapShot.totalBytes) * 100,
          );
          setPercent(percent);
          //console.log(percent);
        },
        (err) => {
          //catches the errors
          console.error("Firebase upload error:", err);
          myReject(err);
        },
        () => {
          // gets the functions from storage refences the image storage in firebase by the children
          // gets the download url then sets the image from firebase as the value for the imgUrl key:
          getDownloadURL(uploadTask.snapshot.ref)
            .then((url) => {
              console.log("Firebase download URL generated:", url);

              // Validate the URL format
              if (
                !url ||
                typeof url !== "string" ||
                !url.startsWith("https://")
              ) {
                console.error("Invalid Firebase URL format:", url);
                myReject(new Error("Invalid Firebase URL format"));
                return;
              }

              myResolve(url);
            })
            .catch((error) => {
              console.error("Error getting download URL:", error);
              myReject(error);
            });
        },
      );
    } catch (error) {
      console.error("Upload task creation error:", error);
      myReject(error);
    }
  });
};

export const uploadFileWithTypePromise = function (
  files,
  basePath,
  setPercent,
  name,
) {
  return new Promise(function (myResolve, myReject) {
    if (files === "") {
      myReject(`The is no file`);
    }
    try {
      const uploadTask = storage
        .ref(`${basePath}/${/* files[0]. */ name}`)
        .put(files[0], { contentType: files[0].type });
      //initiates the firebase side uploading
      uploadTask.on(
        "state_changed",
        (snapShot) => {
          const percent = Math.round(
            (snapShot.bytesTransferred / snapShot.totalBytes) * 100,
          );
          setPercent(percent);
        },
        (err) => {
          //catches the errors
          myReject(err);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            myResolve(url);
          });
        },
      );
    } catch (error) {
      myReject(error);
    }
  });
};

export const deleteFilePromise = function (url) {
  return new Promise(function (myResolve, myReject) {
    try {
      let pictureRef = storage.refFromURL(url);
      pictureRef
        .delete()
        .then(() => {
          myResolve(true);
        })
        .catch((err) => {
          if (err.code.includes("object-not-found"))
            myReject("object-not-found");
          myReject(false);
        });
    } catch (error) {
      if (error.code.includes("storage/invalid-argument"))
        myReject("storage/invalid-argument");
      myReject(error);
    }
  });
};

export const addNewUserFirestore = function (user) {
  return new Promise(function (myResolve, myReject) {
    try {
      //firebase.firestore().collection('saasUsers').doc(user.uid).set(user).then(() => {
      firebase
        .firestore()
        .collection("saasCustomers")
        .doc(user.uid)
        .set(user)
        .then(() => {
          myResolve(true);
        })
        .catch((err) => {
          myReject(err);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const getAIData = function (userID) {
  return new Promise(function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("AIarea")
        .doc(userID)
        .get()
        .then((snapshot) => {
          myResolve(snapshot.data());
        })
        .catch((e) => {
          console.log(e);
          myReject(null);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const setUserVoiceId = function (voiceId, userId) {
  return new Promise(function (myResolve, myReject) {
    try {
      console.log("set voiceId firebase", voiceId, userId);
      firebase
        .firestore()
        .collection("AIarea")
        .doc(userId)
        .set({ voiceId: voiceId }, { merge: true }) // Use set with merge option
        .then(() => {
          myResolve(voiceId);
        })
        .catch((err) => {
          myReject(err);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const setVoiceURLsample = function (voiceURL, userId, voiceSettings) {
  return new Promise(function (myResolve, myReject) {
    try {
      console.log("set voiceURL firebase", voiceURL, userId, voiceSettings);
      firebase
        .firestore()
        .collection("AIarea")
        .doc(userId)
        .set({ voiceURL: voiceURL, voiceSettings }, { merge: true }) // Use set with merge option
        .then(() => {
          myResolve(voiceURL);
        })
        .catch((err) => {
          myReject(err);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const getAISettings = function (userId) {
  return new Promise(function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("AIarea")
        .doc(userId)
        .get()
        .then((snapshot) => {
          myResolve(snapshot.data());
        })
        .catch((e) => {
          console.log(e);
          myReject(null);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const deleteVoiceDB = function (userId) {
  return new Promise(function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("AIarea")
        .doc(userId)
        .set({ voiceId: null, voiceURL: null }, { merge: true })
        .then(() => {
          myResolve(true);
        })
        .catch((err) => {
          myReject(err);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const saveAItext = async function (userID, text) {
  try {
    await firebase
      .firestore()
      .collection("AIarea")
      .doc(userID)
      .set({ AItext: text }, { merge: true });
    return true;
  } catch (error) {
    console.log("error", error);
    return false;
  }
};

export const updateUserFirestore = function (user) {
  return new Promise(function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("saasCustomers")
        .doc(user.uid)
        .set(user)
        .then(() => {
          myResolve(true);
        })
        .catch((err) => {
          myReject(err);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const checkSaaSCoupon = function (coupon) {
  return new Promise(function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("saasCoupons")
        .doc(coupon)
        .get()
        .then((snapshot) => {
          myResolve(true);
        })
        .catch((e) => {
          console.log(e);
          myReject(null);
        });
    } catch (error) {
      myReject(error);
    }
  });
};

export const moveTourToDeleted = function (tourId) {
  const db = firebase.firestore();
  const tourRef = db.collection("tours").doc(tourId);
  const deletedTourRef = db.collection("deletedTours").doc(tourId);

  const userConfirmed = window.confirm(
    "Are you sure you want to delete this tour?",
  );
  if (!userConfirmed) {
    return Promise.reject("User cancelled delete operation");
  }

  return db.runTransaction((transaction) => {
    return transaction.get(tourRef).then((tourDoc) => {
      if (!tourDoc.exists) {
        throw "Tour not found";
      }

      transaction.set(deletedTourRef, tourDoc.data());
      transaction.delete(tourRef);
    });
  });
};

export const getUserByID = function (userID) {
  return new Promise(function (myResolve, myReject) {
    //firebase.firestore().collection("saasUsers").doc(`${userID}`).get().then((snapshot) => {
    firebase
      .firestore()
      .collection("saasCustomers")
      .doc(`${userID}`)
      .get()
      .then((snapshot) => {
        myResolve(snapshot.data());
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

export const createSellingWebTour = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    try {
      console.log("start creating...", tour);
      const tourDoc = await firebase
        .firestore()
        .collection("web_tour")
        .doc(tour.id)
        .get();
      console.log("tourDoc", tourDoc);
      if (tourDoc.exists) {
        return myResolve("Document with this tourID already exists.");
      }
      console.log("AFTER!!!");
      let stopLocations = [];
      tour.stops.map((stop) => {
        stopLocations.push({
          lat: stop.stop_location.latitude,
          lng: stop.stop_location.longitude,
        });
      });
      let htmlString = "";
      if (tour.notes && tour.notes.length > 0) {
        htmlString = `<div><h2 style="margin-bottom:15px;">What Awaits You on the Route?</h2>`;
        tour.notes.forEach((item) => {
          htmlString += `
          <h3>${item.question}</h3>
          <p>${item.answer}</p>
          `;
        });
        htmlString += "</div>";
      } else {
        htmlString = `<div>
  <h2 style="margin-bottom:15px;">What Awaits You on the Route?</h2>
  
  <h3>🏛️ Colosseum</h3>
  <p>We'll start with a visit to the Colosseum 🏛️, one of Rome's most iconic landmarks. This ancient amphitheater, rich in history, offers a glimpse into the grandeur of the Roman Empire.</p>
  
  <h3>🕍 Pantheon</h3>
  <p>Next, we'll visit the Pantheon 🕍, a marvel of ancient engineering. Its massive dome and oculus are a testament to Roman architectural ingenuity.</p>
  
  <h3>🍝 Piazza Navona</h3>
  <p>We'll stop at Piazza Navona 🍝, a vibrant square surrounded by stunning baroque architecture. Here, you can enjoy a taste of authentic Italian gelato or a cappuccino.</p>
  
  <h3>🎨 Vatican Museums</h3>
  <p>Afterward, we'll explore the Vatican Museums 🎨, home to an extensive collection of art and historical artifacts. Don't miss the Sistine Chapel with Michelangelo's breathtaking frescoes.</p>
  
  <h3>⛪ St. Peter's Basilica</h3>
  <p>We'll continue to St. Peter's Basilica ⛪, the heart of the Vatican and one of the most important religious sites in the world. The basilica's grandeur is unmatched.</p>
  
  <h3>🌅 Gianicolo Hill</h3>
  <p>We'll finish with a panoramic view 🌅 from Gianicolo Hill. This spot offers a breathtaking view of Rome, allowing you to take in the beauty of the Eternal City in all its glory.</p>
</div>`;
      }

      // Specify the source folder in Firebase Storage
      const sourceFolderPath = "toursWeb/master/";
      const destinationFolderPath = `toursWeb/${tour.id}/`;

      // Function to copy files from source to destination
      // Function to copy files from source to destination
      async function copyFolder(sourcePath, destinationPath) {
        console.log("Copying folder", sourcePath, "to", destinationPath);

        // Ensure that paths end with a slash
        if (!sourcePath.endsWith("/")) sourcePath += "/";
        if (!destinationPath.endsWith("/")) destinationPath += "/";

        const listResult = await firebase.storage().ref(sourcePath).listAll();
        const fileURLs = {};
        console.log("listResult", listResult);

        // Copy files
        for (const itemRef of listResult.items) {
          const fileName = itemRef.name;
          const fileRef = firebase.storage().ref(destinationPath + fileName);

          // Get the file's download URL
          const downloadURL = await itemRef.getDownloadURL();

          // Fetch the file data
          const fileData = await fetch(downloadURL).then((res) => res.blob());

          // Upload the file to the destination
          await fileRef.put(fileData);

          // Get the new download URL
          const newDownloadURL = await fileRef.getDownloadURL();
          fileURLs[destinationPath + fileName] = newDownloadURL;
        }

        // Recursively copy subfolders
        for (const folderRef of listResult.prefixes) {
          const subFolderPath = folderRef.fullPath.replace(sourcePath, "");
          const subFolderURLs = await copyFolder(
            sourcePath + subFolderPath,
            destinationPath + subFolderPath,
          );
          Object.assign(fileURLs, subFolderURLs);
        }

        return fileURLs;
      }

      console.log("before copyFolder", sourceFolderPath, destinationFolderPath);
      // Copy the folder and get the file URLs
      const fileURLs = await copyFolder(
        sourceFolderPath,
        destinationFolderPath,
      );
      console.log("fileURLs", fileURLs);
      // Add file URLs to the tour object
      //tour.fileURLs = fileURLs;

      // Set the new document in the web_tour collection
      const newObj = {
        gid: tour.tour_guide.id,
        guideProfileImgInput: {
          file: [],
          url: fileURLs[`toursWeb/${tour.id}/profileImg.webp`],
        },
        tourImageInput: {
          file: [],
          url: fileURLs[`toursWeb/${tour.id}/mainImg.webp`],
          //url: fileURLs[`toursWeb/${tour.id}/mainImg_resize`]
        },

        tourVidInput: {
          file: [],
          url: fileURLs[`toursWeb/${tour.id}/mainVid.mp4`]
            ? fileURLs[`toursWeb/${tour.id}/mainVid.mp4`]
            : "",
        },

        recommendations: [
          {
            imagUniqueID: "review1.webp",
            imageFile: [],
            recImg:
              fileURLs[`toursWeb/${tour.id}/recommendations/review1.webp`],
            recommendantName: "Alex Johnson",
            stars: "5",
            tourRecommendant:
              "The historic city tour was fascinating! The self-guided format let me explore freely, and the insights at each stop were spot-on. A must-try for history lovers!",
          },
          {
            imagUniqueID: "review2.webp",
            imageFile: [],
            recImg:
              fileURLs[`toursWeb/${tour.id}/recommendations/review2.webp`],
            recommendantName: "Jordan Smith",
            stars: "5",
            tourRecommendant:
              "The coastal adventure tour was stunning! Beautiful routes and easy navigation made for a perfect day out. Highly recommend for anyone wanting a peaceful yet engaging experience.",
          },
          {
            imagUniqueID: "review3.webp",
            imageFile: [],
            recImg:
              fileURLs[`toursWeb/${tour.id}/recommendations/review1.webp`],
            recommendantName: "Taylor Brown",
            stars: "5",
            tourRecommendant:
              "Loved the cultural landmarks tour! The audio guides were informative, and the trivia was fun. A great way to learn about local traditions at your own pace.",
          },
        ],
        paymentcurrency: "USD",
        price: "20",
        title: tour.title,
        tourAgeGroupP: "10-99",
        logoImageInput: {
          file: [],
          url: tour.tour_guide.profile_image
            ? tour.tour_guide.profile_image
            : fileURLs[`toursWeb/${tour.id}/logoImg.webp`]
            ? fileURLs[`toursWeb/${tour.id}/logoImg.webp`]
            : "",
        },
        contactNumber: "",
        tourImagesArray: [
          {
            file: [],
            name: "tourImg1_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg1_resize.jpg`
            ],
          },
          {
            file: [],
            name: "tourImg2_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg2_resize.jpg`
            ],
          },
          {
            file: [],
            name: "tourImg3_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg3_resize.jpg`
            ],
          },
          {
            file: [],
            name: "tourImg4_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg4_resize.jpg`
            ],
          },
          {
            file: [],
            name: "tourImg5_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg5_resize.jpg`
            ],
          },
          {
            file: [],
            name: "tourImg6_resize.jpg",
            url: fileURLs[
              `toursWeb/${tour.id}/tourImagesArray/tourImg6_resize.jpg`
            ],
          },
        ],
        tourLocactionP: tour.location ? tour.location : "Rome, italy",
        tourPriceP: "25$",
        tourTimeInfoP: "sun-thu, 10:00-20:00",
        tourTypeP: "Culinary, history",
        tourdescription:
          "Discover Rome’s most iconic landmarks on this self-guided tour. Visit the Colosseum, Vatican City, and the Roman Forum, while uncovering hidden gems and vibrant piazzas. With rich historical insights and local tips, experience the Eternal City at your own pace, immersing yourself in its timeless charm and beauty.",
        tourLocations: stopLocations,
        guideDescription:
          "I’m a passionate local guide with a love for history and culture. I’ve been leading tours for over 10 years, sharing my knowledge and insights with visitors from around the world. Join me on a journey through Rome’s fascinating past and vibrant present, and let me show you the city’s hidden gems and iconic landmarks.",
        guideName: tour.tour_guide.name ? tour.tour_guide.name : "Guide Name",
        HTMLtext: htmlString,
      };
      console.log("creating new object, web_tour", newObj);
      await firebase
        .firestore()
        .collection("web_tour")
        .doc(tour.id)
        .set(newObj);

      myResolve(true);
    } catch (error) {
      myReject(error);
    }
  });
};

// ==================== NEW AI-ENHANCED WEB TOUR CREATION ====================

/**
 * Helper: Collect images from tour with smart prioritization
 * Priority 1: tour.all_media (main tour images)
 * Priority 2: tour.stops[].loc_pics (location pictures)
 * Priority 3: tour.stops[].all_media (stop media)
 */
const collectTourImages = (tour) => {
  const images = [];
  const MAX_IMAGES = 6;

  try {
    // Helper to safely check if URL is valid
    const isValidUrl = (url) => {
      return (
        url && typeof url === "string" && url.trim().startsWith("https://")
      );
    };

    // Helper to check if media is an image
    const isImageMedia = (media) => {
      if (!media) return false;
      // Check type field
      if (media.type) {
        const typeStr = String(media.type).toLowerCase();
        if (
          typeStr.includes("image") ||
          typeStr.includes("jpg") ||
          typeStr.includes("jpeg") ||
          typeStr.includes("png") ||
          typeStr.includes("webp") ||
          typeStr.includes("avif")
        ) {
          return true;
        }
      }
      // Fallback: check URL extension
      if (media.url) {
        const urlStr = String(media.url).toLowerCase();
        if (
          urlStr.endsWith(".jpg") ||
          urlStr.endsWith(".jpeg") ||
          urlStr.endsWith(".png") ||
          urlStr.endsWith(".webp") ||
          urlStr.endsWith(".avif") ||
          urlStr.includes("_resize") ||
          urlStr.includes("_avif")
        ) {
          return true;
        }
      }
      return false;
    };

    // Priority 1: Tour-level media (filtered for images)
    if (tour.all_media && Array.isArray(tour.all_media)) {
      tour.all_media.forEach((media) => {
        if (images.length >= MAX_IMAGES) return;
        if (isImageMedia(media) && isValidUrl(media.url)) {
          images.push({
            url: media.url,
            name: media.name || "tour_image",
            source: "tour_media",
          });
        }
      });
    }

    // Priority 2: Stop location pictures (handle multiple formats)
    if (images.length < MAX_IMAGES && tour.stops && Array.isArray(tour.stops)) {
      tour.stops.forEach((stop, idx) => {
        if (images.length >= MAX_IMAGES) return;

        // Format 1: loc_pics as array of objects with url
        if (stop.loc_pics && Array.isArray(stop.loc_pics)) {
          stop.loc_pics.forEach((pic) => {
            if (images.length >= MAX_IMAGES) return;
            // Handle object format
            if (pic && typeof pic === "object" && isValidUrl(pic.url)) {
              images.push({
                url: pic.url,
                name: pic.name || `stop_${idx}_loc`,
                source: "stop_location",
              });
            } else if (typeof pic === "string" && isValidUrl(pic)) {
              // Handle string format (direct URL)
              images.push({
                url: pic,
                name: `stop_${idx}_loc`,
                source: "stop_location",
              });
            }
          });
        } else if (
          typeof stop.loc_pics === "string" &&
          isValidUrl(stop.loc_pics)
        ) {
          // Format 2: loc_pics as single string URL
          images.push({
            url: stop.loc_pics,
            name: `stop_${idx}_loc`,
            source: "stop_location",
          });
        }
      });
    }

    // Priority 3: Stop all_media (filtered for images)
    if (images.length < MAX_IMAGES && tour.stops && Array.isArray(tour.stops)) {
      tour.stops.forEach((stop, idx) => {
        if (images.length >= MAX_IMAGES) return;
        if (stop.all_media && Array.isArray(stop.all_media)) {
          stop.all_media.forEach((media) => {
            if (images.length >= MAX_IMAGES) return;
            if (isImageMedia(media) && isValidUrl(media.url)) {
              images.push({
                url: media.url,
                name: media.name || `stop_${idx}_media`,
                source: "stop_media",
              });
            }
          });
        }
      });
    }

    console.log(
      `Collected ${images.length} images for tour ${tour.id || "unknown"}`,
    );
    console.log(
      "Image sources:",
      images.map((img) => `${img.source}: ${img.name}`),
    );

    if (images.length === 0) {
      console.warn(`Warning: No images found for tour ${tour.id || "unknown"}`);
      console.warn("Tour structure:", {
        hasAllMedia: !!tour.all_media,
        allMediaLength: tour.all_media?.length || 0,
        hasStops: !!tour.stops,
        stopsLength: tour.stops?.length || 0,
        firstStopHasMedia: !!(
          tour.stops?.[0]?.all_media || tour.stops?.[0]?.loc_pics
        ),
      });
    } else if (images.length < 3) {
      console.warn(
        `Warning: Only ${images.length} images found for tour ${
          tour.id || "unknown"
        } (recommended: 3+)`,
      );
    }

    return images.slice(0, MAX_IMAGES);
  } catch (error) {
    console.error("Error collecting tour images:", error);
    return [];
  }
};

// ==================== AI INFRASTRUCTURE ====================

/**
 * Rate Limiter Class - Controls API request rate (RPM)
 */
class RateLimiter {
  constructor(maxRPM) {
    this.maxRPM = maxRPM;
    this.queue = [];
    this.requestsThisMinute = 0;
    this.lastResetTime = Date.now();

    setInterval(() => {
      this.requestsThisMinute = 0;
      this.lastResetTime = Date.now();
    }, 60000);
  }

  async enqueue(requestFn) {
    return new Promise((resolve) => {
      this.queue.push({ requestFn, resolve });
      this.processQueue();
    });
  }

  async processQueue() {
    if (this.queue.length === 0 || this.requestsThisMinute >= this.maxRPM) {
      if (this.queue.length > 0) {
        const delay = 60000 - (Date.now() - this.lastResetTime);
        setTimeout(() => this.processQueue(), Math.max(delay, 1000));
      }
      return;
    }

    const { requestFn, resolve } = this.queue.shift();
    this.requestsThisMinute++;
    try {
      const result = await requestFn();
      resolve(result);
    } catch (error) {
      resolve(Promise.reject(error));
    }
    this.processQueue();
  }
}

/**
 * Circuit Breaker Class - Prevents cascading failures
 */
class CircuitBreaker {
  constructor(options = {}) {
    this.failureThreshold = options.failureThreshold || 5;
    this.successThreshold = options.successThreshold || 3;
    this.timeout = options.timeout || 30000;
    this.resetTimeout = options.resetTimeout || 120000;

    this.state = "CLOSED";
    this.failureCount = 0;
    this.successCount = 0;
    this.lastFailureTime = null;
    this.nextAttemptTime = null;
  }

  async execute(requestFn) {
    if (this.state === "OPEN") {
      if (Date.now() < this.nextAttemptTime) {
        throw new Error(
          `Service unavailable. Next try at ${new Date(
            this.nextAttemptTime,
          ).toISOString()}`,
        );
      }
      this.state = "HALF";
    }

    try {
      const result = await requestFn();
      this.onSuccess();
      return result;
    } catch (error) {
      this.onFailure(error);
      throw error;
    }
  }

  onSuccess() {
    this.failureCount = Math.max(0, this.failureCount - 1);
    if (this.state === "HALF") {
      this.successCount++;
      if (this.successCount >= this.successThreshold) {
        this.reset();
      }
    }
  }

  onFailure(error) {
    this.failureCount++;
    this.successCount = 0;

    const errorWeight = error.message.includes("429") ? 2 : 1;

    if (this.failureCount * errorWeight >= this.failureThreshold) {
      this.trip();
    }
  }

  trip() {
    this.state = "OPEN";
    this.lastFailureTime = Date.now();
    this.nextAttemptTime = this.lastFailureTime + this.timeout;

    setTimeout(() => {
      this.state = "HALF";
      setTimeout(() => {
        if (this.state === "HALF") this.reset();
      }, this.resetTimeout);
    }, this.timeout);
  }

  reset() {
    this.state = "CLOSED";
    this.failureCount = 0;
    this.successCount = 0;
    this.lastFailureTime = null;
    this.nextAttemptTime = null;
  }
}

// Initialize AI infrastructure
const openAIRateLimiter = new RateLimiter(40); // 40 RPM (80% of OpenAI limit)
const apiCircuitBreaker = new CircuitBreaker({
  failureThreshold: 5,
  successThreshold: 3,
  timeout: 30000,
  resetTimeout: 120000,
});

/**
 * AI Configuration & Cost Tracking
 */
const AI_CONFIG = {
  OPENAI_API_KEY: process.env.REACT_APP_OPENAI_API_KEY || "",
  ENDPOINT: "https://api.openai.com/v1/chat/completions",
  MODELS: {
    GPT4: "gpt-4-turbo-preview",
    GPT35: "gpt-3.5-turbo",
  },
  PRICING: {
    "gpt-4-turbo-preview": { input: 0.01, output: 0.03 }, // per 1K tokens
    "gpt-3.5-turbo": { input: 0.0005, output: 0.0015 },
  },
  MAX_RETRIES: 3,
};

/**
 * Calculate cost estimate for AI content generation
 */
const estimateTokens = (text) => {
  // Rough estimate: ~4 characters per token
  return Math.ceil(text.length / 4);
};

const calculateCost = (inputTokens, outputTokens, model) => {
  const pricing = AI_CONFIG.PRICING[model];
  if (!pricing) return 0;

  const inputCost = (inputTokens / 1000) * pricing.input;
  const outputCost = (outputTokens / 1000) * pricing.output;
  return inputCost + outputCost;
};

/**
 * Core AI API call with retry logic, rate limiting, and circuit breaker
 */
const callAIForContent = async (prompt, aiSettings = {}, options = {}) => {
  // Validate API key first
  if (!AI_CONFIG.OPENAI_API_KEY || AI_CONFIG.OPENAI_API_KEY.trim() === "") {
    throw new Error(
      "OpenAI API key not configured. Please set REACT_APP_OPENAI_API_KEY in your .env file. Get your API key from: https://platform.openai.com/account/api-keys",
    );
  }

  const model = options.model || AI_CONFIG.MODELS.GPT4;
  const temperature = aiSettings?.temperature || options.temperature || 0.7;
  const maxTokens = options.maxTokens || 1000;
  const useJsonMode = options.jsonMode || false;

  let attempt = 0;
  let lastError = null;

  while (attempt < AI_CONFIG.MAX_RETRIES) {
    attempt++;

    try {
      const result = await apiCircuitBreaker.execute(async () => {
        return await openAIRateLimiter.enqueue(async () => {
          const requestBody = {
            model: model,
            messages: [
              {
                role: "system",
                content:
                  "You are an expert tourism marketing copywriter specializing in creating compelling landing pages that convert visitors into customers.",
              },
              {
                role: "user",
                content: prompt,
              },
            ],
            temperature: temperature,
            max_tokens: maxTokens,
          };

          // Enable JSON mode if requested (GPT-4 only)
          if (useJsonMode && model.includes("gpt-4")) {
            requestBody.response_format = { type: "json_object" };
          }

          console.log(
            `[AI] Calling ${model} (attempt ${attempt}/${AI_CONFIG.MAX_RETRIES})`,
          );

          const response = await fetch(AI_CONFIG.ENDPOINT, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${AI_CONFIG.OPENAI_API_KEY}`,
            },
            body: JSON.stringify(requestBody),
          });

          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
              `OpenAI API error ${response.status}: ${
                errorData.error?.message || response.statusText
              }`,
            );
          }

          const data = await response.json();

          // Track usage and cost
          const usage = data.usage || {};
          const cost = calculateCost(
            usage.prompt_tokens || 0,
            usage.completion_tokens || 0,
            model,
          );

          console.log(
            `[AI] Success: ${usage.total_tokens || 0} tokens, $${cost.toFixed(
              4,
            )}`,
          );

          return {
            content: data.choices[0].message.content.trim(),
            usage: usage,
            cost: cost,
            model: model,
          };
        });
      });

      return result;
    } catch (error) {
      lastError = error;
      console.warn(`[AI] Attempt ${attempt} failed:`, error.message);

      // Handle rate limit errors with longer delay
      if (
        error.message.includes("429") ||
        error.message.includes("rate_limit")
      ) {
        const delay = 5000 * attempt; // 5s, 10s, 15s
        console.log(`[AI] Rate limited, waiting ${delay}ms before retry...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
        continue;
      }

      // Exponential backoff for other errors
      if (attempt < AI_CONFIG.MAX_RETRIES) {
        const delay = Math.min(1000 * Math.pow(2, attempt), 10000);
        console.log(`[AI] Waiting ${delay}ms before retry...`);
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  }

  // All retries exhausted
  throw lastError || new Error("AI API call failed after all retries");
};

/**
 * Batch AI Content Generator - Combines multiple content types in one API call
 * Reduces costs by ~80% compared to individual calls
 */
const generateBatchAIContent = async (tour, userID, options = {}) => {
  try {
    // Extract tour context for prompts
    const stopHighlights =
      tour.stops
        ?.slice(0, 6)
        .map((s) => s.s_title || s.stop_name)
        .filter(Boolean)
        .join(", ") || "Multiple fascinating locations";

    const tourTypes = Array.isArray(tour.type)
      ? tour.type.join(", ")
      : tour.type || "Cultural";
    const equipment = Array.isArray(tour.equipment)
      ? tour.equipment.map((e) => e.value || e).join(", ")
      : tour.equipment || "Comfortable shoes";

    const duration = tour.duration || "2-3 hours";
    const difficulty = tour.difficulty || "Easy";
    const location =
      tour.location || tour.generalLocation || "Beautiful destination";
    const language = tour.language || "en";
    const guideName =
      tour.tour_guide?.name ||
      tour.tour_guide?.full_name ||
      "Expert local guide";
    const stopCount = tour.stops?.length || 0;

    // Language detection and mapping
    const languageMap = {
      en: "English",
      he: "Hebrew",
      es: "Spanish",
      fr: "French",
      de: "German",
      it: "Italian",
      pt: "Portuguese",
      ru: "Russian",
      ar: "Arabic",
      zh: "Chinese",
      ja: "Japanese",
      nl: "Dutch",
      sv: "Swedish",
      no: "Norwegian",
      da: "Danish",
      fi: "Finnish",
      pl: "Polish",
      cs: "Czech",
      hu: "Hungarian",
      ro: "Romanian",
      tr: "Turkish",
      el: "Greek",
      ko: "Korean",
      th: "Thai",
      vi: "Vietnamese",
    };
    const targetLanguage = languageMap[language] || language || "English";

    // Create comprehensive batch prompt with JSON structure
    const batchPrompt = `You are a professional tourism marketing copywriter creating a premium, high-converting landing page for a self-guided tour experience.

⚠️ CRITICAL REQUIREMENT: Write ALL content in ${targetLanguage} language. Every single word, sentence, and character must be in ${targetLanguage}. This is non-negotiable.

Tour Information:
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📍 Original Title: ${tour.title}
🌍 Location: ${location}
⏱️ Duration: ${duration}
📊 Difficulty: ${difficulty}
🎭 Tour Type: ${tourTypes}
🗺️ Featured Stops (${stopCount} total): ${stopHighlights}
🎒 Equipment: ${equipment}
👤 Guide: ${guideName}
💰 Price: ${tour.price || options.price || ""}
${tour.main_sentense ? `💡 Current Tagline: ${tour.main_sentense}` : ""}
${
  tour.notes?.length > 0
    ? `📝 Tour Highlights: ${tour.notes
        .slice(0, 2)
        .map((n) => n.question)
        .join(", ")}`
    : ""
}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Your Mission:
Create compelling, professional sales copy that makes visitors excited to book this tour immediately. Use emotional, vivid language and focus on unique transformation and authentic experiences.

Return ONLY valid JSON with this exact structure (ALL text in ${targetLanguage}):

{
  "optimizedTitle": "Create a catchy, SEO-friendly tour title in ${targetLanguage} (40-70 characters). Make it more compelling than the original. Include location and key attraction/theme. Examples: 'Hidden Gems of Ancient Jaffa', 'Secret Food Tour of Tel Aviv', 'Sunset Walk Through Old Jerusalem'. Must be in ${targetLanguage}.",
  
  "salesDescription": "Write 2-3 compelling sentences (280-300 characters) in ${targetLanguage} that capture the magic and essence of this tour. Use vivid, sensory language. Focus on: what makes this tour unique, emotional benefits, transformation travelers will experience, and why they MUST book now. Make it irresistible.",
  
  "htmlHighlights": "Create 5-6 powerful benefit points in ${targetLanguage}. Format: <div><h2 style='margin-bottom:15px;'>[Section Title in ${targetLanguage}]</h2><h3>🎯 [Benefit Title]</h3><p>[2-3 sentences explaining why this matters and what travelers will experience]</p><h3>📍 [Next Benefit]</h3><p>[Description]</p>...[repeat 5-6 times]</div>. Use varied emojis: 🎯 📍 ⭐ 🌟 🎭 🏛️ 🍷 🎨 💡 🚶 🗺️ 📱 ⏰. Focus on: self-paced flexibility, expert curation, hidden local gems, authentic cultural insights, convenience, value for money.",
  
  "guideBio": "Write 2-3 sentences (200-220 characters) in ${targetLanguage} about ${guideName} that establishes trust and credibility. Highlight: expertise in ${tourTypes} tours, deep knowledge of ${location}, passion for sharing culture/history, years of experience, what makes them uniquely qualified. Make it warm, personal, and professional.",
  
  "tourCategories": "List 2-3 precise tour categories in ${targetLanguage}, comma-separated (e.g., 'History, Architecture, Culture' or 'Food, Street Art, Local Life'). Be specific to the tour content. Categories must be in ${targetLanguage}.",
  
  "scheduleInfo": "Write a friendly schedule/timing description in ${targetLanguage} (30-50 characters). Include flexibility emphasis. Examples: 'Start anytime - approximately ${duration}', 'Flexible schedule, ${duration} at your pace', 'Available 24/7 - takes about ${duration}'. Must be in ${targetLanguage}.",
  
  "ageRecommendation": "Provide an appropriate age range for this tour in ${targetLanguage}. Consider difficulty (${difficulty}) and content type (${tourTypes}). Options: 'All ages', '8+', '10-99', '12+', '16+', 'Adults only (18+)', 'Family-friendly (6+)'. If in doubt, use '10-99'. Answer in ${targetLanguage}.",
  
  "priceDisplay": "Create an appealing price display text in ${targetLanguage} (10-20 characters). Make it feel like a good deal. Include currency symbol. Examples: '${
      tour.price || "25"
    }$ per person', 'From ${tour.price || "20"}€', 'Only ${
      tour.price || "30"
    }$', 'Just ${tour.price || "25"}USD'. Must be in ${targetLanguage}.",
  
  "faqSection": "Create 4-5 practical FAQ items in ${targetLanguage}. Format: <div><h3>[Question in ${targetLanguage}]?</h3><p>[Helpful, friendly answer that addresses concerns]</p><h3>[Next Question]?</h3><p>[Answer]</p>...[repeat 4-5 times]</div>. Cover these topics: What's included in the tour?, How long does it take?, Is it suitable for families/children?, What if weather is bad?, Can I go at my own pace?, When is the best time to start?, Do I need to book in advance?",
  
  "pricingJustification": "Write 2 sentences (140-160 characters) in ${targetLanguage} explaining why this tour offers exceptional value for money. Mention: ${stopCount} carefully curated stops, quality of expert content, flexibility to explore at own pace, hours of rich local insights included, compared to traditional guided tours."
}

Quality Standards (Critical):
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
✅ Use professional marketing copywriting language (not generic tourism brochure text)
✅ Create urgency and FOMO (fear of missing out)
✅ Be specific - mention actual stop names: ${stopHighlights}
✅ Use sensory, emotional language (what they'll see, hear, discover, feel)
✅ Emphasize self-paced flexibility as major competitive advantage
✅ Focus on transformation and authentic local experiences
✅ Use action-oriented language that motivates booking
✅ Address common objections and concerns in FAQ
✅ Make optimizedTitle more catchy and compelling than original
✅ ALL content MUST be in ${targetLanguage} - this is absolutely critical!
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

Remember: Write EVERYTHING in ${targetLanguage}. Return ONLY the JSON object, no markdown formatting, no code blocks, no explanations.`;

    console.log("[Batch AI] Generating all content in one call...");

    // Estimate cost before calling
    const estimatedInputTokens = estimateTokens(batchPrompt);
    const estimatedOutputTokens = 800; // Conservative estimate
    const estimatedCost = calculateCost(
      estimatedInputTokens,
      estimatedOutputTokens,
      AI_CONFIG.MODELS.GPT4,
    );

    console.log(
      `[Batch AI] Estimated cost: $${estimatedCost.toFixed(4)} (GPT-4)`,
    );

    if (options.progressCallback) {
      options.progressCallback({
        stage: "ai_generation",
        message: "Generating sales content with AI (GPT-4)...",
        estimatedCost: estimatedCost,
      });
    }

    // Get AI settings
    const aiSettings = await getAISettings(userID).catch(() => ({}));

    // Call AI with JSON mode
    const result = await callAIForContent(batchPrompt, aiSettings, {
      model: AI_CONFIG.MODELS.GPT4,
      temperature: 0.7,
      maxTokens: 1500,
      jsonMode: true,
    });

    // Parse JSON response
    let content;
    try {
      content = JSON.parse(result.content);
    } catch (parseError) {
      console.error(
        "[Batch AI] Failed to parse JSON response:",
        result.content,
      );
      throw new Error("Invalid JSON response from AI");
    }

    // Validate required fields
    const requiredFields = [
      "optimizedTitle",
      "salesDescription",
      "htmlHighlights",
      "guideBio",
      "tourCategories",
      "scheduleInfo",
      "ageRecommendation",
      "priceDisplay",
      "faqSection",
      "pricingJustification",
    ];
    const missingFields = requiredFields.filter((field) => !content[field]);

    if (missingFields.length > 0) {
      console.warn("[Batch AI] Missing fields:", missingFields);
      throw new Error(`Missing required fields: ${missingFields.join(", ")}`);
    }

    console.log(`[Batch AI] Success! Actual cost: $${result.cost.toFixed(4)}`);
    console.log(
      `[Batch AI] Generated fields:`,
      Object.keys(content).join(", "),
    );

    if (options.progressCallback) {
      options.progressCallback({
        stage: "ai_complete",
        message: "AI content generated successfully",
        actualCost: result.cost,
        model: result.model,
        tokens: result.usage.total_tokens,
      });
    }

    return {
      ...content,
      metadata: {
        model: result.model,
        cost: result.cost,
        usage: result.usage,
        timestamp: new Date().toISOString(),
      },
    };
  } catch (error) {
    console.error("[Batch AI] Batch generation failed:", error.message);

    // Try GPT-3.5 fallback
    console.log("[Batch AI] Attempting GPT-3.5 fallback...");

    try {
      if (options.progressCallback) {
        options.progressCallback({
          stage: "ai_fallback",
          message: "Retrying with GPT-3.5 (more affordable)...",
        });
      }

      const aiSettings = await getAISettings(userID).catch(() => ({}));

      // Language detection for fallback
      const languageMap = {
        en: "English",
        he: "Hebrew",
        es: "Spanish",
        fr: "French",
        de: "German",
        it: "Italian",
        pt: "Portuguese",
        ru: "Russian",
        ar: "Arabic",
        zh: "Chinese",
        ja: "Japanese",
      };
      const targetLanguage =
        languageMap[tour.language] || tour.language || "English";
      const stopCount = tour.stops?.length || 0;

      // Retry with GPT-3.5 (no JSON mode for 3.5)
      const fallbackPrompt = `You are a professional tourism marketing copywriter. Write ALL content in ${targetLanguage} language.

Tour Information:
- Title: ${tour.title}
- Location: ${tour.location || tour.generalLocation || "Beautiful destination"}
- Duration: ${tour.duration || "2-3 hours"}
- Type: ${
        Array.isArray(tour.type)
          ? tour.type.join(", ")
          : tour.type || "Cultural"
      }
- Stops: ${stopCount}

Write in ${targetLanguage}. Provide exactly 5 sections separated by "---":

1. Sales Description (2-3 compelling sentences in ${targetLanguage}, 280-300 chars, emotional and persuasive)
2. HTML Highlights (5-6 bullet points with emojis in ${targetLanguage}, full HTML with <div><h2>...</h2><h3>🎯 ...</h3><p>...</p>...</div>)
3. Guide Bio (2-3 sentences in ${targetLanguage}, 200 chars, builds trust)
4. FAQ Section (4 Q&A in ${targetLanguage}, full HTML with <div><h3>Question?</h3><p>Answer</p>...</div>)
5. Pricing Justification (2 sentences in ${targetLanguage}, 150 chars, emphasizes value)

CRITICAL: All text must be in ${targetLanguage}.`;

      const fallbackResult = await callAIForContent(
        fallbackPrompt,
        aiSettings,
        {
          model: AI_CONFIG.MODELS.GPT35,
          temperature: 0.7,
          maxTokens: 1500,
          jsonMode: false,
        },
      );

      // Parse text response
      const sections = fallbackResult.content.split("---").map((s) => s.trim());

      if (sections.length < 5) {
        throw new Error("Incomplete GPT-3.5 response");
      }

      console.log(
        `[Batch AI] GPT-3.5 fallback successful! Cost: $${fallbackResult.cost.toFixed(
          4,
        )}`,
      );

      return {
        salesDescription: sections[0],
        htmlHighlights: sections[1],
        guideBio: sections[2],
        faqSection: sections[3],
        pricingJustification: sections[4],
        metadata: {
          model: fallbackResult.model,
          cost: fallbackResult.cost,
          usage: fallbackResult.usage,
          timestamp: new Date().toISOString(),
          fallback: true,
        },
      };
    } catch (fallbackError) {
      console.error(
        "[Batch AI] GPT-3.5 fallback also failed:",
        fallbackError.message,
      );
      throw error; // Throw original error
    }
  }
};

/**
 * Helper: Generate AI sales-optimized tour description
 * Fallback to tour's existing description if AI fails
 */
const generateSalesDescription = async (tour, userID) => {
  try {
    const stopHighlights = tour.stops
      ?.slice(0, 5)
      .map((s) => s.s_title || s.stop_name)
      .filter(Boolean)
      .join(", ");

    const tourTypes = Array.isArray(tour.type)
      ? tour.type.join(", ")
      : tour.type;
    const equipment = Array.isArray(tour.equipment)
      ? tour.equipment.map((e) => e.value || e).join(", ")
      : tour.equipment;

    const prompt = `Create a compelling 2-3 sentence sales description for a tour landing page. Max 300 characters.

Tour Details:
- Title: ${tour.title}
- Location: ${tour.location || tour.generalLocation || "N/A"}
- Type: ${tourTypes || "N/A"}
- Duration: ${tour.duration || "N/A"}
- Difficulty: ${tour.difficulty || "N/A"}
- Key Stops: ${stopHighlights || "Multiple locations"}
- Equipment: ${equipment || "N/A"}
- Guide: ${
      tour.tour_guide?.name || tour.tour_guide?.full_name || "Expert guide"
    }
${tour.main_sentense ? `- Current tagline: ${tour.main_sentense}` : ""}

Requirements:
- Make it emotional, benefit-driven, and persuasive
- Focus on unique experiences and what travelers will feel and discover
- Use active language that creates urgency and excitement
- Keep under 300 characters
- Return ONLY the description, no explanations`;

    const aiSettings = await getAISettings(userID).catch(() => ({}));

    const result = await callAIForContent(prompt, aiSettings, {
      model: AI_CONFIG.MODELS.GPT4,
      temperature: 0.8,
      maxTokens: 200,
    });

    if (result.content && result.content.trim()) {
      console.log(
        `AI-generated sales description created ($${result.cost.toFixed(4)})`,
      );
      return result.content;
    }

    throw new Error("AI response empty");
  } catch (error) {
    console.warn(
      "AI sales description generation failed, using fallback:",
      error.message,
    );

    // Fallback: Use tour's main_sentense or construct from title
    if (tour.main_sentense) {
      return tour.main_sentense;
    }

    const stopCount = tour.stops?.length || "multiple";
    const location =
      tour.location || tour.generalLocation || "amazing destinations";

    return `Discover ${tour.title} at your own pace. An unforgettable self-guided experience featuring ${stopCount} carefully curated stops in ${location}, offering rich insights and local expertise to make your journey truly memorable.`;
  }
};

/**
 * Helper: Generate AI "Why You'll Love This" HTML highlights
 * Fallback to tour notes if AI fails
 */
const generateHTMLHighlights = async (tour, userID) => {
  try {
    const stopsInfo =
      tour.stops
        ?.slice(0, 6)
        .map((stop) => stop.s_title || stop.stop_name)
        .filter(Boolean)
        .join(", ") || "Multiple fascinating locations";

    const tourTypes = Array.isArray(tour.type)
      ? tour.type.join(", ")
      : tour.type || "Cultural";
    const difficulty = tour.difficulty || "Easy";
    const equipment = Array.isArray(tour.equipment)
      ? tour.equipment.map((e) => e.value || e).join(", ")
      : tour.equipment || "Basic items";

    const prompt = `Create 4-6 compelling "Why You'll Love This Tour" bullet points for a landing page.

Tour Details:
- Title: ${tour.title}
- Location: ${tour.location || tour.generalLocation || "N/A"}
- Key Stops: ${stopsInfo}
- Duration: ${tour.duration || "N/A"}
- Difficulty: ${difficulty}
- Type: ${tourTypes}
- Equipment needed: ${equipment}
- Number of stops: ${tour.stops?.length || 0}

Format requirements:
<div><h2 style="margin-bottom:15px;">Why You'll Love This Tour</h2>
<h3>🎯 Benefit Title</h3>
<p>Compelling description (2-3 sentences)...</p>
<h3>📍 Another Benefit</h3>
<p>Description...</p>
...(4-6 total benefits)
</div>

Use varied emojis: 🎯 📍 ⭐ 🌟 🎭 🏛️ 🍷 🎨 💡 🚶
Focus on: emotional benefits, unique experiences, flexibility, self-paced nature, value, local insights.
Make it persuasive and engaging. Return ONLY the HTML.`;

    const aiSettings = await getAISettings(userID).catch(() => ({}));

    const result = await callAIForContent(prompt, aiSettings, {
      model: AI_CONFIG.MODELS.GPT4,
      temperature: 0.8,
      maxTokens: 600,
    });

    if (result.content && result.content.trim()) {
      console.log(
        `AI-generated HTML highlights created ($${result.cost.toFixed(4)})`,
      );
      return result.content;
    }

    throw new Error("AI response empty");
  } catch (error) {
    console.warn(
      "AI HTML highlights generation failed, using fallback:",
      error.message,
    );

    // Fallback: Use tour notes or generate from stops
    if (tour.notes && tour.notes.length > 0) {
      let htmlString = `<div><h2 style="margin-bottom:15px;">What Awaits You on the Route?</h2>`;
      tour.notes.forEach((item) => {
        htmlString += `<h3>${item.question}</h3><p>${item.answer}</p>`;
      });
      htmlString += "</div>";
      return htmlString;
    }

    // Generate from stops
    let htmlString = `<div><h2 style="margin-bottom:15px;">Experience the Journey</h2>`;
    if (tour.stops && tour.stops.length > 0) {
      tour.stops.slice(0, 6).forEach((stop, idx) => {
        htmlString += `<h3>📍 ${
          stop.s_title || stop.stop_name || `Stop ${idx + 1}`
        }</h3>`;
        htmlString += `<p>${
          stop.s_description ||
          "Discover this fascinating location on your tour."
        }</p>`;
      });
    } else {
      htmlString += `<p>Explore multiple carefully selected locations, each offering unique insights and unforgettable experiences.</p>`;
    }
    htmlString += "</div>";
    return htmlString;
  }
};

/**
 * Helper: Generate AI guide bio for trust-building
 * Fallback to basic guide info if AI fails
 */
const generateGuideBio = async (tour, userID) => {
  try {
    const guideName =
      tour.tour_guide?.name || tour.tour_guide?.full_name || "Expert Guide";
    const location = tour.location || tour.generalLocation || "N/A";
    const tourTypes = Array.isArray(tour.type)
      ? tour.type.join(", ")
      : tour.type || "Cultural";

    const prompt = `Create a compelling 2-3 sentence guide bio for a tour landing page. Keep it 150-200 characters.

Guide Details:
- Name: ${guideName}
- Tour Title: ${tour.title}
- Location: ${location}
- Language: ${tour.language || "N/A"}
- Tour Type: ${tourTypes}
- Specialization: ${tourTypes} tours in ${location}

Requirements:
- Make it trustworthy, professional, and warm
- Highlight expertise, passion, and local knowledge
- Build credibility and emotional connection
- Focus on what makes this guide unique
- Keep under 200 characters
- Return ONLY the bio text`;

    const aiSettings = await getAISettings(userID).catch(() => ({}));

    const result = await callAIForContent(prompt, aiSettings, {
      model: AI_CONFIG.MODELS.GPT4,
      temperature: 0.7,
      maxTokens: 150,
    });

    if (result.content && result.content.trim()) {
      console.log(
        `AI-generated guide bio created ($${result.cost.toFixed(4)})`,
      );
      return result.content;
    }

    throw new Error("AI response empty");
  } catch (error) {
    console.warn(
      "AI guide bio generation failed, using fallback:",
      error.message,
    );

    // Fallback: Construct from available guide data
    const guideName =
      tour.tour_guide?.name ||
      tour.tour_guide?.full_name ||
      "Your Expert Guide";
    const location = tour.location || tour.generalLocation || "this region";
    const tourType = Array.isArray(tour.type)
      ? tour.type[0]
      : tour.type || "cultural";

    return `${guideName} is a passionate local expert specializing in ${tourType.toLowerCase()} experiences in ${location}. With years of experience crafting unforgettable tours, they bring history, culture, and hidden gems to life through engaging storytelling and authentic insights.`;
  }
};

/**
 * Main function: Create selling web tour with AI-enhanced content
 * Uses actual tour images and AI-generated sales copy
 */
export const createSellingWebTourUsingAI = function (tour, options = {}) {
  return new Promise(async function (myResolve, myReject) {
    try {
      console.log("Starting AI-enhanced web tour creation...", tour.id);
      console.log("Options:", options);

      // Check if web_tour document already exists
      const tourDoc = await firebase
        .firestore()
        .collection("web_tour")
        .doc(tour.id)
        .get();

      if (tourDoc.exists && !options.overwrite) {
        console.log("tourDoc.exists", tourDoc.data());
        return myResolve({
          success: false,
          message:
            "Document with this tourID already exists. Use overwrite option to replace.",
          tourId: tour.id,
        });
      }

      // Validate required fields
      const warnings = [];
      if (!tour.title) warnings.push("Missing tour title");
      if (!tour.tour_guide?.name && !tour.tour_guide?.full_name)
        warnings.push("Missing guide name");
      if (!tour.tour_guide?.id) warnings.push("Missing guide ID");

      // Collect images from tour
      const collectedImages = collectTourImages(tour);
      if (collectedImages.length === 0) {
        return myReject(
          "No images found in tour. At least 1 image is required.",
        );
      }

      // Build stop locations array
      let stopLocations = [];
      if (tour.stops && Array.isArray(tour.stops)) {
        tour.stops.forEach((stop) => {
          if (stop.stop_location) {
            stopLocations.push({
              lat: stop.stop_location.latitude,
              lng: stop.stop_location.longitude,
            });
          }
        });
      }

      // Initialize progress tracking
      const userID = tour.tour_guide?.id;
      let totalCost = 0;
      let aiEnhanced = {
        batchGeneration: false,
        title: false,
        description: false,
        highlights: false,
        bio: false,
        categories: false,
        schedule: false,
        ageRange: false,
        priceText: false,
        faq: false,
        pricing: false,
      };

      let optimizedTitle,
        salesDescription,
        htmlHighlights,
        guideBio,
        tourCategories,
        scheduleInfo,
        ageRecommendation,
        priceDisplay,
        faqSection,
        pricingJustification;

      // Try batch generation first (most efficient)
      if (options.useBatchAI !== false) {
        console.log("[Web Tour] Attempting batch AI generation...");

        try {
          const batchResult = await generateBatchAIContent(tour, userID, {
            progressCallback: options.progressCallback,
          });

          optimizedTitle = batchResult.optimizedTitle;
          salesDescription = batchResult.salesDescription;
          htmlHighlights = batchResult.htmlHighlights;
          guideBio = batchResult.guideBio;
          tourCategories = batchResult.tourCategories;
          scheduleInfo = batchResult.scheduleInfo;
          ageRecommendation = batchResult.ageRecommendation;
          priceDisplay = batchResult.priceDisplay;
          faqSection = batchResult.faqSection;
          pricingJustification = batchResult.pricingJustification;

          totalCost = batchResult.metadata.cost;
          aiEnhanced = {
            batchGeneration: true,
            title: true,
            description: true,
            highlights: true,
            bio: true,
            categories: true,
            schedule: true,
            ageRange: true,
            priceText: true,
            faq: true,
            pricing: true,
          };

          console.log(
            `[Web Tour] Batch AI generation successful! Cost: $${totalCost.toFixed(
              4,
            )}`,
          );
          console.log(`[Web Tour] Generated title: "${optimizedTitle}"`);
        } catch (batchError) {
          console.warn(
            "[Web Tour] Batch AI failed, falling back to individual calls:",
            batchError.message,
          );

          // Fallback: Individual AI calls
          const individualResults = await Promise.allSettled([
            generateSalesDescription(tour, userID),
            generateHTMLHighlights(tour, userID),
            generateGuideBio(tour, userID),
          ]);

          salesDescription =
            individualResults[0].status === "fulfilled"
              ? individualResults[0].value
              : generateSalesDescription(tour, userID); // Force fallback

          htmlHighlights =
            individualResults[1].status === "fulfilled"
              ? individualResults[1].value
              : generateHTMLHighlights(tour, userID);

          guideBio =
            individualResults[2].status === "fulfilled"
              ? individualResults[2].value
              : generateGuideBio(tour, userID);

          // Generate basic fallback values for missing fields
          optimizedTitle = tour.title; // Keep original
          tourCategories = Array.isArray(tour.type)
            ? tour.type.join(", ")
            : tour.type || "Cultural";
          scheduleInfo = `Flexible schedule - approximately ${
            tour.duration || "2-3 hours"
          }`;
          ageRecommendation = "10-99";
          priceDisplay = `${tour.price || options.price || "25"}$`;

          // Generate basic FAQ from tour notes
          faqSection =
            tour.notes && tour.notes.length > 0
              ? `<div>${tour.notes
                  .map(
                    (note) => `<h3>${note.question}</h3><p>${note.answer}</p>`,
                  )
                  .join("")}</div>`
              : `<div><h3>What's included?</h3><p>Self-guided tour with ${
                  tour.stops?.length || "multiple"
                } stops, audio narration, and detailed information at each location.</p><h3>How long does it take?</h3><p>Approximately ${
                  tour.duration || "2-3 hours"
                }, but you can go at your own pace.</p></div>`;

          pricingJustification = `Experience ${
            tour.stops?.length || "multiple"
          } curated stops with expert insights, all at your own pace. Great value for a comprehensive ${
            tour.location || "local"
          } experience.`;

          aiEnhanced.description = individualResults[0].status === "fulfilled";
          aiEnhanced.highlights = individualResults[1].status === "fulfilled";
          aiEnhanced.bio = individualResults[2].status === "fulfilled";

          console.log("[Web Tour] Individual fallback complete");
        }
      } else {
        // Manual mode: No AI, use fallbacks only
        console.log("[Web Tour] AI disabled, using template content");

        optimizedTitle = tour.title;
        salesDescription =
          tour.main_sentense || `Discover ${tour.title} at your own pace.`;
        htmlHighlights = generateHTMLHighlights(tour, userID); // Will use fallback
        guideBio = generateGuideBio(tour, userID); // Will use fallback
        tourCategories = Array.isArray(tour.type)
          ? tour.type.join(", ")
          : tour.type || "Cultural";
        scheduleInfo = `Flexible schedule - approximately ${
          tour.duration || "2-3 hours"
        }`;
        ageRecommendation = "10-99";
        priceDisplay = `${tour.price || options.price || "25"}$`;
        faqSection = `<div><h3>What's included?</h3><p>Self-guided tour with detailed information.</p></div>`;
        pricingJustification = `Great value for exploring ${
          tour.location || "the area"
        }.`;
      }

      // Build tourImagesArray from collected images
      const tourImagesArray = collectedImages.map((img, idx) => ({
        file: [],
        name: img.name,
        url: img.url,
      }));

      // Get main tour image (first collected image)
      const mainImageUrl = collectedImages[0]?.url || "";

      // Get guide profile image
      const guideProfileImg = tour.tour_guide?.profile_image || "";

      // Handle testimonials/recommendations
      let recommendations = [];
      const generateFakeReviews = options.generateFakeReviews === true; // Default false

      if (generateFakeReviews) {
        console.log(
          "[Web Tour] Generating placeholder testimonials (generateFakeReviews=true)",
        );
        // Basic placeholder testimonials
        recommendations = [
          {
            imageFile: [],
            recImg: "",
            recommendantName: "Travel Enthusiast",
            stars: "5",
            tourRecommendant:
              "Amazing self-guided experience! The content was informative and easy to follow.",
          },
          {
            imageFile: [],
            recImg: "",
            recommendantName: "Local Explorer",
            stars: "5",
            tourRecommendant:
              "Loved the flexibility to go at my own pace. Highly recommend!",
          },
        ];
      } else {
        console.log(
          "[Web Tour] No testimonials generated (generateFakeReviews=false, ethical default)",
        );
        // Empty array - to be populated with real reviews later
        recommendations = [];
      }

      // Default color themes (fallback if not provided)
      const defaultColorThemes = {
        blue: {
          name: "Ocean Blue",
          category: "Classic",
          primaryColor: "#5cc1eb",
          iconColor: "#5cc1eb",
          heroGradient: "linear-gradient(250deg, #71daf0, #5cc1eb, #2177E4)",
          accentColor: "#71daf0",
          brandGradient: "linear-gradient(250deg, #71daf0, #5cc1eb, #2177E4)",
          buttonSecondary: "#2177E4",
          secondaryColor: "#2177E4",
          sectionBackground: "#f8fafc",
          featureBackground: "#f0f9ff",
          buttonPrimary: "#5cc1eb",
        },
        red: {
          name: "Vibrant Red",
          category: "Bold",
          primaryColor: "#dc2626",
          iconColor: "#dc2626",
          heroGradient: "linear-gradient(250deg, #fee2e2, #dc2626, #991b1b)",
          accentColor: "#ef4444",
          brandGradient: "linear-gradient(250deg, #fca5a5, #dc2626, #991b1b)",
          buttonSecondary: "#374151",
          secondaryColor: "#991b1b",
          sectionBackground: "#f8fafc",
          featureBackground: "#fef2f2",
          buttonPrimary: "#dc2626",
        },
        green: {
          name: "Nature Green",
          category: "Fresh",
          primaryColor: "#10b981",
          iconColor: "#10b981",
          heroGradient: "linear-gradient(250deg, #d1fae5, #10b981, #047857)",
          accentColor: "#34d399",
          brandGradient: "linear-gradient(250deg, #6ee7b7, #10b981, #047857)",
          buttonSecondary: "#374151",
          secondaryColor: "#047857",
          sectionBackground: "#f8fafc",
          featureBackground: "#ecfdf5",
          buttonPrimary: "#10b981",
        },
      };

      // Get color theme from options or use default
      const selectedColor = options.color || tour.color || "blue";
      const colorTheme =
        options.colorTheme ||
        tour.colorTheme ||
        defaultColorThemes[selectedColor] ||
        defaultColorThemes.blue;

      // Build theme object (separate from colorTheme for compatibility)
      const theme = options.theme || {
        primaryColor: colorTheme.primaryColor,
        secondaryColor: colorTheme.secondaryColor,
        accentColor: colorTheme.accentColor,
        buttonPrimary: colorTheme.buttonPrimary,
        buttonSecondary: colorTheme.buttonSecondary,
        heroGradient: colorTheme.heroGradient,
        brandGradient: colorTheme.brandGradient,
        sectionBackground: colorTheme.sectionBackground,
        featureBackground: colorTheme.featureBackground,
        iconColor: colorTheme.iconColor,
      };

      // Build new web_tour object with enhanced schema
      const newObj = {
        // Required fields (AI-ENHANCED)
        title: optimizedTitle || tour.title, // Use AI-optimized title if available
        tourdescription: salesDescription,
        tourImageInput: {
          file: [],
          url: mainImageUrl,
        },
        guideName:
          tour.tour_guide?.name || tour.tour_guide?.full_name || "Guide Name",
        guideDescription: guideBio,
        price: tour.price || options.price || "20",
        clientid: options.clientid || tour.clientid || "", // PayPal client ID

        // Optional fields with defaults
        language: tour.language || "en",
        paymentcurrency: options.currency || "USD",
        period: options.period || "30 days",
        discount: options.discount !== undefined ? options.discount : 0,

        // Color theming (both formats for compatibility)
        color: selectedColor,
        colorTheme: colorTheme,
        theme: theme,

        // Additional tour info
        gid: tour.tour_guide?.id,
        tourImagesArray: tourImagesArray,
        tourLocations: stopLocations,
        HTMLtext: htmlHighlights,

        // NEW: AI-generated content
        faqSection: faqSection,
        pricingJustification: pricingJustification,

        // Guide info
        guideProfileImgInput: {
          file: [],
          url: guideProfileImg,
        },
        logoImageInput: {
          file: [],
          url: guideProfileImg,
        },

        // AI-ENHANCED FIELDS (use AI-generated values when available)
        duration: tour.duration || "",
        distance: tour.distance || "",
        tourLocactionP: tour.location || tour.generalLocation || "",
        tourTypeP:
          tourCategories ||
          (Array.isArray(tour.type) ? tour.type.join(", ") : tour.type || ""),
        tourPriceP: priceDisplay || `${tour.price || options.price || "20"}$`,
        tourTimeInfoP: scheduleInfo || options.tourTime || "",
        tourAgeGroupP: ageRecommendation || options.ageGroup || "10-99",

        // Video content
        tourVidInput: {
          file: [],
          url: tour.starting_video || "",
        },

        // Testimonials
        recommendations: recommendations,

        // Contact
        contactNumber: options.contactNumber || tour.tour_guide?.phone || "",

        // Enhanced metadata
        createdAt: new Date().toISOString(),
        generationMethod: "ai_enhanced",
        aiEnhanced: aiEnhanced,
        aiCost: totalCost,
        imagesCollected: collectedImages.length,
        generationOptions: {
          useBatchAI: options.useBatchAI !== false,
          generateFakeReviews: generateFakeReviews,
          overwrite: options.overwrite || false,
        },
      };

      console.log("Creating AI-enhanced web_tour document:", {
        tourId: tour.id,
        originalTitle: tour.title,
        optimizedTitle:
          optimizedTitle !== tour.title ? optimizedTitle : "(same)",
        imagesCollected: collectedImages.length,
        aiEnhanced: aiEnhanced,
        totalCost: `$${totalCost.toFixed(4)}`,
        generateFakeReviews: generateFakeReviews,
        warnings: warnings,
      });

      if (options.progressCallback) {
        options.progressCallback({
          stage: "saving",
          message: "Saving web tour to database...",
        });
      }

      // Save to Firestore
      await firebase
        .firestore()
        .collection("web_tour")
        .doc(tour.id)
        .set(newObj);

      console.log("[Web Tour] Successfully saved to Firestore");

      if (options.progressCallback) {
        options.progressCallback({
          stage: "complete",
          message: "Web tour created successfully!",
        });
      }

      myResolve({
        success: true,
        message: "AI-enhanced web tour created successfully",
        tourId: tour.id,
        imagesCollected: collectedImages.length,
        aiEnhanced: aiEnhanced,
        totalCost: totalCost,
        costBreakdown: {
          estimated: `$${totalCost.toFixed(4)}`,
          model: aiEnhanced.batchGeneration
            ? "GPT-4 (batch)"
            : "GPT-4 (individual)",
        },
        warnings: warnings.length > 0 ? warnings : undefined,
        url: `https://yourapp.com/tour/${tour.id}`,
      });
    } catch (error) {
      console.error("Error in createSellingWebTourUsingAI:", error);
      myReject(error);
    }
  });
};

export const getDguideUserByID = function (userID) {
  return new Promise(function (myResolve, myReject) {
    //firebase.firestore().collection("saasUsers").doc(`${userID}`).get().then((snapshot) => {
    firebase
      .firestore()
      .collection("users")
      .doc(`${userID}`)
      .get()
      .then((snapshot) => {
        myResolve(snapshot.data());
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

// ==================== TOUR EXPORT & BACKUP FUNCTIONS ====================

/**
 * Get or generate user's export password
 * Password format: First 6 chars of UID (uppercase) + First 2 chars of display name (uppercase)
 * Example: "ABC123JO" for user with UID starting "abc123..." and name "John"
 *
 * @param {string} userID - User's Firebase UID
 * @returns {Promise<{password: string, isNew: boolean}>} Password and whether it was newly generated
 */
export const getUserExportPassword = function (userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      // Fetch user document from saasCustomers
      const userDoc = await firebase
        .firestore()
        .collection("saasCustomers")
        .doc(userID)
        .get();

      if (!userDoc.exists) {
        myReject("User not found");
        return;
      }

      const userData = userDoc.data();

      // Check if password already exists
      if (userData.exportPassword) {
        myResolve({ password: userData.exportPassword, isNew: false });
        return;
      }

      // Generate new password: UID prefix (6 chars) + Name initials (2 chars)
      const uidPrefix = userID.substring(0, 6).toUpperCase();
      const displayName =
        userData.displayName || userData.full_name || userData.email || "USER";
      const nameInitials = displayName.substring(0, 2).toUpperCase();
      const newPassword = uidPrefix + nameInitials;

      // Save password to Firestore
      await firebase
        .firestore()
        .collection("saasCustomers")
        .doc(userID)
        .set({ exportPassword: newPassword }, { merge: true });

      console.log(`Generated new export password for user ${userID}`);
      myResolve({ password: newPassword, isNew: true });
    } catch (error) {
      console.error("Error getting export password:", error);
      myReject(error);
    }
  });
};

/**
 * Sanitize tour data for text export (shallow backup)
 * Excludes: GPS coordinates, duration, equipment, language, difficulty, config,
 * stop types, media types/order, technical IDs, URLs, timestamps
 *
 * @param {Object} tour - Full tour object
 * @returns {string} Formatted text content
 */
export const sanitizeTourForTextExport = function (tour) {
  try {
    let textContent = "";
    const separator = "=".repeat(60);

    // Tour header
    textContent += `${separator}\n`;
    textContent += `TOUR CONTENT BACKUP\n`;
    textContent += `${separator}\n\n`;

    // Basic tour info
    textContent += `TOUR TITLE: ${tour.title || "Untitled Tour"}\n\n`;

    if (tour.main_sentense) {
      textContent += `DESCRIPTION:\n${tour.main_sentense}\n\n`;
    }

    if (tour.generalLocation || tour.location) {
      textContent += `LOCATION: ${tour.generalLocation || tour.location}\n\n`;
    }

    // Guide information (name only, no contact info)
    if (tour.tour_guide) {
      textContent += `GUIDE: ${
        tour.tour_guide.name || tour.tour_guide.full_name || "N/A"
      }\n\n`;
    }

    // Tour notes/highlights
    if (tour.notes && tour.notes.length > 0) {
      textContent += `${separator}\n`;
      textContent += `TOUR HIGHLIGHTS\n`;
      textContent += `${separator}\n\n`;
      tour.notes.forEach((note, idx) => {
        textContent += `${idx + 1}. ${note.question || "Highlight"}\n`;
        if (note.answer) {
          textContent += `   ${note.answer}\n`;
        }
        textContent += `\n`;
      });
    }

    // Stops (without coordinates or technical details)
    if (tour.stops && tour.stops.length > 0) {
      textContent += `${separator}\n`;
      textContent += `TOUR STOPS (${tour.stops.length} stops)\n`;
      textContent += `${separator}\n\n`;

      tour.stops.forEach((stop, idx) => {
        textContent += `STOP ${idx + 1}: ${
          stop.s_title || stop.stop_name || "Unnamed Stop"
        }\n`;
        textContent += `${"-".repeat(40)}\n`;

        // Location (hidden for content backup)
        if (stop.stop_location) {
          textContent += `Location: [GPS coordinates included]\n`;
        }

        if (stop.slider_item_title) {
          textContent += `Subtitle: ${stop.slider_item_title}\n`;
        }

        if (stop.s_smallDesc) {
          textContent += `Brief Description: ${stop.s_smallDesc}\n`;
        }

        if (stop.s_description) {
          textContent += `\nDescription:\n${stop.s_description}\n`;
        }

        if (stop.direction_text) {
          textContent += `\nDirections:\n${stop.direction_text}\n`;
        }

        if (stop.tags && stop.tags.length > 0) {
          // Handle tags that might be strings or objects
          const tagStrings = stop.tags.map((tag) => {
            if (typeof tag === "string") {
              return tag;
            } else if (tag && typeof tag === "object") {
              // Extract value or label property, or stringify
              return tag.value || tag.label || tag.name || JSON.stringify(tag);
            }
            return String(tag);
          });
          textContent += `\nTags: ${tagStrings.join(", ")}\n`;
        }

        // Location pictures
        if (stop.loc_pics && stop.loc_pics.length > 0) {
          textContent += `\nLocation Images: ${stop.loc_pics.length} image(s) included\n`;
          stop.loc_pics.forEach((pic, picIdx) => {
            const picName =
              pic.name || pic.fileName || pic.title || `Image ${picIdx + 1}`;
            textContent += `  ${picIdx + 1}. ${picName}\n`;
          });
        }

        // Media content (text only, no URLs or types)
        if (stop.all_media && stop.all_media.length > 0) {
          textContent += `\nMedia Content:\n`;
          stop.all_media.forEach((media, mIdx) => {
            // Skip if no meaningful content
            if (
              !media.title &&
              !media.text &&
              !media.content &&
              !media.html_text &&
              !media.question &&
              !media.question_text &&
              media.type !== "image" &&
              media.type !== "video" &&
              media.type !== "audio"
            ) {
              return;
            }

            // Media type indicator
            const typeEmoji = {
              text: "📝",
              html: "📄",
              image: "🖼️",
              video: "🎥",
              audio: "🎵",
              question: "❓",
            };
            const emoji = typeEmoji[media.type] || "•";

            // Title with type
            if (media.title) {
              textContent += `\n  ${emoji} ${media.title}\n`;
            } else if (media.type) {
              textContent += `\n  ${emoji} ${
                media.type.charAt(0).toUpperCase() + media.type.slice(1)
              }\n`;
            }

            // Text content (for text type)
            if (media.type === "text" && media.content) {
              textContent += `  ${media.content}\n`;
            }

            // HTML content (strip tags and clean markdown)
            if (media.type === "html" && media.content) {
              let plainText = media.content
                .replace(/```html\n?/g, "") // Remove markdown code blocks
                .replace(/```\n?/g, "")
                .replace(/<[^>]*>/g, "") // Strip HTML tags
                .replace(/\n\s*\n/g, "\n") // Remove extra blank lines
                .trim();

              if (plainText) {
                textContent += `  ${plainText}\n`;
              }
            }

            // Regular text/html_text fallback
            if (media.text) {
              textContent += `  ${media.text}\n`;
            } else if (media.html_text && !media.content) {
              const plainText = media.html_text.replace(/<[^>]*>/g, "").trim();
              if (plainText) {
                textContent += `  ${plainText}\n`;
              }
            }

            // Button text (for HTML with affiliate links)
            if (media.but_text) {
              textContent += `  Button: "${media.but_text}"\n`;
            }

            // Affiliate link
            if (media.affiliate_link) {
              textContent += `  🔗 Link: ${media.affiliate_link}\n`;
            }

            // Question/Quiz content (handle both old and new format)
            const questionText = media.question || media.question_text;
            if (questionText) {
              textContent += `  Question: ${questionText}\n`;

              // New format: options array with isAnswer
              if (media.options && Array.isArray(media.options)) {
                media.options.forEach((opt, idx) => {
                  const isCorrect = opt.isAnswer === true;
                  textContent += `    ${idx + 1}. ${opt.option}${
                    isCorrect ? " ✓" : ""
                  }\n`;
                });
              } else if (media.answers && Array.isArray(media.answers)) {
                // Old format: answers array with correct_answer
                media.answers.forEach((answer, aIdx) => {
                  const isCorrect =
                    media.correct_answer === aIdx ||
                    media.correct_answer === answer;
                  textContent += `    ${aIdx + 1}. ${answer}${
                    isCorrect ? " ✓" : ""
                  }\n`;
                });
              }

              if (media.explanation) {
                textContent += `    Explanation: ${media.explanation}\n`;
              }
            }

            // Media reference note (for image/video/audio without showing URLs)
            if (
              ["image", "video", "audio"].includes(media.type) &&
              !questionText &&
              !media.content &&
              !media.text
            ) {
              textContent += `  [Media file included in tour]\n`;
            }
          });
        }

        textContent += `\n\n`;
      });
    }

    // Footer
    textContent += `${separator}\n`;
    textContent += `Exported: ${new Date().toLocaleString()}\n`;
    textContent += `Total Stops: ${tour.stops?.length || 0}\n`;
    textContent += `${separator}\n`;

    return textContent;
  } catch (error) {
    console.error("Error sanitizing tour for text export:", error);
    throw error;
  }
};

/**
 * Sanitize tour data for JSON export (deep backup)
 * Includes: All user content, coordinates, config, but excludes IDs, URLs,
 * timestamps, integration data (wixID, bokunID)
 *
 * @param {Object} tour - Full tour object
 * @returns {Object} Sanitized tour object
 */
export const sanitizeTourForJSONExport = function (tour) {
  try {
    const sanitized = {
      // Basic tour info
      title: tour.title,
      main_sentense: tour.main_sentense,
      generalLocation: tour.generalLocation,
      location: tour.location,
      language: tour.language,
      duration: tour.duration,
      difficulty: tour.difficulty,
      distance: tour.distance,
      type: tour.type,
      equipment: tour.equipment,

      // Guide info (no IDs or profile images)
      tour_guide: {
        name: tour.tour_guide?.name || tour.tour_guide?.full_name,
        // Exclude: id, profile_image, email, phone
      },

      // Tour config
      config: tour.config,

      // Notes and highlights
      notes: tour.notes || [],

      // Starting point details
      starting_name: tour.starting_name,
      starting_type: tour.starting_type,
      // Exclude: starting_url, starting_video (URLs)

      // Stops with full details including coordinates
      stops: (tour.stops || []).map((stop, idx) => ({
        order: idx + 1,
        s_title: stop.s_title || stop.stop_name,
        slider_item_title: stop.slider_item_title,
        s_smallDesc: stop.s_smallDesc,
        s_description: stop.s_description,
        direction_text: stop.direction_text,
        direction_type: stop.direction_type,
        type: stop.type,
        tags: stop.tags || [],
        hours_range: stop.hours_range,
        icon: stop.icon,

        // Include GPS coordinates (deep export only)
        stop_location: stop.stop_location
          ? {
              latitude: stop.stop_location.latitude,
              longitude: stop.stop_location.longitude,
            }
          : null,

        // Include path/route info
        include_path: stop.include_path,

        // Media with metadata but no URLs
        all_media: (stop.all_media || []).map((media) => ({
          type: media.type,
          order: media.order,
          name: media.name,
          text: media.text,
          html_text: media.html_text,
          question: media.question,
          answers: media.answers,
          correct_answer: media.correct_answer,
          explanation: media.explanation,
          // Exclude: url, all Firebase Storage URLs
        })),

        // Exclude: loc_pics (URLs), s_video (URL)
      })),

      // Metadata
      exportedAt: new Date().toISOString(),
      exportVersion: "1.0",
      stopCount: tour.stops?.length || 0,
    };

    return sanitized;
  } catch (error) {
    console.error("Error sanitizing tour for JSON export:", error);
    throw error;
  }
};

/**
 * Download text content as .txt file with UTF-8 BOM for Hebrew support
 *
 * @param {string} content - Text content to download
 * @param {string} filename - Filename (without extension)
 */
export const downloadTextFile = function (content, filename) {
  try {
    const link = document.createElement("a");
    const universalBOM = "\uFEFF"; // UTF-8 BOM for Hebrew/special chars
    const fullContent = universalBOM + content;

    // Create blob with UTF-8 encoding
    const blob = new Blob([fullContent], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.txt`);
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    setTimeout(() => URL.revokeObjectURL(url), 100);

    console.log(`Downloaded text file: ${filename}.txt`);
  } catch (error) {
    console.error("Error downloading text file:", error);
    throw error;
  }
};

/**
 * Download JSON object as .json file
 *
 * @param {Object} data - Data object to download
 * @param {string} filename - Filename (without extension)
 */
export const downloadJSONFile = function (data, filename) {
  try {
    const link = document.createElement("a");
    const json = JSON.stringify(data, null, 2); // Pretty print with 2-space indent

    // Create blob
    const blob = new Blob([json], { type: "application/json;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}.json`);
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    setTimeout(() => URL.revokeObjectURL(url), 100);

    console.log(`Downloaded JSON file: ${filename}.json`);
  } catch (error) {
    console.error("Error downloading JSON file:", error);
    throw error;
  }
};

/**
 * Log tour export to Firestore for analytics
 *
 * @param {string} tourId - Tour ID
 * @param {string} userId - User ID performing export
 * @param {string} exportType - "text" or "json"
 * @param {string} tourTitle - Tour title
 * @param {number} stopCount - Number of stops in tour
 * @returns {Promise<string>} Document ID of created log
 */
export const logTourExport = function (
  tourId,
  userId,
  exportType,
  tourTitle,
  stopCount,
) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const exportLog = {
        tourId: tourId,
        userId: userId,
        exportType: exportType,
        tourTitle: tourTitle,
        stopCount: stopCount || 0,
        exportedAt: firebase.firestore.FieldValue.serverTimestamp(),
        timestamp: Date.now(),
      };

      const docRef = await firebase
        .firestore()
        .collection("exportLogs")
        .add(exportLog);

      console.log(`Logged tour export: ${docRef.id}`);
      myResolve(docRef.id);
    } catch (error) {
      console.error("Error logging tour export:", error);
      // Don't reject - logging failure shouldn't block export
      myResolve(null);
    }
  });
};

export const getAllProduct = function () {
  return new Promise(async function (myResolve, myReject) {
    const allProduct = {};
    firebase
      .firestore()
      .collection("products")
      .where("active", "==", true)
      .get()
      .then((snapshot) => {
        snapshot.forEach(async (prod) => {
          //console.log("prod", prod);
          allProduct[prod.id] = prod.data();
          if (allProduct[prod.id].name === "Advanced Plan")
            allProduct[prod.id]["popular"] = true;
          const priceSnapshot = await prod.ref.collection("prices").get();
          allProduct[prod.id]["prices"] = {};
          priceSnapshot.forEach((priceDoc) => {
            const priceData = priceDoc.data();
            if (priceData.interval === "month") {
              allProduct[prod.id]["month"] = priceData.unit_amount / 100;
              allProduct[prod.id]["monthId"] = priceDoc.id;
            } else {
              allProduct[prod.id]["year"] = priceData.unit_amount / 100;
              allProduct[prod.id]["yearId"] = priceDoc.id;
            }
            //allProduct[prod.id].prices[priceData.interval] = priceData
          });
        });
        setTimeout(function () {
          myResolve(allProduct);
        }, 2000);
      });
  });
};

export const checkTourExistence = async function (tourID) {
  try {
    const docRef = firebase.firestore().collection("tours").doc(tourID);

    const doc = await docRef.get();

    if (doc.exists) return doc.data().tour_guide.id !== tourID;
    else return false;
  } catch (error) {
    console.log("Error checking tour existence:", error);
    return false;
  }
};

export const getTourAI = async function (tourID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const docRef = firebase.firestore().collection("AIDStour").doc(tourID);
      if (docRef) {
        const doc = await docRef.get();
        if (doc.exists) {
          myResolve(doc.data());
        } else {
          myResolve(null);
        }
      }
    } catch (error) {
      console.log("Error getting AI data:", error);
      myReject(error);
    }
  });
};

export const saveTourAI = async function (tourID, data) {
  return new Promise(async function (myResolve, myReject) {
    try {
      console.log("saveTourAI", tourID, data);
      const docRef = firebase.firestore().collection("AIDStour").doc(tourID);
      await docRef.set(data);

      myResolve(true);
    } catch (error) {
      console.log("Error saving AI data:", error);
      myReject(error);
    }
  });
};

export const saveTourFirebase = function (updateTour) {
  return new Promise(async function (myResolve, myReject) {
    try {
      //updateTour.modify_date = Date()
      //console.log("updateTour", updateTour);
      await firebase
        .firestore()
        .collection("tours")
        .doc(updateTour.id)
        .set(updateTour);
      myResolve(updateTour);
    } catch (error) {
      console.log("ERROR in Add saveTourFirebase", error);
      myReject(error);
    }
  });
};

/**
 * Fix corrupted notes field in tour objects where notes was stored as character array
 * instead of proper array of {question, answer} objects.
 *
 * Example corruption:
 *   notes: ["T", "h", "i", "s", " ", "t", "o", "u", "r", ...]
 *
 * Converts to:
 *   notes: [{ question: "what to expect?", answer: "This tour..." }]
 *
 * @param {Object} tour - Tour object that may have corrupted notes field
 * @returns {Object} Tour object with fixed notes field
 */
export const fixCharArraysInObject = function (tour) {
  console.log("🔧 fixCharArraysInObject - Checking for corrupted notes field");

  // Create a shallow copy to avoid mutating the original
  const fixedTour = { ...tour };

  // Check if notes field exists and needs fixing
  if (fixedTour.notes) {
    const isCharArray =
      Array.isArray(fixedTour.notes) &&
      fixedTour.notes.length > 0 &&
      fixedTour.notes.every(
        (char) => typeof char === "string" && char.length === 1,
      );

    if (isCharArray) {
      console.log(
        `⚠️ Detected corrupted notes field (${fixedTour.notes.length} characters)`,
      );

      // Reconstruct the original string from character array
      const reconstructedText = fixedTour.notes.join("");
      console.log(
        `📝 Reconstructed text preview: "${reconstructedText.substring(
          0,
          100,
        )}..."`,
      );

      // Convert to proper notes format
      fixedTour.notes = [
        {
          question: "what to expect?",
          answer: reconstructedText,
        },
      ];

      console.log("✅ Notes field fixed successfully");
    } else if (
      Array.isArray(fixedTour.notes) &&
      fixedTour.notes.length > 0 &&
      typeof fixedTour.notes[0] === "object" &&
      fixedTour.notes[0].question !== undefined
    ) {
      console.log("✅ Notes field is already in correct format");
    } else {
      console.log(
        "ℹ️ Notes field exists but is not a character array (might be empty or different format)",
      );
    }
  } else {
    console.log("ℹ️ No notes field found in tour object");
  }

  return fixedTour;
};

const checkUserAllow = function (userID, tourID) {
  return new Promise(async function (myResolve, myReject) {
    myResolve(userID === tourID);
  });
};

export const GetUser = function (userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      firebase
        .firestore()
        .collection("saasCustomers")
        .doc(userID)
        .get()
        .then((user) => {
          myResolve(user.data());
        })
        .catch((err) => {
          console.log("Can't get tours of this guide", err);
          myReject(err);
        });
    } catch (error) {
      console.log("error", error);
      myReject(error);
    }
  });
};

/**
 * Add a child user to a parent user's ownsUsers array
 * @param {string} parentUID - Parent user ID
 * @param {string} childUID - Child user ID to add
 * @returns {Promise<string>} Success message
 */
export const addOwnedUser = function (parentUID, childUID) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!parentUID || !childUID) {
        throw new Error("Both parentUID and childUID are required");
      }

      if (parentUID === childUID) {
        throw new Error("Cannot add user as their own owned user");
      }

      await db
        .collection("saasCustomers")
        .doc(parentUID)
        .update({
          ownsUsers: firebase.firestore.FieldValue.arrayUnion(childUID),
        });

      resolve("User added to owned users successfully!");
    } catch (error) {
      console.error("Error adding owned user:", error);
      reject("Failed to add owned user. Please try again.");
    }
  });
};

/**
 * Remove a child user from a parent user's ownsUsers array
 * @param {string} parentUID - Parent user ID
 * @param {string} childUID - Child user ID to remove
 * @returns {Promise<string>} Success message
 */
export const removeOwnedUser = function (parentUID, childUID) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!parentUID || !childUID) {
        throw new Error("Both parentUID and childUID are required");
      }

      await db
        .collection("saasCustomers")
        .doc(parentUID)
        .update({
          ownsUsers: firebase.firestore.FieldValue.arrayRemove(childUID),
        });

      resolve("User removed from owned users successfully!");
    } catch (error) {
      console.error("Error removing owned user:", error);
      reject("Failed to remove owned user. Please try again.");
    }
  });
};

export const GetAllUserTours = function (userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      let allTours = [];
      if (!userID) myResolve([]);
      console.log("guideID", userID);
      firebase
        .firestore()
        .collection("URLusage")
        .where("uID", "==", userID)
        .get()
        .then(async (tours) => {
          if (!tours.empty) {
            let data = await Promise.all(
              tours.docs.map(async (tour) => {
                allTours.push(tour.data().tourID);
              }),
            );
            myResolve(allTours);
          } else {
            myResolve([]);
          }
        })
        .catch((err) => {
          console.log("Can't get tours of this guide", err);
          myReject(err);
        });
    } catch (error) {
      console.log("error", error);
      myReject(error);
    }
  });
};

export const GetAllUserToursByGuide = function (guideID, userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      let allTours = [];
      if (!guideID || !userID) myResolve([]);
      console.log("guideID", guideID, userID);
      firebase
        .firestore()
        .collection("URLusage")
        .where("uID", "==", userID)
        .where("gID", "==", guideID)
        .get()
        .then(async (tours) => {
          if (!tours.empty) {
            let data = await Promise.all(
              tours.docs.map(async (tour) => {
                allTours.push(tour.data().tourID);
              }),
            );
            myResolve(allTours);
          } else {
            myResolve([]);
          }
        })
        .catch((err) => {
          console.log("Can't get tours of this guide", err);
          myReject(err);
        });
    } catch (error) {
      console.log("error", error);
      myReject(error);
    }
  });
};

export const getTourData = (tourID) => {
  return new Promise(async function (myResolve, myReject) {
    firebase
      .firestore()
      .collection("approval_saas")
      .doc(tourID)
      .get()
      .then((tour) => {
        if (tour.data()) {
          let data = tour.data();
          //console.log("data", data)
          let res = {
            title: data.title,
            tour_guide: data.tour_guide,
            tour_image: data.tour_image
              ? data.tour_image
              : data.stops[0].loc_pics[0].url,
            config: data.config,
          };
          //console.log("res", res)
          myResolve(res);
        }
      })
      .catch((err) => {
        console.log("Can't get tours of this guide", err);
        myReject({});
      });
  });
};

export const removeAPI = async function (uID, tourID, allAPI) {
  return new Promise(async function (myResolve, myReject) {
    //allAPI[idx].active = false;
    try {
      const newDoc = { ...allAPI[tourID][uID], active: false };
      allAPI[tourID][uID] = newDoc;
      firebase.firestore().collection("URLusage").doc(newDoc.docID).set(newDoc);
      myResolve(allAPI);
    } catch (error) {
      console.log("err", error);
      myReject(error);
    }
  });
};

export const updateTourProfile = async function (tour) {
  return new Promise(async function (myResolve, myReject) {
    try {
      let docRef = firebase.firestore().collection("tours").doc(tour.id);
      let updateTour = {
        duration: tour.duration,
        title: tour.title,
        language: tour.language,
        generalLocation: tour.generalLocation,
        location: tour.location,
        difficulty: tour.difficulty,
        type: tour.tourType.map((obj) => obj.value),
        equipment: tour.equipment.map((obj) => obj.value),
        tour_guide: tour.tour_guide,
        main_sentense: tour.main_sentense,
        notes: tour.notes,
        starting_name: tour.starting_name,
        starting_video: tour.starting_video,
        starting_url: tour.starting_url,
        starting_type: tour.starting_type,
      };

      // Check each field for undefined values
      console.log("Checking for undefined values:");
      Object.keys(updateTour).forEach((key) => {
        if (updateTour[key] === undefined) {
          console.log(`⚠️ Field "${key}" is undefined`);
        }
      });

      // Only add config if it exists
      if (tour.config) {
        updateTour.config = tour.config;
        console.log("✅ Config added to updateTour");
      } else {
        console.log("⚠️ Config is undefined, not adding to update");
      }

      console.log(
        "Final updateTour object:",
        JSON.stringify(updateTour, null, 2),
      );
      console.log("=== End Debug ===");

      docRef
        .update(updateTour)
        .then((res) => {
          console.log("After update to the bsisash", res);
          myResolve(docRef.id);
        })
        .catch((err) => {
          console.log("Error set link to header", err);
          myReject(err);
        });
    } catch (error) {
      console.log("ERROR in Add updateTourProfile", error);
      myReject(error);
    }
  });
};

export const addLinkForUser = async function (
  gID,
  uID,
  tID,
  imageUrl,
  description,
  title,
) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const link = {
        imageUrl: imageUrl,
        description: description,
        title: title,
        gID: gID,
        uID: uID,
        tID: tID,
      };
      console.log("link", link);
      if (!link.tID || !link.gID || !link.uID)
        myReject("Error in addLinkForUser");

      let docRef = firebase.firestore().collection("URLheader").doc();
      console.log("docRef", docRef.id);
      if (!docRef.id) myReject("Error in addLinkForUser");
      docRef
        .set(link)
        .then((res) => {
          console.log("int then functions", res);
          myResolve(docRef.id);
        })
        .catch((err) => {
          console.log("Error set link to header");
          myReject(err);
        });
    } catch (error) {
      console.log("ERROR in Add addLinkForUser", error);
      myReject(error);
    }
  });
};

export const addAPI = async function (
  ownerID,
  uID,
  tourID,
  allAPI,
  minDate,
  maxDate,
  maxUsage,
) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const APIparams = {
        uId: uID,
        tourID: tourID,
        creationDate: Date(),
        active: true,
        maxDate: maxDate,
        minDate: minDate,
        maxUsage: Number(maxUsage),
        uniqueMID: [],
        usage: {},
      };
      //allAPI.push(APIparams)
      if (allAPI[tourID]) {
        allAPI[tourID][uID] = APIparams;
      } else {
        if (!allAPI) allAPI = {};
        allAPI[tourID] = {};
        allAPI[tourID][uID] = APIparams;
      }

      firebase
        .firestore()
        .collection("saasAPI")
        .doc(ownerID)
        .set({ allAPI: allAPI }, { merge: true })
        .then((resp) => {
          console.log("resp", resp);
          myResolve(allAPI);
        })
        .catch((err) => console.log("Error in firebase", err));
    } catch (error) {
      console.log("ERROR in Add API", error);
      myReject(error);
    }
  });
};

//usage change
export const addAPIPromise = async function (
  ownerID,
  uID,
  tourID,
  minDate,
  maxDate,
  maxUsage,
  couponNum = 0,
  allCoupons = [],
  budget = 0,
  packageInfo = null,
) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const APIparams = {
        uID: uID,
        tourID: tourID,
        creationDate: Date(),
        active: true,
        maxDate: maxDate,
        minDate: minDate,
        maxUsage: Number(maxUsage),
        usage: {},
        gID: ownerID,
      };
      if (couponNum > 0) {
        APIparams.coupon = {
          available: Number(couponNum),
          budget: Number(budget),
          budgetUsage: 0,
        };
        APIparams.allCoupons = allCoupons;
      }

      // Add package information if provided
      if (packageInfo) {
        APIparams.packageId = packageInfo.packageId;
        APIparams.packageName = packageInfo.packageName;
      }

      firebase
        .firestore()
        .collection("URLusage")
        .doc()
        .set(APIparams, { merge: true })
        .then((resp) => {
          console.log("resp", resp);
          myResolve(APIparams);
        })
        .catch((err) => {
          console.log("Error in firebase", err);
          myReject(err);
        });
    } catch (error) {
      console.log("ERROR in Add API", error);
      myReject(error);
    }
  });
};

//usage change
export const updateAPIPromise = async function (
  minDate,
  maxDate,
  maxUsage,
  docID,
) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const APIparams = {
        modifyDate: Date(),
        active: true,
        maxDate: maxDate,
        minDate: minDate,
        maxUsage: Number(maxUsage),
      };
      console.log("update tour", docID, APIparams);

      firebase
        .firestore()
        .collection("URLusage")
        .doc(docID)
        .set(APIparams, { merge: true })
        .then((resp) => {
          console.log("resp", resp);
          myResolve(APIparams);
        })
        .catch((err) => {
          console.log("Error in firebase", err);
          myReject(err);
        });
    } catch (error) {
      console.log("ERROR in Add API", error);
      myReject(error);
    }
  });
};

export const getAPIByUID = async function (ownerID, uID) {
  return new Promise(async function (myResolve, myReject) {
    firebase
      .firestore()
      .collection("URLusage")
      .where("gID", "==", ownerID)
      .where("uID", "==", uID)
      .get()
      .then((querySnapshot) => {
        let docs = {};
        querySnapshot.forEach((doc) => {
          console.log("doc", doc.data());
          if (!docs[doc.data().tourID]) docs[doc.data().tourID] = {};
          if (!docs[doc.data().tourID][doc.data().uID])
            docs[doc.data().tourID][doc.data().uID] = {};
          if (docs[doc.data().tourID][doc.data().uID].usage) return;
          docs[doc.data().tourID][doc.data().uID] = {
            ...doc.data(),
            docID: doc.id,
          };
        });

        myResolve({ allAPI: docs });
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

export const getAPIPromise = async function (ownerID) {
  return new Promise(async function (myResolve, myReject) {
    firebase
      .firestore()
      .collection("URLusage")
      .where("gID", "==", ownerID)
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        let docs = {};
        querySnapshot.forEach((doc) => {
          if (!docs[doc.data().tourID]) docs[doc.data().tourID] = {};
          if (!docs[doc.data().tourID][doc.data().uID])
            docs[doc.data().tourID][doc.data().uID] = {};
          if (docs[doc.data().tourID][doc.data().uID].usage) return;
          docs[doc.data().tourID][doc.data().uID] = {
            ...doc.data(),
            docID: doc.id,
          };
          //docs.push(doc.data());
        });
        myResolve({ allAPI: docs });
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

export const getAPI = async function (ownerID) {
  return new Promise(async function (myResolve, myReject) {
    console.log("ownerID", ownerID);
    firebase
      .firestore()
      .collection("saasAPI")
      .doc(`${ownerID}`)
      .get()
      .then((snapshot) => {
        myResolve(snapshot.data());
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

export const getHeaderLinks = async function (ownerID) {
  return new Promise(async function (myResolve, myReject) {
    firebase
      .firestore()
      .collection("URLheader")
      .where("gID", "==", ownerID)
      .get()
      .then((querySnapshot) => {
        let docs = [];
        querySnapshot.forEach((doc) => {
          docs.push({ ...doc.data(), id: doc.id });
        });

        myResolve(docs);
      })
      .catch((e) => {
        console.log(e);
        myReject(null);
      });
  });
};

const editAllMediaUrl = async function (allMediaArr, folderID) {
  return new Promise(async function (myResolve, myReject) {
    allMediaArr.map(async (media, idx) => {
      if (media.type.includes("video")) {
        console.log("CHeck _compress", media);
        const imageRef = storage().ref(`${folderID}/${media.name}_compress`);
        const url = await imageRef.getDownloadURL().catch((error) => {
          console.log("throw error not find compress resize in all_media tour");
        });
        console.log("FOUND URL", url);
        if (url) allMediaArr[idx].url = url;
      }
    });
  });
};

const fileStorageRef = function (
  folderID,
  fileName,
  type,
  subFolder = "stopMedia",
) {
  return new Promise(async function (myResolve, myReject) {
    console.log("avif test");
    try {
      // First, try to find AVIF version for images
      if (
        type === "jpg" ||
        type === "jpeg" ||
        type === "png" ||
        type === "image"
      ) {
        const avifFileName = fileName.replace("_resize", "_avif.avif");
        let avifFileRef = storage.ref(
          subFolder
            ? `${folderID}/${subFolder}/${avifFileName}`
            : `${folderID}/${avifFileName}`,
        );

        try {
          const avifUrl = await avifFileRef.getDownloadURL();
          console.log(`Found AVIF version: ${avifFileName}`);
          myResolve(avifUrl);
          return;
        } catch (avifError) {
          console.log(
            `AVIF version not found: ${avifFileName}, falling back to resize version`,
          );
          // Continue to original logic if AVIF not found
        }
      }

      // Original logic - try the provided fileName first
      let compressFileRef = storage.ref(
        subFolder
          ? `${folderID}/${subFolder}/${fileName}`
          : `${folderID}/${fileName}`,
      );
      await compressFileRef
        .getDownloadURL()
        .then((url) => {
          myResolve(url);
        })
        .catch(async (error) => {
          compressFileRef = storage.ref(
            subFolder
              ? `${folderID}/${subFolder}/${fileName}`
              : `${folderID}/${fileName}`,
          );
          await compressFileRef
            .getDownloadURL()
            .then((url) => {
              myResolve(url);
            })
            .catch(async (error) => {
              compressFileRef = storage.ref(
                subFolder
                  ? `${folderID}/${subFolder}/${fileName}.${type}`
                  : `${folderID}/${fileName}.${type}`,
              );
              await compressFileRef
                .getDownloadURL()
                .then((url) => {
                  myResolve(url);
                })
                .catch((error) => {
                  if (error.code === "storage/object-not-found")
                    myReject("storage/object-not-found");
                });
            });
        });
    } catch (error) {
      console.log("GENERAL ERROR");
      myReject("false");
    }
  });
};

const fileStorageRefNoSubFolder = function (folderID, fileName, type) {
  return new Promise(async function (myResolve, myReject) {
    try {
      let compressFileRef = storage.ref(
        subFolder ? `${folderID}/${fileName}` : `${folderID}/${fileName}`,
      );
      //console.log("fileStorageRef 1", `${folderID}/${fileName}`)
      await compressFileRef
        .getDownloadURL()
        .then((url) => {
          myResolve(url);
        })
        .catch(async (error) => {
          /* throw error */
          compressFileRef = storage.ref(
            subFolder ? `${folderID}/${fileName}` : `${folderID}/${fileName}`,
          );
          //console.log("fileStorageRef 2", `${folderID}/stopMedia/${fileName}`)
          await compressFileRef
            .getDownloadURL()
            .then((url) => {
              myResolve(url);
            })
            .catch(async (error) => {
              compressFileRef = storage.ref(
                subFolder
                  ? `${folderID}/${fileName}.${type}`
                  : `${folderID}/${fileName}.${type}`,
              );
              //console.log("fileStorageRef 3", `${folderID}/stopMedia/${fileName}.${type}`)
              await compressFileRef
                .getDownloadURL()
                .then((url) => {
                  myResolve(url);
                })
                .catch((error) => {
                  if (error.code === "storage/object-not-found")
                    myReject("storage/object-not-found");
                });
            });
        });
    } catch (error) {
      console.log("GENERAL ERROR");
      myReject("false");
    }
  });
};

const tagDict = {
  General: "כללי",
  Classic: "קלאסי",
  History: "היסטורי",
  Culture: "תרבות",
  Artistic: "אומנותי",
  Musical: "מוזיקלי",
  Nature: "טבע",
  Culinary: "קולינרי",
  Religious: "דת",
  Food: "אוכל",
  general: "כללי",
  classic: "קלאסי",
  history: "היסטורי",
  culture: "תרבות",
  artistic: "אומנותי",
  musical: "מוזיקלי",
  nature: "טבע",
  culinary: "קולינרי",
  religious: "דת",
  food: "אוכל",
};
const dictByLnag = {
  Hebrew: {
    stop: "עצירה",
  },
  English: {
    stop: "stop",
  },
  Spanish: {
    stop: "parada",
  },
  French: {
    stop: "arrêt",
  },
  Franch: {
    stop: "arrêt",
  },
  Portuguese: {
    stop: "parada",
  },
};

const updateApprovDate = function (tour) {
  tour.approval_date = Date();
  firebase
    .firestore()
    .collection("tours")
    .doc(tour.id)
    .set(tour)
    .then(() => {
      console.log("tour approval_date saved");
    })
    .catch((err) => {
      console.log("tour Approve ERROR!", err);
    });
};

export const approveTour = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    if (tour.stops.length < 2) {
      myReject(
        "Tour most include at least 2 stops.\n Please add stops before tring the demo.",
      );
      return;
    }
    if (!tour.title) {
      myReject(
        "Tour most include title.\n Please fill the basic details of that tour.",
      );
      return;
    }

    let stopInRoute = 0;
    const MAXSTOPSINROUTE = 70;
    let approve_tour = JSON.parse(JSON.stringify(tour));
    let bigStopCnt = 1;
    try {
      //starting_point
      if (approve_tour.stops[0] && approve_tour.stops[0].stop_location) {
        approve_tour.starting_point = {
          latitude: approve_tour.stops[0].stop_location["latitude"],
          longitude: approve_tour.stops[0].stop_location["longitude"],
        };
      }
      //starting_video
      if (approve_tour.starting_name) {
        fileStorageRef(
          tour.id,
          `${approve_tour.starting_name}_compress`,
          "mp4",
          null,
        )
          .then((resp) => {
            approve_tour.starting_video = resp;
            approve_tour.starting_url = resp;
            approve_tour.starting_name = `${approve_tour.starting_name}_compress`;
          })
          .catch((error) =>
            console.log(
              "DONT GOT IN FUNCTION",
              `${tour.id} ${media.name}_compress`,
            ),
          );
      }
      if (approve_tour.tour_guide.profile_image) {
        fileStorageRef(tour.id, `guideProfile_resize`, "jpg", null)
          .then((resp) => {
            approve_tour.tour_guide.profile_image = resp;
          })
          .catch((error) =>
            console.log(
              "DONT GOT IN FUNCTION",
              `${tour.id} guideProfile_resize`,
            ),
          );
      } else {
        approve_tour.tour_guide.profile_image =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/avatar-blank.png?alt=media&token=d33a1c38-6d60-4aa1-b7fa-9a324f6a03c4";
      }

      //all_media
      approve_tour.all_media.map((media, idx) => {
        if (media.type.includes("video")) {
          fileStorageRef(tour.id, `${media.name}_compress`, "mp4", null)
            .then((resp) => {
              approve_tour.all_media[idx].url = resp;
              approve_tour.all_media[idx].name = `${media.name}_compress`;
            })
            .catch((error) => console.log("DONT GOT IN FUNCTION", error));
        } else if (media.type.includes("image")) {
          fileStorageRef(tour.id, `${media.name}_resize`, "jpg", null)
            .then((resp) => {
              approve_tour.all_media[idx].url = resp;
              approve_tour.all_media[idx].name = `${media.name}_resize`;
            })
            .catch((error) => console.log("DONT GOT IN FUNCTION", error));
        }
      });

      if (approve_tour.language === "Hebrew")
        approve_tour.exp_video =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/explanHe_compress.mp4?alt=media&token=d38219d2-0d70-4a81-ab87-d616b6bae2ee";
      //"https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/maslol_exp_he_compress.mp4?alt=media&token=cb0b7755-be31-4f55-9df6-42158bd4c1b0";
      else
        approve_tour.exp_video =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/explanEn_compress.mp4?alt=media&token=b257ca28-333b-4038-9cab-2f163c28898c";
      //"https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/mexpo_vid.mp4?alt=media&token=a10b2584-6a4e-4a90-a02c-466ea06d02ad";

      approve_tour.stops.map((stop, idx) => {
        if (stop.type === "parkingStop") {
          approve_tour.parking = {
            latitude: stop.stop_location.latitude,
            longitude: stop.stop_location.longitude,
            name: stop.s_title,
          };
          approve_tour.stops.splice(idx, 1);
          return;
        }

        if (stop.include_path) {
          stopInRoute += 1;
          if (stopInRoute > MAXSTOPSINROUTE) {
            approve_tour.stops[idx].include_path = false;
          }
        }

        if (stop.type === "directionStop") {
          approve_tour.stops[idx].type = "smallStop";
          return;
        }

        if (approve_tour.language === "Hebrew") {
          const tmpTags = approve_tour.stops[idx].tags
            ? approve_tour.stops[idx].tags
            : [];
          approve_tour.stops[idx].tags = [];
          tmpTags.map((tag) => {
            approve_tour.stops[idx].tags.push(tagDict[tag.toLowerCase()]);
          });
        }

        if (stop.type.includes("big")) {
          approve_tour.stops[idx].stop_index = bigStopCnt;
          bigStopCnt++;

          if (stop.direction_text)
            approve_tour.stops[idx].diraction_text = stop.direction_text;

          if (stop.loc_pics && stop.loc_pics[0]) {
            fileStorageRef(
              tour.id,
              `${stop.loc_pics[0].name}_resize`,
              "jpg",
              null,
            )
              .then((resp) => {
                approve_tour.stops[idx].loc_pics[0].url = resp;
                approve_tour.stops[
                  idx
                ].loc_pics[0].name = `${stop.loc_pics[0].name}_resize`;
              })
              .catch((error) =>
                console.log(
                  "DONT GOT IN FUNCTION",
                  error,
                  stop.loc_pics[0].name,
                ),
              );
          } /* (!stop.loc_pics || !stop.loc_pics[0]) */ else {
            approve_tour.stops[idx].loc_pics = [
              {
                name: "direcTmp",
                order: 0,
                title: "title",
                type: "image/jpeg",
                url: "https://firebasestorage.googleapis.com/v0/b/dguidedev.appspot.com/o/direcTmp.jpg?alt=media&token=580c9983-9b39-4b30-a64b-00695c65b8eb",
              },
            ];
          }
        }

        stop.all_media.map(async (media, mIdx) => {
          if (media.type.includes("video")) {
            if (media.orientation === "vertical")
              approve_tour.stops[idx].all_media[mIdx].isVertical = true;
            fileStorageRef(tour.id, `${media.name}_compress`, "mp4", null)
              .then((resp) => {
                approve_tour.stops[idx].all_media[mIdx].url = resp;
                approve_tour.stops[idx].all_media[
                  mIdx
                ].name = `${media.name}_compress`;
              })
              .catch((error) =>
                console.log(
                  "DONT GOT IN FUNCTION",
                  `${tour.id} ${media.name}_compress`,
                ),
              );
            if (idx === 0 && !approve_tour.starting_video) {
              approve_tour.starting_video =
                approve_tour.stops[idx].all_media[mIdx].url;
              approve_tour.starting_name =
                approve_tour.stops[idx].all_media[mIdx].name;
            }
            /* let compress_name = `${media.name}_compress`
            let compressImageRef = storage.ref(`${tour.id}/${compress_name}`)
            await compressImageRef.getDownloadURL().then(url => {
              approve_tour.stops[idx].all_media[mIdx].url = url
              approve_tour.stops[idx].all_media[mIdx].name =  `${compress_name}`
            }).catch((error) => { console.log("throw error, Can't find a copress file") }) */
          } else if (media.type.includes("image")) {
            fileStorageRef(tour.id, `${media.name}_resize`, "jpg", null)
              .then((resp) => {
                approve_tour.stops[idx].all_media[mIdx].url = resp;
                approve_tour.stops[idx].all_media[
                  mIdx
                ].name = `${media.name}_resize`;
              })
              .catch((error) => console.log("DONT GOT IN FUNCTION", error));
          }
        });
      });
      setTimeout(() => {
        approve_tour.approve_date = Date();
        firebase
          .firestore()
          .collection("approval_saas")
          .doc(tour.id)
          .set(approve_tour)
          .then(() => {
            //updateApprovDate(tour)
            myResolve(approve_tour);
          })
          .catch((err) => {
            console.log("tour Approve ERROR!", err);
            myReject(err);
          });
      }, 9000);
    } catch (error) {
      console.log("ERROR", error);
    }
  });
};

export const approveTourToDguide = function (
  tour,
  saas_approve = false,
  old_system = true,
) {
  return new Promise(async function (myResolve, myReject) {
    let approve_tour = JSON.parse(JSON.stringify(tour));
    let bigStopCnt = 1;
    let stopsCnt = 0;
    let allCouponStops = [];
    delete approve_tour["rating"];
    try {
      //all_media
      //editAllMediaUrl(tour.all_media).then(newAllMedia => tour.all_media)

      //starting_video
      const mp4Media = tour.all_media.find((media) =>
        media.type.includes("mp4"),
      );
      console.log("mp4Media", mp4Media);
      if (mp4Media) {
        const starting_name = mp4Media.name.includes("compress")
          ? `${mp4Media.name}`
          : `${mp4Media.name}_compress`;
        console.log(
          "LOOKKING FOR ",
          `${tour.id}/toursMedia/${starting_name}.mp4`,
        );
        const imageRef = storage.ref(
          `${tour.id}/toursMedia/${starting_name}.mp4`,
        );
        await imageRef
          .getDownloadURL()
          .then((url) => {
            approve_tour.starting_video = url;
            approve_tour.starting_url = url;
            approve_tour.starting_name = `${starting_name}`;
            approveTour.starting_type = mp4Media.type;
          })
          .catch((error) => {
            /* throw error */ console.log(
              "throw error, Can't find a copress file for starting",
              error,
            );
          });
      }

      approve_tour.all_media.map((media, idx) => {
        if (media.type.includes("video")) {
          if (old_system) {
            fileStorageRef(
              tour.id,
              `${media.name}_compress`,
              "mp4",
              "toursMedia",
            )
              .then((resp) => {
                approve_tour.all_media[idx].url = resp;
                approve_tour.all_media[idx].name = `${media.name}_compress`;
              })
              .catch((error) => console.log("DONT GOT IN FUNCTION all_media"));
          } else {
            fileStorageRefNoSubFolder(tour.id, `${media.name}_compress`, "mp4")
              .then((resp) => {
                approve_tour.all_media[idx].url = resp;
                approve_tour.all_media[idx].name = `${media.name}_compress`;
                approve_tour.all_media[idx].type = "video/mp4";
              })
              .catch((error) => console.log("DONT GOT IN FUNCTION all_media"));
          }
        } else if (media.type.includes("image")) {
          if (old_system) {
            fileStorageRef(tour.id, `${media.name}_resize`, "jpg", "toursMedia")
              .then((resp) => {
                approve_tour.all_media[idx].url = resp;
                approve_tour.all_media[idx].name = `${media.name}_resize`;
              })
              .catch((error) => console.log("DONT GOT IN FUNCTION"));
          } else {
            fileStorageRefNoSubFolder(tour.id, `${media.name}_resize`, "jpg")
              .then((resp) => {
                approve_tour.all_media[idx].url = resp;
                approve_tour.all_media[idx].name = `${media.name}_resize`;
              })
              .catch((error) => console.log("DONT GOT IN FUNCTION"));
          }
        }
      });
      approve_tour.exp_video =
        "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/expo_video.mp4?alt=media&token=1236c5eb-1097-4d48-946e-381b9e10085e";
      approve_tour.stops.map((stop, idx) => {
        if (stop.type === "parkingStop") {
          approve_tour.parking = {
            latitude: stop.stop_location.latitude,
            longitude: stop.stop_location.longitude,
            name: stop.s_title,
          };
          approve_tour.stops.splice(idx, 1);
          return;
        }
        if (stop.type.includes("big")) {
          approve_tour.stops[idx].stop_index = bigStopCnt;
          bigStopCnt++;

          /****** Handle loc_pic ************/
          if (stop.loc_pics && stop.loc_pics[0]) {
            if (old_system) {
              fileStorageRef(stop.id, `${stop.loc_pics[0].name}_resize`, "jpg")
                .then((resp) => {
                  approve_tour.stops[idx].loc_pics[0].url = resp;
                  approve_tour.stops[
                    idx
                  ].loc_pics[0].name = `${stop.loc_pics[0].name}_resize`;
                })
                .catch((error) => console.log("DONT GOT IN FUNCTION", error));
            } else {
              fileStorageRef(
                stop.id,
                `${stop.loc_pics[0].name}_resize`,
                "jpg",
                false,
              )
                .then((resp) => {
                  approve_tour.stops[idx].loc_pics[0].url = resp;
                  approve_tour.stops[
                    idx
                  ].loc_pics[0].name = `${stop.loc_pics[0].name}_resize`;
                })
                .catch((error) => console.log("DONT GOT IN FUNCTION", error));
            }
          }

          if (stop.direction_text)
            approve_tour.stops[idx].diraction_text = stop.direction_text;
        }
        if (!stop.loc_pics || !stop.loc_pics[0]) {
          approve_tour.stops[idx].loc_pics = [
            {
              name: "direcTmp",
              order: 0,
              title: "title",
              type: "image/jpeg",
              url: "https://firebasestorage.googleapis.com/v0/b/dguidedev.appspot.com/o/direcTmp.jpg?alt=media&token=580c9983-9b39-4b30-a64b-00695c65b8eb",
            },
          ];
        }
        approve_tour.stops[idx].display_icon = stop.show_marker
          ? stop.show_marker
          : true;
        approve_tour.stops[idx].include_path = stop.include_path
          ? stop.include_path
          : true;

        if (approve_tour.stops[idx].direction_type === undefined)
          console.log("DIRECTION TYPE SET TO FOOT", stop.direction_type);
        if (approve_tour.stops[idx].direction_type === undefined)
          approve_tour.stops[idx].direction_type = "foot";
        stop.all_media.map(async (media, mIdx) => {
          try {
            if (media.type.includes("video")) {
              try {
                if (old_system) {
                  fileStorageRef(
                    stop.id,
                    media.name.includes("compress")
                      ? `${media.name}plus`
                      : `${media.name}_compressplus`,
                    "mp4",
                    "stopMedia",
                  )
                    .then((resp) => {
                      approve_tour.stops[idx].all_media[mIdx].url = resp;
                      approve_tour.stops[idx].all_media[mIdx].name =
                        media.name.includes("compress")
                          ? `${media.name}plus`
                          : `${media.name}_compressplus`;
                    })
                    .catch((error) => {
                      fileStorageRef(
                        stop.id,
                        media.name.includes("compress")
                          ? media.name
                          : `${media.name}_compress`,
                        "mp4",
                        "stopMedia",
                      )
                        .then((resp) => {
                          approve_tour.stops[idx].all_media[mIdx].url = resp;
                          approve_tour.stops[idx].all_media[mIdx].name =
                            media.name.includes("compress")
                              ? media.name
                              : `${media.name}_compress`;
                        })
                        .catch((error) => {
                          console.log("DONT GOT IN FUNCTION", error);
                        });
                    });
                  /* fileStorageRef(stop.id, `${media.poster_name}_resize`, "jpg").then(resp => {
                  approve_tour.stops[idx].all_media[mIdx].poster_url = resp
                  approve_tour.stops[idx].all_media[mIdx].poster_name =  `${media.poster_name}_resize`
                }).catch((error) => console.log("DONT GOT IN FUNCTION", error)) */
                } else {
                  fileStorageRef(
                    tour.id,
                    `${media.name}_compress`,
                    "mp4",
                    false,
                  )
                    .then((resp) => {
                      approve_tour.stops[idx].all_media[mIdx].url = resp;
                      approve_tour.stops[idx].all_media[
                        mIdx
                      ].name = `${media.name}_compress`;
                      approve_tour.stops[idx].all_media[mIdx].type =
                        "video/mp4";
                    })
                    .catch((error) =>
                      console.log("DONT GOT IN FUNCTION", error),
                    );
                }
              } catch (error) {
                console.log("GENERAL ERROR");
              }
            } else if (media.type.includes("image")) {
              if (old_system) {
                fileStorageRef(
                  stop.id,
                  `${media.name}_resize`,
                  "jpg",
                  "stopMedia",
                )
                  .then((resp) => {
                    approve_tour.stops[idx].all_media[mIdx].url = resp;
                    approve_tour.stops[idx].all_media[
                      mIdx
                    ].name = `${media.name}_resize`;
                  })
                  .catch((error) => {
                    console.log(
                      "!!!!!!!!throw error, Can't find a resize file",
                      media.name,
                    );
                  });
              } else {
                fileStorageRef(tour.id, `${media.name}_resize`, "jpg", false)
                  .then((resp) => {
                    approve_tour.stops[idx].all_media[mIdx].url = resp;
                    approve_tour.stops[idx].all_media[
                      mIdx
                    ].name = `${media.name}_resize`;
                  })
                  .catch((error) => {
                    console.log(
                      "!!!!!!!!throw error, Can't find a resize file",
                      media.name,
                    );
                  });
              }
            } else if (media.type.includes("coupon")) {
              if (!allCouponStops.includes(approve_tour.stops[idx].id)) {
                allCouponStops.push(approve_tour.stops[idx].id);
              }
            }
          } catch (error) {
            console.log("catch error", stop.id, stop.order, media, error);
          }
        });
      });
      approve_tour.approval_time = new Date().toLocaleString();
      setTimeout(() => {
        if (saas_approve) {
          //console.log("BEFORE APPROVE to SAAS", approve_tour);
          approve_tour.coupon_stops = allCouponStops;
          approve_tour.approve_date = Date();
          firebase
            .firestore()
            .collection("approval_saas")
            .doc(tour.id)
            .set(approve_tour /* , {merge: true} */)
            .then(() => {
              //updateApprovDate(tour)
              myResolve(approve_tour);
            })
            .catch((err) => {
              console.log("tour Approve ERROR!", err);
              myReject(err);
            });
        } else {
          console.log("approve firestore to Dguide APP", approve_tour);
          return;
          firebase
            .firestore()
            .collection("approval_tours")
            .doc(tour.id)
            .set(approve_tour, { merge: true })
            .then(() => {
              myResolve(approve_tour);
            })
            .catch((err) => {
              console.log("tour Approve ERROR!", err);
              myReject(err);
            });
        }

        /* firebase.firestore().collection("approval_tours").doc(`${tour.id}`).get().then((snapshot) => {
          const orig_tour = snapshot.data()
          console.log("APPROVE OUTPUT", approve_tour)
          console.log("orig_tour", orig_tour)
          const all_diff = Object.fromEntries(Object.entries(approve_tour).filter(([key, val]) => key in orig_tour && orig_tour[key] !== val))
          console.log("DIFF", all_diff)
        }).catch((e) => {
          console.log(e)
          myReject(null)
        }) */
      }, 30000);
    } catch (error) {
      console.log("ERROR", error);
    }
  });
};

//////////////////// DUPLICATE TOUR ////////////////////////////

export const copyFolderFiles = async (source, destination) => {
  try {
    console.log("copy start");
    const sourceDirectory = `${source}`;
    const destinationDirectory = `${destination}`;
    console.log("sourceDirectory", sourceDirectory);
    // Get a reference to the source directory
    const sourceRef = storage.ref(sourceDirectory);
    console.log("sourceRef", sourceRef);
    // Get a list of files in the source directory
    const files = await sourceRef.listAll();
    console.log("all  files", files);
    // Iterate through the files and copy them to the destination directory

    await Promise.all(
      files.items.map(async (file) => {
        const fileData = await file.getDownloadURL();
        const destinationPath = `${destinationDirectory}${file.name}`;
        const destinationRef = storage.ref().child(destinationPath);

        // Upload the file to the destination location
        await fetch(fileData)
          .then((response) => response.blob())
          .then((blob) => destinationRef.put(blob));
      }),
    );

    console.log("Files copied successfully.");
  } catch (error) {
    console.log("CATCH ERROR", error);
  }
};

export const fixCopy = async () => {
  await copyFolderFiles(
    `0a2de5a3ffef41ea88f98f57d7d894a5/`,
    `cb61010304b442958130b5cd74798438/`,
  );
  console.log("AFTER COPY");
  //await copyFolderFiles(`0a2de5a3ffef41ea88f98f57d7d894a5/`, `0a2de5a3ffef41ea88f98f57d7d894a5/`);
};

export const dupTour = function (tour, with_media = false) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const tId = getUUID();
      console.log("new tour ID", tId);
      let dup_tour = JSON.parse(JSON.stringify(tour));
      dup_tour.id = tId;
      dup_tour.title = `${tour.title}-DUPLICATED`;
      //for JapanTuri
      dup_tour.language = `English`;
      if (!with_media) {
        dup_tour.stops.map((stop, s_idx) => {
          dup_tour.stops[s_idx].all_media = [];
          dup_tour.stops[s_idx].loc_pics = [];
        });

        //dup_tour.all_media = stop.all_media.filter(media => media.type.includes('video') || media.type.includes('audio') || media.type.includes('pic') )
        dup_tour.starting_video = "";
        dup_tour.starting_name = "";
        dup_tour.all_media = [];
        dup_tour.tour_image = "";
        dup_tour.tour_image_obj = {};
        dup_tour.tour_guide.profile_image = "";
      } else {
        console.log(
          "starting copy files",
          `from ${tour.id}/ to: ${dup_tour.id}/`,
        );
        await copyFolderFiles(`${tour.id}/`, `${dup_tour.id}/`);
        console.log("after copy files");

        if (tour.all_media) {
          tour.all_media.map(async (media, m_idx) => {
            if (media.url)
              await storage
                .ref(`${dup_tour.id}/${media.name}`)
                .getDownloadURL()
                .then((url) => (dup_tour.all_media[m_idx].url = url))
                .catch((err) => {
                  dup_tour.all_media[m_idx].url = "";
                });
          });
        }

        if (dup_tour.stops)
          dup_tour.stops.map(async (stop, s_idx) => {
            if (stop.all_media)
              stop.all_media.map(async (media, mediaIdx) => {
                if (media.url) {
                  console.log(`ref media ${dup_tour.id}/${media.name}`);
                  await storage
                    .ref(`${dup_tour.id}/${media.name}`)
                    .getDownloadURL()
                    .then(
                      (url) =>
                        (dup_tour.stops[s_idx].all_media[mediaIdx].url = url),
                    )
                    .catch((err) => {
                      dup_tour.stops[s_idx].all_media[mediaIdx].url = "";
                    });
                }
              }); //all_media loop

            if (stop.loc_pics && stop.loc_pics[0]) {
              console.log(
                `ref loc_pic ${dup_tour.id}/${stop.loc_pics[0].name}`,
              );
              await storage
                .ref(`${dup_tour.id}/${stop.loc_pics[0].name}`)
                .getDownloadURL()
                .then((url) => (dup_tour.stops[s_idx].loc_pics[0].url = url))
                .catch((err) => (dup_tour.stops[s_idx].loc_pics[0].url = ""));
            }
          }); //stops loop

        if (dup_tour.starting_name) {
          console.log(
            `ref tour_image_obj ${dup_tour.id}/${dup_tour.starting_name}`,
          );
          await storage
            .ref(`${dup_tour.id}/${dup_tour.starting_name}`)
            .getDownloadURL()
            .then((url) => (dup_tour.starting_video = url))
            .catch((err) => (dup_tour.starting_video = ""));
        }

        if (dup_tour.tour_image_obj && dup_tour.tour_image_obj.name) {
          console.log(
            `ref starting_name ${dup_tour.id}/${dup_tour.tour_image_obj.name}`,
          );
          await storage
            .ref(`${dup_tour.id}/${dup_tour.tour_image_obj.name}`)
            .getDownloadURL()
            .then((url) => {
              dup_tour.tour_image_obj.url = url;
              dup_tour.tour_image = url;
            })
            .catch((err) => (dup_tour.tour_image_obj.url = ""));
        }
        dup_tour.tour_guide.profile_image = "";
      }
      console.log("dup_tour", dup_tour);
      console.log("tour", tour);
      setTimeout(() => {
        firebase
          .firestore()
          .collection("tours")
          .doc(dup_tour.id)
          .set(dup_tour, { merge: true })
          .then(() => {
            myResolve(dup_tour);
          })
          .catch((err) => {
            console.log("tour Approve ERROR!", err);
            myReject(err);
          });
      }, 2000);
      //response.then(resp => console.log("RESP", resp))
    } catch (error) {
      console.log("THRER IS AN ERROR", error);
    }
  });
};

export const getFileSize = function (tourID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      let sumVidSize = 0;
      let sumImgSize = 0;
      let sumAudioSize = 0;
      let totalFiles = 0;
      let processedFiles = 0;

      //https://europe-west6-tours-app-1579553856346.cloudfunctions.net/getAllAss
      console.log(
        "start",
        `https://europe-west6-tours-app-1579553856346.cloudfunctions.net/getAllAss?tourID=${tourID}`,
      );
      fetch(
        `https://europe-west6-tours-app-1579553856346.cloudfunctions.net/getAllAss?tourID=${tourID}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => {
          console.log("response", response);
          return response.json();
        })
        .then((data) => {
          console.log("Total files to process:", data.length);
          totalFiles = data.length;

          if (totalFiles === 0) {
            myResolve({
              video: 0,
              image: 0,
              audio: 0,
              total: 0,
              totalFiles: 0,
            });
            return;
          }

          data.map((url) => {
            try {
              let fileRef = ref(storage, url);
              getMetadata(fileRef)
                .then((metadata) => {
                  // Convert bytes to MB
                  const sizeInMB = metadata.size / 1048576;

                  // Categorize files based on content type
                  if (metadata.contentType.includes("video")) {
                    sumVidSize += sizeInMB;
                    console.log(
                      "📹 Video file:",
                      url,
                      sizeInMB.toFixed(2),
                      "MB",
                    );
                  } else if (metadata.contentType.includes("image")) {
                    sumImgSize += sizeInMB;
                    console.log(
                      "🖼️ Image file:",
                      url,
                      sizeInMB.toFixed(2),
                      "MB",
                    );
                  } else if (metadata.contentType.includes("audio")) {
                    sumAudioSize += sizeInMB;
                    console.log(
                      "🎵 Audio file:",
                      url,
                      sizeInMB.toFixed(2),
                      "MB",
                    );
                  } else {
                    // For unknown types, classify by file extension
                    const urlLower = url.toLowerCase();
                    if (
                      urlLower.includes(".mp4") ||
                      urlLower.includes(".avi") ||
                      urlLower.includes(".mov") ||
                      urlLower.includes(".webm")
                    ) {
                      sumVidSize += sizeInMB;
                      console.log(
                        "📹 Video file (by extension):",
                        url,
                        sizeInMB.toFixed(2),
                        "MB",
                      );
                    } else if (
                      urlLower.includes(".jpg") ||
                      urlLower.includes(".jpeg") ||
                      urlLower.includes(".png") ||
                      urlLower.includes(".webp") ||
                      urlLower.includes(".avif")
                    ) {
                      sumImgSize += sizeInMB;
                      console.log(
                        "🖼️ Image file (by extension):",
                        url,
                        sizeInMB.toFixed(2),
                        "MB",
                      );
                    } else if (
                      urlLower.includes(".mp3") ||
                      urlLower.includes(".wav") ||
                      urlLower.includes(".ogg") ||
                      urlLower.includes(".m4a")
                    ) {
                      sumAudioSize += sizeInMB;
                      console.log(
                        "🎵 Audio file (by extension):",
                        url,
                        sizeInMB.toFixed(2),
                        "MB",
                      );
                    } else {
                      // Default to image for unknown types
                      sumImgSize += sizeInMB;
                      console.log(
                        "❓ Unknown type (classified as image):",
                        url,
                        sizeInMB.toFixed(2),
                        "MB",
                      );
                    }
                  }

                  processedFiles++;

                  // Check if all files have been processed
                  if (processedFiles === totalFiles) {
                    const result = {
                      video: Math.round(sumVidSize * 100) / 100, // Round to 2 decimal places
                      image: Math.round(sumImgSize * 100) / 100,
                      audio: Math.round(sumAudioSize * 100) / 100,
                      total:
                        Math.round(
                          (sumVidSize + sumImgSize + sumAudioSize) * 100,
                        ) / 100,
                      totalFiles: totalFiles,
                    };

                    console.log("📊 Final file size summary:", result);
                    myResolve(result);
                  }
                })
                .catch((error) => {
                  // Uh-oh, an error occurred!
                  console.log("metadata error:", error, url);
                  processedFiles++;

                  // Still check if all files have been processed
                  if (processedFiles === totalFiles) {
                    const result = {
                      video: Math.round(sumVidSize * 100) / 100,
                      image: Math.round(sumImgSize * 100) / 100,
                      audio: Math.round(sumAudioSize * 100) / 100,
                      total:
                        Math.round(
                          (sumVidSize + sumImgSize + sumAudioSize) * 100,
                        ) / 100,
                      totalFiles: totalFiles,
                    };

                    console.log(
                      "📊 Final file size summary (with errors):",
                      result,
                    );
                    myResolve(result);
                  }
                });
            } catch (err) {
              console.log("ref error:", err, url);
              processedFiles++;

              // Still check if all files have been processed
              if (processedFiles === totalFiles) {
                const result = {
                  video: Math.round(sumVidSize * 100) / 100,
                  image: Math.round(sumImgSize * 100) / 100,
                  audio: Math.round(sumAudioSize * 100) / 100,
                  total:
                    Math.round((sumVidSize + sumImgSize + sumAudioSize) * 100) /
                    100,
                  totalFiles: totalFiles,
                };

                console.log(
                  "📊 Final file size summary (with ref errors):",
                  result,
                );
                myResolve(result);
              }
            }
          });
        })
        .catch((err) => {
          console.log("err in json()", err);
          myReject(err);
        });

      // const response = await fetch('https://api.npms.io/v2/search?q=react');
      //const data = await response.json();
      //this.setState({ totalReactPackages: data.total })
    } catch (error) {
      console.log("THERE IS AN ERROR", error);
      myReject(error);
    }
  });
};

const getFileStorageUrl = function (
  folderID,
  secondFolderID,
  fileName,
  type,
  subFolder,
  skipAvif = false,
) {
  return new Promise(async function (myResolve, myReject) {
    console.log("getFileStorageUrl -", skipAvif ? "Skipping AVIF (quality mode)" : "checking for AVIF optimization");
    try {
      // First, try to find AVIF version for images
      if (
        !skipAvif &&
        (type === "jpg" ||
        type === "jpeg" ||
        type === "png" ||
        type === "image")
      ) {
        console.log(`Checking for AVIF version of ${fileName}`);
        const avifFileName = fileName.replace("_resize", "_avif.avif");

        // Try AVIF in primary folder
        try {
          console.log(`Trying to find AVIF ref: ${folderID}/${avifFileName}`);
          let avifFileRef = storage.ref(`${folderID}/${avifFileName}`);
          const avifUrl = await avifFileRef.getDownloadURL();
          console.log(`✅ Found AVIF file: ${avifFileName}`);
          myResolve(avifUrl);
          return;
        } catch (avifError) {
          console.log(`❌ AVIF not found in primary location: ${avifFileName}`);

          // Try AVIF in secondary folder if provided
          if (secondFolderID) {
            try {
              let avifFileRef = storage.ref(
                subFolder
                  ? `${secondFolderID}/${subFolder}/${avifFileName}`
                  : `${secondFolderID}/${avifFileName}`,
              );
              const avifUrl = await avifFileRef.getDownloadURL();
              console.log(
                `✅ Found AVIF file in secondary location: ${avifFileName}`,
              );
              myResolve(avifUrl);
              return;
            } catch (secondaryAvifError) {
              console.log(
                `❌ AVIF not found in secondary location: ${avifFileName}`,
              );
            }
          }
        }
        console.log(`Falling back to standard formats for: ${fileName}`);
      }

      // Original logic - try the provided fileName first
      let compressFileRef = storage.ref(`${folderID}/${fileName}.${type}`);
      //console.log("TRYING", `${folderID}/${fileName}.${type}`, compressFileRef)
      //console.log("TRYING", `${folderID}/${fileName}`, compressFileRef);
      await compressFileRef
        .getDownloadURL()
        .then((url) => {
          myResolve(url);
        })
        .catch(async (error) => {
          compressFileRef = storage.ref(`${folderID}/${fileName}`);
          await compressFileRef
            .getDownloadURL()
            .then((url) => {
              myResolve(url);
            })
            .catch(async (error) => {
              let compressFileRef = storage.ref(
                `${folderID}/${subFolder}/${fileName}.${type}`,
              );
              console.log(
                "TRYING",
                `${folderID}/${subFolder}/${fileName}.${type}`,
                compressFileRef,
              );
              await compressFileRef
                .getDownloadURL()
                .then((url) => {
                  myResolve(url);
                })
                .catch(async (error) => {
                  if (secondFolderID === null) {
                    if (error.code === "storage/object-not-found")
                      myReject("storage/object-not-found");
                    else myReject("false");
                  }
                  compressFileRef = storage.ref(
                    `${secondFolderID}/${subFolder}/${fileName}.${type}`,
                  );
                  await compressFileRef
                    .getDownloadURL()
                    .then((url) => {
                      myResolve(url);
                    })
                    .catch(async (error) => {
                      compressFileRef = storage.ref(
                        `${secondFolderID}/${subFolder}/${fileName}`,
                      );
                      await compressFileRef
                        .getDownloadURL()
                        .then((url) => {
                          myResolve(url);
                        })
                        .catch(async (error) => {
                          if (error.code === "storage/object-not-found")
                            myReject("storage/object-not-found");
                        });
                    });
                });
            });
        });
    } catch (error) {
      console.log("GENERAL ERROR", error);
      myReject("false");
    }
  });
};

// Helper function to get file with format info
const getFileStorageUrlWithFormat = function (
  folderID,
  secondFolderID,
  fileName,
  type,
  subFolder,
  qualityMode = "standard",
) {
  return new Promise(async function (myResolve, myReject) {
    const qualityLabels = {
      standard: "STANDARD MODE (AVIF)",
      high: "HIGH QUALITY MODE (Resize JPG)",
      original: "ORIGINAL QUALITY MODE (Uncompressed)"
    };
    console.log(
      "🔍 getFileStorageUrlWithFormat -",
      qualityLabels[qualityMode] || qualityLabels.standard
    );
    try {
      // Use original uncompressed images if original mode
      if (qualityMode === "original") {
        console.log(`🌟 Original quality mode: Using original uncompressed image for ${fileName}`);
        // Remove _resize suffix to get original filename
        const originalFileName = fileName.replace("_resize", "");
        return getFileStorageUrl(
          folderID,
          secondFolderID,
          originalFileName,
          type,
          subFolder,
          true,
        )
          .then((url) => {
            myResolve({
              url: url,
              fileName: originalFileName,
              format: type,
              isOptimized: false,
            });
          })
          .catch((error) => {
            myReject(error);
          });
      }

      // Skip AVIF detection if high quality mode is enabled
      if (qualityMode === "high") {
        console.log(`💎 High quality mode: Skipping AVIF, using resize JPG for ${fileName}`);
        return getFileStorageUrl(
          folderID,
          secondFolderID,
          fileName,
          type,
          subFolder,
          true,
        )
          .then((url) => {
            myResolve({
              url: url,
              fileName: fileName,
              format: type,
              isOptimized: false,
            });
          })
          .catch((error) => {
            myReject(error);
          });
      }

      // First, try to find AVIF version for images (standard mode)
      if (
        type === "jpg" ||
        type === "jpeg" ||
        type === "png" ||
        type === "image"
      ) {
        console.log(`📝 Checking for AVIF version of ${fileName}`);
        const baseFileName = fileName.replace("_resize", "");
        const avifFileName = `${baseFileName}_avif.avif`;

        // Try AVIF in primary folder with subfolder
        if (subFolder) {
          const primarySubfolderPath = `${folderID}/${subFolder}/${avifFileName}`;
          try {
            console.log(
              `🔍 Trying PRIMARY with subfolder: ${primarySubfolderPath}`,
            );
            let avifFileRef = storage.ref(primarySubfolderPath);
            const avifUrl = await avifFileRef.getDownloadURL();
            console.log(
              `✅ Found AVIF file in primary subfolder: ${avifFileName}`,
            );
            myResolve({
              url: avifUrl,
              fileName: avifFileName,
              format: "avif",
              isOptimized: true,
            });
            return;
          } catch (avifError) {
            console.log(
              `❌ AVIF not found in primary subfolder: ${primarySubfolderPath}`,
            );
          }
        }

        // Try AVIF in primary folder without subfolder
        const primaryRootPath = `${folderID}/${avifFileName}`;
        try {
          console.log(`🔍 Trying PRIMARY root folder: ${primaryRootPath}`);
          let avifFileRef = storage.ref(primaryRootPath);
          const avifUrl = await avifFileRef.getDownloadURL();
          console.log(`✅ Found AVIF file in primary root: ${avifFileName}`);
          myResolve({
            url: avifUrl,
            fileName: avifFileName,
            format: "avif",
            isOptimized: true,
          });
          return;
        } catch (avifError) {
          console.log(`❌ AVIF not found in primary root: ${primaryRootPath}`);

          // Try AVIF in secondary folder if provided
          if (secondFolderID) {
            // Try secondary with subfolder
            if (subFolder) {
              const secondarySubfolderPath = `${secondFolderID}/${subFolder}/${avifFileName}`;
              try {
                console.log(
                  `🔍 Trying SECONDARY with subfolder: ${secondarySubfolderPath}`,
                );
                let avifFileRef = storage.ref(secondarySubfolderPath);
                const avifUrl = await avifFileRef.getDownloadURL();
                console.log(
                  `✅ Found AVIF file in secondary subfolder: ${avifFileName}`,
                );
                myResolve({
                  url: avifUrl,
                  fileName: avifFileName,
                  format: "avif",
                  isOptimized: true,
                });
                return;
              } catch (secondaryAvifError) {
                console.log(
                  `❌ AVIF not found in secondary subfolder: ${secondarySubfolderPath}`,
                );
              }
            }

            // Try secondary without subfolder
            const secondaryRootPath = `${secondFolderID}/${avifFileName}`;
            try {
              console.log(
                `🔍 Trying SECONDARY root folder: ${secondaryRootPath}`,
              );
              let avifFileRef = storage.ref(secondaryRootPath);
              const avifUrl = await avifFileRef.getDownloadURL();
              console.log(
                `✅ Found AVIF file in secondary root: ${avifFileName}`,
              );
              myResolve({
                url: avifUrl,
                fileName: avifFileName,
                format: "avif",
                isOptimized: true,
              });
              return;
            } catch (secondaryAvifError) {
              console.log(
                `❌ AVIF not found in secondary root: ${secondaryRootPath}`,
              );
            }
          }
        }
        console.log(`💭 Falling back to standard formats for: ${fileName}`);
      }

      // Fallback to original getFileStorageUrl logic
      console.log(`🔄 Using standard file retrieval for: ${fileName}`);
      return getFileStorageUrl(
        folderID,
        secondFolderID,
        fileName,
        type,
        subFolder,
        false,
      )
        .then((url) => {
          myResolve({
            url: url,
            fileName: fileName,
            format: type,
            isOptimized: false,
          });
        })
        .catch((error) => {
          myReject(error);
        });
    } catch (error) {
      console.log("GENERAL ERROR in getFileStorageUrlWithFormat", error);
      myReject(error);
    }
  });
};

import pako from "pako";
const compressHTML = function (html) {
  return new Promise(async function (myResolve, myReject) {
    try {
      const compressed = pako.gzip(html, { to: "string" });
      myResolve(compressed);
    } catch (error) {
      console.log("GENERAL ERROR", error);
      myReject("false");
    }
  });
};

// Example function to fix button links in your content
function fixButtonLinks(content) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");

  // Find all <button> elements
  const buttons = doc.querySelectorAll("button");
  buttons.forEach((button) => {
    const onClickAttr = button.getAttribute("onclick");
    // Look for window.open('...') in the onclick
    const match =
      onClickAttr && onClickAttr.match(/window\.open\(['"](.*?)['"]\)/);
    if (match && match[1]) {
      let link = match[1];
      // If link does not start with http:// or https://, prepend https://
      if (!/^https?:\/\//i.test(link)) {
        link = `https://${link}`;
        // Update onclick with the corrected link
        const updatedOnClick = onClickAttr.replace(match[1], link);
        button.setAttribute("onclick", updatedOnClick);
      }
    }
  });

  // Return the updated HTML string
  return doc.body.innerHTML;
}

function cleanHtmlStylesAsync(html) {
  return new Promise((resolve) => {
    let cleanedHtml = html;

    // ── Step 1: Remove only the font-family from style attributes ──
    cleanedHtml = cleanedHtml.replace(/style="[^"]*"/gi, (styleAttr) => {
      const newStyle = styleAttr
        .replace(/font-family:[^;"]*;?/gi, "") // remove font-family
        .replace(/style="\s*;*\s*"/gi, "") // remove empty style=""
        .trim();
      return newStyle === 'style=""' || newStyle === "" ? "" : newStyle;
    });

    // ── Step 2: Remove <span> tags with no attributes ──
    cleanedHtml = cleanedHtml.replace(/<span>\s*([^<]*)\s*<\/span>/gi, "$1");

    // ── Step 3: Add border-radius if missing ──
    if (!cleanedHtml.includes("border-radius")) {
      cleanedHtml = cleanedHtml.replace(
        /style\s*=\s*"(.*?)"/gi,
        (match, styleContent) => {
          return `style="${styleContent
            .trim()
            .replace(/;*$/, "")}; border-radius: 15px;"`;
        },
      );
    }

    resolve(cleanedHtml);
  });
}

function addBorderRadiusIfMissing(html) {
  // Quick check if 'border-radius' is anywhere in the string
  if (html.includes("border-radius")) {
    // Already present, do nothing
    return html;
  }

  // Otherwise, find 'style="...' and inject border-radius.
  // We'll do a naive approach: look for style="some styles"
  // and append ' border-radius: 25px;' before the closing quote.
  const updatedHtml = html.replace(
    /style\s*=\s*"(.*?)"/gi, // capture all inline styles
    (match, styleContent) => {
      // Insert our border-radius property at the end of existing inline styles
      return `style="${styleContent}; border-radius: 15px;"`;
    },
  );

  return updatedHtml;
}

function convertFaIconName(iconName) {
  // Remove leading "fa"
  let name = iconName.replace(/^fa/, "");

  // Insert a dash before each uppercase letter, then convert it to lower case
  name = name.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`);

  // Remove any leading dash (if the original name after "fa" started with uppercase)
  name = name.replace(/^-/, "");

  return name;
}

const title_slider = {
  english: "Stop",
  hebrew: "תחנה",
  french: "Arrêt",
  portuguese: "Parada",
  spanish: "Parada",
  german: "Halt",
  japanese: "停留所",
  korean: "정류장",
  russian: "Остановка",
};

// Icon label translations for consistent multilingual support
const iconLabels = {
  Business: {
    English: "Business",
    Hebrew: "עסק",
    Spanish: "Negocio",
    French: "Entreprise",
    Portuguese: "Negócio",
  },
  Featured: {
    English: "Featured",
    Hebrew: "מומלץ",
    Spanish: "Destacado",
    French: "En vedette",
    Portuguese: "Destaque",
  },
  Restroom: {
    English: "Restroom",
    Hebrew: "שירותים",
    Spanish: "Baño",
    French: "Toilettes",
    Portuguese: "Banheiro",
  },
  Water: {
    English: "Water",
    Hebrew: "מים",
    Spanish: "Agua",
    French: "Eau",
    Portuguese: "Água",
  },
  "No Entry": {
    English: "No Entry",
    Hebrew: "אסור כניסה",
    Spanish: "Prohibido entrar",
    French: "Entrée interdite",
    Portuguese: "Entrada proibida",
  },
  Coffee: {
    English: "Coffee",
    Hebrew: "קפה",
    Spanish: "Café",
    French: "Café",
    Portuguese: "Café",
  },
  Hospital: {
    English: "Hospital",
    Hebrew: "בית חולים",
    Spanish: "Hospital",
    French: "Hôpital",
    Portuguese: "Hospital",
  },
  "Street Food": {
    English: "Street Food",
    Hebrew: "אוכל רחוב",
    Spanish: "Comida callejera",
    French: "Cuisine de rue",
    Portuguese: "Comida de rua",
  },
  "Local Business": {
    English: "Local Business",
    Hebrew: "עסק מקומי",
    Spanish: "Negocio local",
    French: "Commerce local",
    Portuguese: "Negócio local",
  },
  Restaurant: {
    English: "Restaurant",
    Hebrew: "מסעדה",
    Spanish: "Restaurante",
    French: "Restaurant",
    Portuguese: "Restaurante",
  },
  Shopping: {
    English: "Shopping",
    Hebrew: "קניות",
    Spanish: "Compras",
    French: "Shopping",
    Portuguese: "Compras",
  },
  "Point of Interest": {
    English: "Point of Interest",
    Hebrew: "נקודת עניין",
    Spanish: "Punto de interés",
    French: "Point d'intérêt",
    Portuguese: "Ponto de interesse",
  },
};

/**
 * Get translated icon label based on language
 * @param {string} labelKey - The icon label in English (e.g., "Shopping", "Restaurant")
 * @param {string} language - Target language (e.g., "English", "Hebrew", "Spanish")
 * @returns {string} - Translated label or original if not found
 */
const getTranslatedIconLabel = (labelKey, language) => {
  if (iconLabels[labelKey] && iconLabels[labelKey][language]) {
    return iconLabels[labelKey][language];
  }
  // Fallback to original label if translation not found
  return labelKey;
};

function convertToStickyButton(htmlContent) {
  if (!htmlContent || typeof htmlContent !== "string") {
    return htmlContent;
  }

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const buttons = doc.querySelectorAll("button");

    if (!buttons.length) {
      return htmlContent;
    }

    const normalizeLink = (rawLink) => {
      if (!rawLink || typeof rawLink !== "string") {
        return "";
      }

      const trimmed = rawLink.trim();
      if (!trimmed) {
        return "";
      }

      const hasScheme = /^https?:\/\//i.test(trimmed);
      return hasScheme ? trimmed : `https://${trimmed}`;
    };

    const parseColorFromStyle = (styleText) => {
      if (!styleText || typeof styleText !== "string") {
        return "";
      }

      const bgColorMatch = styleText.match(/background-color\s*:\s*([^;]+)/i);
      if (bgColorMatch?.[1]) {
        return bgColorMatch[1].trim().replace(/['"]/g, "");
      }

      const bgMatch = styleText.match(/background\s*:\s*([^;]+)/i);
      if (bgMatch?.[1]) {
        return bgMatch[1].trim().replace(/['"]/g, "");
      }

      return "";
    };

    const parseTextColorFromStyle = (styleText) => {
      if (!styleText || typeof styleText !== "string") {
        return "";
      }

      const colorMatch = styleText.match(/(?:^|;)\s*color\s*:\s*([^;]+)/i);
      return colorMatch?.[1]
        ? colorMatch[1].trim().replace(/['"]/g, "")
        : "";
    };

    buttons.forEach((button) => {
      if (!button || button.closest('[data-sticky-cta="true"]')) {
        return;
      }

      const parentAnchor = button.closest("a[href]");
      const onclick = button.getAttribute("onclick") || "";

      let link = "";
      const match = onclick.match(/window\.open\(['"]([^'"]+)['"]/i);
      if (match?.[1]) {
        link = match[1];
      }
      if (!link && parentAnchor) {
        link = parentAnchor.getAttribute("href") || "";
      }

      const cleanLink = normalizeLink(link);
      if (!cleanLink) {
        return;
      }

      const sourceStyle = button.getAttribute("style") || "";
      const userBackgroundColor = parseColorFromStyle(sourceStyle) || "#D25529";
      const userTextColor = parseTextColorFromStyle(sourceStyle) || "#ffffff";

      const stickyWrapper = doc.createElement("div");
      stickyWrapper.setAttribute("data-sticky-cta", "true");
      stickyWrapper.setAttribute(
        "style",
        "position: sticky; bottom: 16px; left: 0; right: 0; z-index: 100; margin: 16px auto 0; width: clamp(280px, 80vw, 416px);",
      );

      const stickyAnchor = doc.createElement("a");
      stickyAnchor.setAttribute("href", cleanLink);
      stickyAnchor.setAttribute("target", "_blank");
      stickyAnchor.setAttribute("rel", "noopener noreferrer");
      stickyAnchor.setAttribute(
        "style",
        `display: flex; flex-direction: row; justify-content: center; align-items: center; padding: 16px 32px; gap: 8px; margin: 0 auto; width: 100%; height: 48px; background: ${userBackgroundColor}; border-radius: 24px; color: ${userTextColor}; text-decoration: none; box-sizing: border-box; font-weight: 600;`,
      );
      stickyAnchor.innerHTML = button.innerHTML;

      stickyWrapper.appendChild(stickyAnchor);

      const replaceTarget = parentAnchor || button;
      replaceTarget.replaceWith(stickyWrapper);
    });

    return doc.body.innerHTML;
  } catch (error) {
    console.warn("convertToStickyButton fallback due to parsing error", error);
    return htmlContent;
  }
}

// ===================== HELPER FUNCTIONS FOR PROMISE APPROVE TOUR =====================

/**
 * Migrate legacy type-based icon system to new stop.icon system
 * Old system: stop type determined the icon (e.g., type="restaurant" showed restaurant icon)
 * New system: stop.icon explicitly sets the icon, types are more semantic
 *
 * @param {Object} stop - The stop object to migrate
 * @returns {Object} - Migrated stop with icon set and type normalized
 */
const migrateLegacyStopType = (stop) => {
  // Map of legacy types to their icon equivalents
  const legacyTypeToIcon = {
    business: { name: "shop", label: "Business" },
    starStop: { name: "star", label: "Featured" },
    WCStop: { name: "restroom-simple", label: "Restroom" },
    waterStop: { name: "faucet-drip", label: "Water" },
    noEntrance: { name: "ban", label: "No Entry" },
    coffee: { name: "mug-hot", label: "Coffee" },
    hospital: { name: "bed", label: "Hospital" },
    streetFood: { name: "smile", label: "Street Food" },
    localBusiness: { name: "shop", label: "Local Business" },
    restaurant: { name: "utensils", label: "Restaurant" },
    shoppingCenter: { name: "shopping-cart", label: "Shopping" },
    smallStop: { name: "lightbulb", label: "Point of Interest" },
  };

  // If stop already has an explicit icon, don't migrate
  if (stop.icon && typeof stop.icon === "object" && stop.icon.name) {
    return stop;
  }

  // Check if this is a legacy type that needs migration
  if (legacyTypeToIcon[stop.type]) {
    console.log(`🔄 Migrating legacy stop type "${stop.type}" to icon system`);

    // Set the icon based on the old type
    stop.icon = legacyTypeToIcon[stop.type];

    // Convert type to smallStop (these were all special small stops)
    stop.type = "smallStop";
  }

  return stop;
};

/**
 * Normalize hours_range to standard format: {min: "HH:mm", max: "HH:mm"}
 * Handles legacy formats:
 * - Weekly minutes: {min: 5040, max: 9720} → extracts time-of-day only
 * - Daily seconds: {min: 43200, max: 64800} → converts to time strings
 * - String format: "10:00-22:00" → converts to object
 * - Already formatted: {min: "12:00", max: "18:00"} → returns as-is
 *
 * @param {Object|string} hoursRange - The hours_range value to normalize
 * @returns {Object|null} - Normalized {min: "HH:mm", max: "HH:mm"} or null if invalid
 */
const normalizeHoursRange = (hoursRange) => {
  // Helper to format time as HH:mm
  const formatTime = (hours, minutes) => {
    const h = String(Math.floor(hours)).padStart(2, "0");
    const m = String(Math.floor(minutes)).padStart(2, "0");
    return `${h}:${m}`;
  };

  // Handle null/undefined
  if (!hoursRange) return null;

  // If already a string like "10:00-22:00", convert to object
  if (typeof hoursRange === "string") {
    const match = hoursRange.match(/^(\d{1,2}:\d{2})-(\d{1,2}:\d{2})$/);
    if (match) {
      return { min: match[1], max: match[2] };
    }
    console.warn("Invalid hours_range string format:", hoursRange);
    return null;
  }

  // Handle object format
  if (
    typeof hoursRange === "object" &&
    hoursRange.min !== undefined &&
    hoursRange.max !== undefined
  ) {
    const { min, max } = hoursRange;

    // Already in correct format (strings)
    if (typeof min === "string" && typeof max === "string") {
      return { min, max };
    }

    // Handle numeric values
    if (typeof min === "number" && typeof max === "number") {
      // Detect format by value range
      // Weekly minutes: typically 5040-9720 (84-162 hours from week start)
      // Daily seconds: typically 43200-64800 (12:00-18:00 in seconds)

      if (min > 1440 || max > 1440) {
        // Weekly minutes format (1440 = 24 hours * 60 minutes)
        console.log(
          `Converting legacy weekly-minutes format: {min: ${min}, max: ${max}}`,
        );

        // Extract time-of-day by taking modulo 24 hours
        const minHours = Math.floor((min / 60) % 24);
        const minMinutes = min % 60;
        const maxHours = Math.floor((max / 60) % 24);
        const maxMinutes = max % 60;

        const result = {
          min: formatTime(minHours, minMinutes),
          max: formatTime(maxHours, maxMinutes),
        };
        console.log(`Extracted time-of-day: ${JSON.stringify(result)}`);
        return result;
      } else if (min > 59 || max > 59) {
        // Daily seconds format (59 seconds is max for minutes)
        const minHours = Math.floor(min / 3600);
        const minMinutes = Math.floor((min % 3600) / 60);
        const maxHours = Math.floor(max / 3600);
        const maxMinutes = Math.floor((max % 3600) / 60);

        return {
          min: formatTime(minHours, minMinutes),
          max: formatTime(maxHours, maxMinutes),
        };
      } else {
        // Ambiguous - could be hours (0-23) but this is uncertain
        console.warn(
          "Ambiguous hours_range format (numbers 0-59):",
          hoursRange,
        );
        console.warn(
          "Cannot determine if values represent hours or other unit. Removing field.",
        );
        return null;
      }
    }
  }

  console.warn("Invalid hours_range format:", hoursRange);
  return null;
};

/**
 * Validate that smallStop has at least one image in loc_pics or all_media
 * If one array has an image but the other doesn't, copy the image to the empty array
 * @param {Object} stop - The stop object to validate
 * @returns {Object} - The validated stop with images copied if needed
 */
const validateSmallStopImages = (stop) => {
  // Only validate smallStop types
  if (stop.type !== "smallStop") {
    return stop;
  }

  // Check if loc_pics has at least one image
  const hasLocPicsImage =
    stop.loc_pics &&
    Array.isArray(stop.loc_pics) &&
    stop.loc_pics.some((pic) => pic.type && pic.type.includes("image"));

  // Check if all_media has at least one image
  const hasAllMediaImage =
    stop.all_media &&
    Array.isArray(stop.all_media) &&
    stop.all_media.some((media) => media.type && media.type.includes("image"));

  // If validation fails (at least one doesn't have an image)
  if (!hasLocPicsImage || !hasAllMediaImage) {
    // If loc_pics has image but all_media doesn't, copy to all_media
    if (hasLocPicsImage && !hasAllMediaImage) {
      const imageFromLocPics = stop.loc_pics.find(
        (pic) => pic.type && pic.type.includes("image"),
      );
      if (imageFromLocPics) {
        console.log(
          `📋 Copying image from loc_pics to all_media for smallStop: ${stop.s_title}`,
        );
        stop.all_media = stop.all_media || [];
        stop.all_media.push({
          ...imageFromLocPics,
          order: stop.all_media.length,
        });
      }
    } else if (hasAllMediaImage && !hasLocPicsImage) {
      // If all_media has image but loc_pics doesn't, copy to loc_pics
      const imageFromAllMedia = stop.all_media.find(
        (media) => media.type && media.type.includes("image"),
      );
      if (imageFromAllMedia) {
        console.log(
          `📋 Copying image from all_media to loc_pics for smallStop: ${stop.s_title}`,
        );
        stop.loc_pics = stop.loc_pics || [];
        stop.loc_pics.push({
          ...imageFromAllMedia,
          order: stop.loc_pics.length,
        });
      }
    }
    // If both don't have images, skip (do nothing)
  }

  return stop;
};

const validateTour = (tour) => {
  if (tour.stops.length < 2) {
    throw new Error(
      "Tour must include at least 2 stops.\n Please add stops before trying the demo.",
    );
  }
  if (!tour.title) {
    throw new Error(
      "Tour must include a title.\n Please fill in the basic details of the tour.",
    );
  }
};

const setupTourConfig = (tour) => {
  const approve_tour = JSON.parse(JSON.stringify(tour));

  // Remove UI-only fields
  delete approve_tour.neighboringStops;

  // Starting point
  if (approve_tour.stops[0] && approve_tour.stops[0].stop_location) {
    approve_tour.starting_point = {
      latitude: approve_tour.stops[0].stop_location["latitude"],
      longitude: approve_tour.stops[0].stop_location["longitude"],
    };
  }

  // Handle active_filter
  if (approve_tour.config?.active_filter) {
    approve_tour.config.active_filter =
      approve_tour.config.active_filter === "true" ||
      approve_tour.config.active_filter === true;
  }

  if (!approve_tour.language) approve_tour.language = "English";

  return approve_tour;
};

const processTourMedia = async (approve_tour, tourId) => {
  // Starting Media
  let startingMediaPromise = Promise.resolve();

  if (approve_tour.starting_name || approve_tour.starting_type) {
    if (approve_tour?.starting_type?.includes("image")) {
      console.log("starting_name", approve_tour.starting_name);
      startingMediaPromise = getFileStorageUrlWithFormat(
        tourId,
        null,
        `${approve_tour?.starting_name}_resize`,
        "jpg",
        null,
      )
        .then((result) => {
          approve_tour.starting_image = result.url;
          approve_tour.starting_name = result.fileName;
          console.log(
            `🎯 Using ${result.format} format for starting image (optimized: ${result.isOptimized})`,
          );
        })
        .catch((error) => {
          console.log(
            "DID NOT GET FUNCTION",
            `${tourId} starting_name_resize`,
            error,
          );
          approve_tour.starting_image = approve_tour.starting_url;
        });
    } else {
      startingMediaPromise = getFileStorageUrl(
        tourId,
        approve_tour.stops[0].id,
        `${approve_tour.starting_name}_compress`,
        "mp4",
        "toursMedia",
      )
        .then((resp) => {
          approve_tour.starting_video = resp;
          approve_tour.starting_url = resp;
          approve_tour.starting_name = `${approve_tour.starting_name}_compress`;
        })
        .catch((error) =>
          console.log(
            "DID NOT GET FUNCTION",
            `${tourId} ${approve_tour.starting_name}_compress`,
            error,
          ),
        );
    }
  } else {
    approve_tour.starting_video = null;
    approve_tour.starting_name = null;
  }

  // Profile Image
  let profileImagePromise = Promise.resolve();
  if (
    approve_tour.tour_guide.profile_image &&
    !approve_tour.tour_guide.profile_image.includes("lh3")
  ) {
    profileImagePromise = getFileStorageUrlWithFormat(
      tourId,
      null,
      `guideProfile_resize`,
      "jpg",
      null,
    )
      .then((result) => {
        approve_tour.tour_guide.profile_image = result.url;
        console.log(
          `🎯 Using ${result.format} format for profile image (optimized: ${result.isOptimized})`,
        );
      })
      .catch((error) =>
        console.log(
          "DID NOT GET FUNCTION",
          `${tourId} guideProfile_resize`,
          error,
        ),
      );
  } else {
    approve_tour.tour_guide.profile_image =
      "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/avatar-blank.png?alt=media&token=d33a1c38-6d60-4aa1-b7fa-9a324f6a03c4";
  }

  // All Media
  const mediaPromises = (approve_tour.all_media || []).map((media, idx) => {
    if (media.type.includes("video")) {
      return getFileStorageUrl(
        tourId,
        null,
        `${media.name}_compress`,
        "mp4",
        "toursMedia",
      )
        .then((resp) => {
          approve_tour.all_media[idx].url = resp;
          approve_tour.all_media[idx].name = `${media.name}_compress`;
        })
        .catch((error) => console.log("DID NOT GET FUNCTION", error));
    } else if (media.type.includes("image")) {
      return getFileStorageUrlWithFormat(
        tourId,
        null,
        `${media.name}_resize`,
        "jpg",
        "toursMedia",
      )
        .then((result) => {
          approve_tour.all_media[idx].url = result.url;
          approve_tour.all_media[idx].name = result.fileName;
          console.log(
            `🎯 Using ${result.format} format for media ${media.name} (optimized: ${result.isOptimized})`,
          );
        })
        .catch((error) => console.log("DID NOT GET FUNCTION", error));
    } else {
      return Promise.resolve();
    }
  });

  // Explanation Video
  if (approve_tour.language && approve_tour.language.includes("Hebrew")) {
    approve_tour.exp_video =
      "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/maslol_exp_he_compress.mp4?alt=media&token=cb0b7755-be31-4f55-9df6-42158bd4c1b0";
  } else {
    approve_tour.exp_video =
      "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/mexpo_vid.mp4?alt=media&token=a10b2584-6a4e-4a90-a02c-466ea06d02ad";
  }

  await Promise.all([
    startingMediaPromise,
    profileImagePromise,
    ...mediaPromises,
  ]);
};

const restructureStops = (stops) => {
  let newStops = [];
  let previousStop = null;

  for (let i = 0; i < stops.length; i++) {
    const currentStop = { ...stops[i] };

    // Set default direction_type
    if (i === 0) {
      currentStop.direction_type = "none";
    } else if (
      currentStop.direction_type === undefined ||
      currentStop.direction_type === "default"
    ) {
      currentStop.direction_type = "foot";
    }

    // Skip stops that don't need path processing
    if (!currentStop.include_path) {
      currentStop.order = newStops.length;
      newStops.push(currentStop);
      previousStop = currentStop;
      continue;
    }

    // Handle "none" direction type
    if (currentStop.direction_type === "none" && i > 0) {
      const routeEndStop = {
        direction_type: "none",
        stop_location: currentStop.stop_location,
        include_path: true,
        show_marker: false,
        order: newStops.length,
        show_on_slider: false,
        s_title: `Route End - ${currentStop.s_title}`,
      };
      newStops.push(routeEndStop);

      const nextStop = stops[i + 1];
      currentStop.direction_type = nextStop?.direction_type || "foot";
    } else if (
      i > 0 &&
      previousStop &&
      previousStop.direction_type !== "none" && // Prevent transition from "none" (first stop)
      previousStop.direction_type !== currentStop.direction_type
    ) {
      const routeTransitionStop = {
        direction_type: currentStop.direction_type,
        stop_location: previousStop.stop_location,
        include_path: true,
        show_marker: false,
        order: newStops.length,
        show_on_slider: false,
        s_title: `Route Transition - ${previousStop.s_title}`,
      };
      newStops.push(routeTransitionStop);
    }

    currentStop.order = newStops.length;
    newStops.push(currentStop);
    previousStop = currentStop;
  }
  return newStops;
};

// ==================== ELEVENLABS AUDIO GENERATION HELPERS ====================

/**
 * Strip SSML tags to get plain text (fallback if SSML validation fails)
 */
const ssmlToPlainText = (ssml) => {
  if (!ssml || typeof ssml !== "string") return "";
  return ssml.replace(/<[^>]*>/g, "").trim();
};

/**
 * Detect language from text content
 */
const detectLanguageFromText = (text) => {
  if (!text) return "en";

  // Hebrew detection - use ISO 639-1 code for ElevenLabs
  if (/[\u0590-\u05FF]/.test(text)) return "he";

  // Arabic detection
  if (/[\u0600-\u06FF]/.test(text)) return "ar";

  // Chinese detection
  if (/[\u4e00-\u9fff]/.test(text)) return "zh";

  // Russian detection
  if (/[\u0400-\u04FF]/.test(text)) return "ru";

  // Default to English for Latin script
  return "en";
};

/**
 * Generate ElevenLabs audio from SSML with fallback to plain text
 * @param {string} tourId - Tour ID for storage path
 * @param {string} stopId - Stop ID for file naming
 * @param {string} ssml - SSML content to generate audio from
 * @param {string} voiceId - ElevenLabs voice ID
 * @param {object} userAIData - User AI settings (voiceSettings, etc.)
 * @returns {Promise<string|null>} - Firebase Storage URL of generated audio, or null if failed
 */
export const generateElevenLabsAudio = async (
  tourId,
  stopId,
  ssml,
  voiceId,
  userAIData = {},
) => {
  try {
    console.log(`🎤 Generating ElevenLabs audio for stop ${stopId}`);

    // Prepare voice settings
    const baseSettings = {
      stability: 0.5,
      similarity_boost: 0.75,
    };

    const userSettings = userAIData?.voiceSettings || {};
    const voiceSettings = {
      ...baseSettings,
      ...userSettings,
      stability: [0.0, 0.5, 1.0].includes(userSettings.stability)
        ? userSettings.stability
        : 0.5,
    };

    // Detect language from SSML content
    const plainText = ssmlToPlainText(ssml);
    const languageCode = detectLanguageFromText(plainText);

    // Try with SSML first
    let audioData = null;
    let usedPlainText = false;

    try {
      const payload = {
        action: "synthesizeSpeechFromPrepared",
        voiceId: voiceId,
        preparedText: ssml,
        model_id: "eleven_v3",
        languageCode: languageCode, // ISO 639-3 format (heb, eng, ara, etc.)
        output_format: "mp3_44100_128",
        voice_settings: voiceSettings,
      };

      const response = await fetch(
        "https://europe-west10-tours-app-1579553856346.cloudfunctions.net/ElevenLabsAPI",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        audioData = await response.arrayBuffer();
        console.log(`✅ SSML audio generated successfully for stop ${stopId}`);
      } else {
        throw new Error(`ElevenLabs API returned ${response.status}`);
      }
    } catch (ssmlError) {
      console.warn(
        `⚠️ SSML generation failed for stop ${stopId}, trying plain text:`,
        ssmlError.message,
      );

      // Fallback to plain text
      try {
        const payload = {
          action: "synthesizeSpeechFromPrepared",
          voiceId: voiceId,
          preparedText: plainText,
          model_id: "eleven_v3",
          languageCode: languageCode, // ISO 639-3 format (heb, eng, ara, etc.)
          output_format: "mp3_44100_128",
          voice_settings: voiceSettings,
        };

        const response = await fetch(
          "https://europe-west10-tours-app-1579553856346.cloudfunctions.net/ElevenLabsAPI",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        if (response.ok) {
          audioData = await response.arrayBuffer();
          usedPlainText = true;
          console.log(
            `✅ Plain text audio generated successfully for stop ${stopId}`,
          );
        } else {
          throw new Error(
            `Plain text generation also failed: ${response.status}`,
          );
        }
      } catch (plainTextError) {
        console.error(
          `❌ Both SSML and plain text generation failed for stop ${stopId}:`,
          plainTextError,
        );
        return null;
      }
    }

    if (!audioData) {
      console.warn(`⚠️ No audio data generated for stop ${stopId}`);
      return null;
    }

    // Upload to Firebase Storage
    const timestamp = Date.now();
    const audioFileName = `${stopId}_elevenlabs_${timestamp}.mp3`;
    const storagePath = `${tourId}/audio/${audioFileName}`;

    const audioBlob = new Blob([audioData], { type: "audio/mpeg" });
    const storageRef = storage.ref(storagePath);

    await storageRef.put(audioBlob, { contentType: "audio/mpeg" });
    const audioUrl = await storageRef.getDownloadURL();

    console.log(
      `✅ Audio uploaded to Storage: ${storagePath}${
        usedPlainText ? " (plain text fallback)" : ""
      }`,
    );

    return audioUrl;
  } catch (error) {
    console.error(
      `❌ Error generating ElevenLabs audio for stop ${stopId}:`,
      error,
    );
    return null;
  }
};

const processStop = async (
  stop,
  idx,
  approve_tour,
  tourId,
  better_quality,
  counters,
) => {
  // Ensure defaults
  stop.all_media = stop.all_media || [];
  if (!stop.type) stop.type = "bigStop";

  // Apply Theme Data if theme_id exists
  if (stop.theme_id && approve_tour.config?.themes) {
    const theme = approve_tour.config.themes.find(
      (t) => t.id === stop.theme_id,
    );
    if (theme) {
      // Apply theme color to stop.config.color
      if (!stop.config) stop.config = {};
      stop.config.color = theme.color;

      // Apply theme slider_title (only if not manually overridden)
      if (!stop.slider_item_title || stop.slider_item_title === "") {
        stop.slider_item_title = theme.slider_title;
      }

      // Apply theme marker URL if exists
      if (theme.marker_url) {
        stop.config.marker = theme.marker_url;
      }
    }
  }

  // Handle Icons and Titles
  if (stop.icon === undefined && stop.show_on_slider) {
    delete stop.icon;
    stop.stop_index = counters.bigStopCnt++;
  } else if (stop.show_marker === false) {
    delete stop.icon;
  } else if (stop.icon && stop.icon.name !== "none") {
    if (stop.slider_item_title) {
      stop.slider_item_title = `${stop.slider_item_title}`;
    } else {
      stop.slider_item_title = `${stop.icon.label} ${
        dictByLnag[approve_tour.language].stop
      }`;
    }
    stop.icon = stop.icon.name;
  } else if (!stop.icon || (stop.icon && stop.icon.name === "none")) {
    delete stop.icon;
    const slider_item_title = title_slider[approve_tour.language.toLowerCase()];
    stop.slider_item_title = `${slider_item_title} #${counters.sliderItemCounter++}`;
    stop.stop_index = counters.bigStopCnt++;
  }

  // Handle Parking Stop
  if (stop.type === "parkingStop") {
    approve_tour.parking = {
      latitude: stop.stop_location.latitude,
      longitude: stop.stop_location.longitude,
      name: stop.s_title,
    };
    return null; // Indicate to remove this stop
  }

  // Handle Hidden/Small Stops
  if (!stop.show_marker && idx !== 0) {
    stop.display_icon = false;
    stop.type = "smallStop";
    stop.show_on_slider = false;
    // Don't clear all_media - stops can have content even without markers
    return stop;
  }

  // Handle Path Inclusion
  if (stop.include_path) {
    counters.stopInRoute += 1;
    if (counters.stopInRoute > 70) {
      stop.include_path = false;
    }
  }

  // Handle Direction Stop
  if (stop.type === "directionStop") {
    stop.type = "smallStop";
    return stop;
  }

  // Process Tags
  const tmpTags = stop.tags || [];
  stop.tags = [];
  tmpTags.forEach((tag) => {
    if (tag.icon) {
      stop.tags.push(tag.text);
    } else {
      if (!tag.text) {
        if (approve_tour.language === "Hebrew") {
          const tagValue =
            tagDict[tag.toLowerCase()] !== undefined
              ? tagDict[tag.toLowerCase()]
              : tag;
          stop.tags.push(tagValue);
        } else {
          stop.tags.push(tag);
        }
      } else {
        stop.tags.push(tag.text);
      }
    }
  });

  // Handle Location Pictures
  /* if (!stop.loc_pics || !stop.loc_pics[0]) {
    stop.loc_pics = [
      {
        name: "direcTmp",
        order: 0,
        title: "title",
        type: "image/jpeg",
        url: "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/0directionPic.png?alt=media&token=9ab51616-61b3-42b9-a7e3-8e3261c6abd1",
      },
    ];
  } */

  if (stop.type.includes("big")) {
    stop.show_on_slider = true;
    if (stop.direction_text) stop.diraction_text = stop.direction_text;
  } else if (stop.loc_pics && stop.loc_pics[0]) {
    stop.show_on_slider = true;
  }

  // Process Location Pictures Async
  if (
    stop.loc_pics &&
    stop.loc_pics[0] &&
    stop.loc_pics[0].name !== "direcTmp"
  ) {
    try {
      const result = await getFileStorageUrlWithFormat(
        tourId,
        stop.id,
        `${stop.loc_pics[0].name}_resize`,
        "jpg",
        "stopMedia",
      );
      stop.loc_pics[0].url = result.url;
      stop.loc_pics[0].name = result.fileName;
      console.log(
        `🎯 Using ${result.format} format for stop loc_pic (optimized: ${result.isOptimized})`,
      );
    } catch (error) {
      console.log("DID NOT GET FUNCTION", error, stop.loc_pics[0].name);
    }
  }

  // Handle Empty Media with Description
  if (stop.all_media && stop.all_media.length === 0) {
    if (stop.s_smallDesc && stop.s_smallDesc.length > 0) {
      stop.all_media[0] = {
        content: stop.s_smallDesc,
        type: "text",
        title: "Introduction",
        name: "a2d60303c2374f82aec20770ef6562c1",
        order: 0,
      };
    }
    stop.type = "smallStop";
    stop.show_on_slider = true;
  }

  // Process All Media
  const mediaPromises = stop.all_media.map(async (media, mIdx) => {
    try {
      if (!media.type) {
        stop.all_media.splice(mIdx, 1);
        return;
      }

      if (media.type.includes("video")) {
        if (!media.url) {
          stop.all_media.splice(mIdx, 1);
          return;
        }
        if (!better_quality) {
          try {
            const resp = await getFileStorageUrl(
              tourId,
              stop.id,
              `${media.name}_compressplus`,
              "mp4",
              "stopMedia",
            );
            stop.all_media[mIdx].url = resp;
            stop.all_media[mIdx].name = `${media.name}_compressplus`;
          } catch (error) {
            console.log(
              "DID NOT GET FUNCTION",
              `${tourId} ${media.name}_compressplus`,
              error,
            );
            try {
              const resp = await getFileStorageUrl(
                tourId,
                stop.id,
                `${media.name}_compress`,
                "mp4",
                "stopMedia",
              );
              stop.all_media[mIdx].url = resp;
              stop.all_media[mIdx].name = `${media.name}_compress`;
            } catch (error) {
              console.log(
                "DID NOT GET FUNCTION",
                `${tourId} ${media.name}_compress`,
                error,
              );
            }
          }
        }
      } else if (media.type.includes("image")) {
        if (!media.url) {
          stop.all_media.splice(mIdx, 1);
          return;
        }
        try {
          const result = await getFileStorageUrlWithFormat(
            tourId,
            stop.id,
            `${media.name}_resize`,
            "jpg",
            "stopMedia",
          );
          stop.all_media[mIdx].url = result.url;
          stop.all_media[mIdx].name = result.fileName;
          console.log(
            `🎯 Using ${result.format} format for stop media ${media.name} (optimized: ${result.isOptimized})`,
          );
        } catch (error) {
          console.log("DID NOT GET FUNCTION", error);
        }
      } else if (media.type.includes("audio")) {
        if (!media.url) {
          stop.all_media.splice(mIdx, 1);
          return;
        }
        stop.all_media[mIdx].type = "audio/mpeg";
        try {
          const resp = await getFileStorageUrl(
            tourId,
            stop.id,
            `${media.name}_compress`,
            "mp3",
            "stopMedia",
          );
          stop.all_media[mIdx].url = resp;
          stop.all_media[mIdx].name = `${media.name}_compress`;
        } catch (error) {
          console.log("DID NOT GET FUNCTION", error);
        }
      } else if (media.type.includes("html")) {
        console.log(
          "convertToStickyButton START idx:",
          idx,
          stop.all_media[mIdx].content,
        );
        const roudedButton = await cleanHtmlStylesAsync(
          stop.all_media[mIdx].content,
        );
        const fixHTMLcontent = fixButtonLinks(roudedButton);

        stop.all_media[mIdx].content = fixHTMLcontent;
        const HTMLwithTitle =
          stop.type === "bigStop"
            ? `<h1>${media.title}</h1>\n${stop.all_media[mIdx].content}`
            : `${stop.all_media[mIdx].content}`;

        let tmpContent = HTMLwithTitle;

        // Replace </em>" with </u>
        tmpContent = tmpContent.replace(/<\/em>"/g, "</u>");

        // Add <br> between </p><p>
        tmpContent = tmpContent.replace(/<\/p>\s*<p>/g, "</p><br><p>");

        // Convert old buttons to new sticky format
        tmpContent = convertToStickyButton(tmpContent);
        try {
          const resp = await compressHTML(tmpContent);
          const base64CompressedData = btoa(String.fromCharCode(...resp));
          stop.all_media[mIdx].content = base64CompressedData;
        } catch (error) {
          console.log("DID NOT GET FUNCTION", error);
          stop.all_media[mIdx].content = tmpContent;
        }
      } else if (media.type.includes("coupon")) {
        if (!counters.allCouponStops.includes(stop.id)) {
          counters.allCouponStops.push(stop.id);
        }
        try {
          const result = await getFileStorageUrlWithFormat(
            tourId,
            stop.id,
            `${media.name}_resize`,
            "jpg",
            "stopMedia",
          );
          stop.all_media[mIdx].product_pic = result.url;
          stop.all_media[mIdx].name = result.fileName;
          console.log(
            `🎯 Using ${result.format} format for coupon ${media.name} (optimized: ${result.isOptimized})`,
          );
        } catch (error) {
          console.log("DID NOT GET FUNCTION", error);
        }
      }
    } catch (error) {
      console.log(
        "error in stop.all_media",
        error,
        "stop idx",
        idx,
        media,
        mIdx,
      );
      stop.all_media.splice(mIdx, 1);
    }
  });

  await Promise.all(mediaPromises);

  // Generate ElevenLabs audio if SSML is present and not already generated
  if (
    stop.elevenlabs?.ssml &&
    !stop.elevenlabs?.audioGenerated &&
    !stop.elevenlabs?.audioUrl
  ) {
    try {
      console.log(
        `🎤 ElevenLabs audio generation for stop ${idx}: ${stop.s_title}`,
      );

      // Get user AI data for voice settings
      const tourGuideId = approve_tour.tour_guide?.id;
      if (!tourGuideId) {
        console.warn(
          `⚠️ No tour guide ID found, skipping ElevenLabs audio for stop ${idx}`,
        );
      } else {
        const userAIDoc = await firebase
          .firestore()
          .collection("AIarea")
          .doc(tourGuideId)
          .get();

        const userAIData = userAIDoc.exists ? userAIDoc.data() : {};

        // Use voice from KML or fall back to user's custom voice
        const voiceId = stop.elevenlabs.voice || userAIData?.voiceId;

        if (!voiceId) {
          console.warn(
            `⚠️ No voice ID available for stop ${idx}, skipping audio generation`,
          );
        } else {
          // Generate audio
          const audioUrl = await generateElevenLabsAudio(
            tourId,
            stop.id,
            stop.elevenlabs.ssml,
            voiceId,
            userAIData,
          );

          if (audioUrl) {
            // Add to all_media array
            stop.all_media.push({
              type: "audio",
              name: `${stop.id}_elevenlabs_audio`,
              url: audioUrl,
              title: "Generated Audio",
              order: stop.all_media.length,
            });

            // Update elevenlabs metadata
            stop.elevenlabs.audioGenerated = true;
            stop.elevenlabs.audioUrl = audioUrl;
            stop.elevenlabs.generatedAt = new Date().toISOString();

            console.log(`✅ ElevenLabs audio added to stop ${idx}`);
          } else {
            console.warn(`⚠️ Audio generation returned null for stop ${idx}`);
          }
        }
      }
    } catch (error) {
      // Log warning but don't fail the approval
      console.error(
        `❌ Error generating ElevenLabs audio for stop ${idx}:`,
        error,
      );
      console.warn(
        `⚠️ Continuing approval without ElevenLabs audio for stop ${idx}`,
      );

      // Store error info for potential retry
      stop.elevenlabs.generationError = {
        message: error.message,
        timestamp: new Date().toISOString(),
      };
    }
  }

  return stop;
};

const saveApprovedTour = async (approve_tour, tourId) => {
  approve_tour.approve_date = Date();
  console.log("approve_tour", approve_tour);
  console.log(
    "SIZE of the OBJECT before sending ",
    JSON.stringify(approve_tour).length,
  );

  try {
    await firebase
      .firestore()
      .collection("approval_saas")
      .doc(tourId)
      .set(approve_tour);
    return approve_tour;
  } catch (err) {
    console.log("tour Approve ERROR!", err);
    throw err;
  }
};

export const promiseApproveTour = function (tour, better_quality = false) {
  return new Promise(async function (myResolve, myReject) {
    if (tour.stops.length < 2) {
      myReject(
        "Tour must include at least 2 stops.\n Please add stops before trying the demo.",
      );
      return;
    }
    if (!tour.title) {
      myReject(
        "Tour must include a title.\n Please fill in the basic details of the tour.",
      );
      return;
    }

    let stopInRoute = 0;
    const MAXSTOPSINROUTE = 70;
    let approve_tour = JSON.parse(JSON.stringify(tour));
    let bigStopCnt = 1;
    let allCouponStops = [];
    try {
      // Starting point
      if (approve_tour.stops[0] && approve_tour.stops[0].stop_location) {
        approve_tour.starting_point = {
          latitude: approve_tour.stops[0].stop_location["latitude"],
          longitude: approve_tour.stops[0].stop_location["longitude"],
        };
      }

      //handle active_filter
      if (approve_tour.config.active_filter) {
        approve_tour.config.active_filter =
          approve_tour.config.active_filter === "true";
      }
      
      // Read image quality setting from tour config
      // Support: "standard" (AVIF), "high" (Resize), "original" (Uncompressed)
      // Backwards compatibility: undefined/false -> "standard", true -> "high"
      let qualityMode = "standard";
      if (approve_tour.config?.use_high_quality_images === "original") {
        qualityMode = "original";
      } else if (approve_tour.config?.use_high_quality_images === "high" || approve_tour.config?.use_high_quality_images === true) {
        qualityMode = "high";
      }
      const qualityLabels = {
        standard: "STANDARD (AVIF - Fastest)",
        high: "HIGH QUALITY (Resize JPG)",
        original: "ORIGINAL (Uncompressed - Largest)"
      };
      console.log("🎨 Image quality setting:", qualityLabels[qualityMode]);
      
      if (!approve_tour.language) approve_tour.language = "English";
      // Starting video or picture

      let startingMediaPromise;

      if (
        approve_tour.config?.active_filter &&
        approve_tour.config?.active_filter === "true"
      ) {
        approve_tour.config.active_filter = true;
      }
      if (approve_tour.starting_name || approve_tour.starting_type) {
        if (approve_tour?.starting_type.includes("image")) {
          console.log("starting_name", approve_tour.starting_name);
          startingMediaPromise = getFileStorageUrlWithFormat(
            tour.id,
            null,
            `${approve_tour?.starting_name}_resize`,
            "jpg",
            null,
            qualityMode,
          )
            .then((result) => {
              approve_tour.starting_image = result.url;
              approve_tour.starting_name = result.fileName; // Will be _avif.avif if AVIF found
              console.log(
                `🎯 Using ${result.format} format for starting image (optimized: ${result.isOptimized})`,
              );
            })
            .catch((error) => {
              console.log(
                "DID NOT GET FUNCTION",
                `${tour.id} starting_name_resize`,
                error,
              );
              approve_tour.starting_image = tour.starting_url;
            });
        } else {
          startingMediaPromise = getFileStorageUrl(
            tour.id,
            approve_tour.stops[0].id,
            `${approve_tour.starting_name}_compress`,
            "mp4",
            "toursMedia",
          )
            .then((resp) => {
              approve_tour.starting_video = resp;
              approve_tour.starting_url = resp;
              approve_tour.starting_name = `${approve_tour.starting_name}_compress`;
            })
            .catch((error) =>
              console.log(
                "DID NOT GET FUNCTION",
                `${tour.id} ${approve_tour.starting_name}_compress`,
                error,
              ),
            );
        }
      } else {
        approve_tour.starting_video = null;
        approve_tour.starting_name = null;
        startingMediaPromise = Promise.resolve();
      }

      let profileImagePromise;
      if (
        approve_tour.tour_guide.profile_image &&
        !approve_tour.tour_guide.profile_image.includes("lh3")
      ) {
        profileImagePromise = getFileStorageUrlWithFormat(
          tour.id,
          null,
          `guideProfile_resize`,
          "jpg",
          null,
          qualityMode,
        )
          .then((result) => {
            approve_tour.tour_guide.profile_image = result.url;
            console.log(
              `🎯 Using ${result.format} format for profile image (optimized: ${result.isOptimized})`,
            );
          })
          .catch((error) =>
            console.log(
              "DID NOT GET FUNCTION",
              `${tour.id} guideProfile_resize`,
              error,
            ),
          );
      } else {
        approve_tour.tour_guide.profile_image =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/avatar-blank.png?alt=media&token=d33a1c38-6d60-4aa1-b7fa-9a324f6a03c4";
        profileImagePromise = Promise.resolve();
      }

      // Processing all_media
      const mediaPromises = approve_tour.all_media.map((media, idx) => {
        /* console.log(
          `Processing media item ${idx + 1} of ${approve_tour.all_media.length}`
        ); */
        if (media.type.includes("video")) {
          return getFileStorageUrl(
            tour.id,
            null,
            `${media.name}_compress`,
            "mp4",
            "toursMedia",
          )
            .then((resp) => {
              approve_tour.all_media[idx].url = resp;
              approve_tour.all_media[idx].name = `${media.name}_compress`;
            })
            .catch((error) => console.log("DID NOT GET FUNCTION", error));
        } else if (media.type.includes("image")) {
          return getFileStorageUrlWithFormat(
            tour.id,
            null,
            `${media.name}_resize`,
            "jpg",
            "toursMedia",
            qualityMode,
          )
            .then((result) => {
              approve_tour.all_media[idx].url = result.url;
              approve_tour.all_media[idx].name = result.fileName;
              console.log(
                `🎯 Using ${result.format} format for media ${media.name} (optimized: ${result.isOptimized})`,
              );
            })
            .catch((error) => console.log("DID NOT GET FUNCTION", error));
        } else {
          return Promise.resolve();
        }
      });

      if (approve_tour.language && approve_tour.language.includes("Hebrew")) {
        approve_tour.exp_video =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/maslol_exp_he_compress.mp4?alt=media&token=cb0b7755-be31-4f55-9df6-42158bd4c1b0";
      } else {
        approve_tour.exp_video =
          "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/mexpo_vid.mp4?alt=media&token=a10b2584-6a4e-4a90-a02c-466ea06d02ad";
      }

      // Iterate over stops and insert new stop if direction_type changes
      let newStops = [];
      let previousStop = null;

      for (let i = 0; i < approve_tour.stops.length; i++) {
        const currentStop = { ...approve_tour.stops[i] }; // Create copy to avoid mutations

        // Set default direction_type
        if (i === 0) {
          // First stop always has direction_type "none" (no navigation to get there)
          currentStop.direction_type = "none";
        } else if (
          currentStop.direction_type === undefined ||
          currentStop.direction_type === "default"
        ) {
          currentStop.direction_type = "foot";
        }

        // Skip stops that don't need path processing
        if (!currentStop.include_path) {
          currentStop.order = newStops.length;
          newStops.push(currentStop);
          previousStop = currentStop;
          continue;
        }

        // Handle "none" direction type - creates a route break (but not for first stop)
        if (currentStop.direction_type === "none" && i > 0) {
          // Create duplicate of current stop to end the previous route segment
          const routeEndStop = {
            direction_type: "none",
            stop_location: currentStop.stop_location,
            include_path: true,
            show_marker: false,
            order: newStops.length,
            show_on_slider: false,
            s_title: `Route End - ${currentStop.s_title}`,
          };
          newStops.push(routeEndStop);

          // Set the current stop's direction_type for the next route segment
          const nextStop = approve_tour.stops[i + 1];
          currentStop.direction_type = nextStop?.direction_type || "foot";
        } else if (
          // Handle direction type changes (except for first stop)
          i > 0 &&
          previousStop &&
          previousStop.direction_type !== currentStop.direction_type
        ) {
          // Create duplicate of previous stop's location with new direction type
          const routeTransitionStop = {
            direction_type: currentStop.direction_type,
            stop_location: previousStop.stop_location,
            include_path: true,
            show_marker: false,
            order: newStops.length,
            show_on_slider: false,
            s_title: `Route Transition - ${previousStop.s_title}`,
          };
          newStops.push(routeTransitionStop);
        }

        // Add the current stop
        currentStop.order = newStops.length;
        newStops.push(currentStop);
        previousStop = currentStop;
      }
      approve_tour.stops = newStops;

      let sliderItemCounter = 1;
      const stopPromises = approve_tour.stops.map(async (stop, idx) => {
        // Ensure all_media is an array, even if it's initially undefined
        approve_tour.stops[idx].all_media =
          approve_tour.stops[idx].all_media || [];

        // Ensure every stop has a type - default to "bigStop" if not defined
        if (!approve_tour.stops[idx].type) {
          approve_tour.stops[idx].type = "bigStop";
        }

        // Apply Theme Data if theme_id exists
        if (stop.theme_id && approve_tour.config?.themes) {
          const theme = approve_tour.config.themes.find(
            (t) => t.id === stop.theme_id,
          );
          if (theme) {
            if (!approve_tour.stops[idx].config)
              approve_tour.stops[idx].config = {};
            approve_tour.stops[idx].config.color = theme.color;
            if (!stop.slider_item_title || stop.slider_item_title === "") {
              approve_tour.stops[idx].slider_item_title = theme.slider_title;
            }
            // Apply theme marker URL if exists
            if (theme.marker_url) {
              approve_tour.stops[idx].config.marker = theme.marker_url;
            }
          }
        }

        /*  if (stop.show_marker === true) {
          if (stop.slider_item_title) {
            approve_tour.stops[
              idx
            ].slider_item_title = `${stop.slider_item_title}`;
          }
        } */
        // Ensure stop.all_media is an array
        if (!Array.isArray(stop.all_media)) {
          stop.all_media = [];
        }

        // Migrate legacy type-based icon system to new stop.icon system
        migrateLegacyStopType(stop);

        // Normalize hours_range if present
        if (stop.hours_range) {
          const normalized = normalizeHoursRange(stop.hours_range);
          if (normalized) {
            approve_tour.stops[idx].hours_range = normalized;
          } else {
            delete approve_tour.stops[idx].hours_range;
          }
        }

        if (stop.icon === undefined && stop.show_on_slider) {
          delete approve_tour.stops[idx].icon;
          approve_tour.stops[idx].stop_index = bigStopCnt;
          bigStopCnt++;
        } else if (stop.show_marker === false) {
          delete approve_tour.stops[idx].icon;
        } else if (stop.icon && stop.icon.name !== "none") {
          if (stop.slider_item_title) {
            approve_tour.stops[
              idx
            ].slider_item_title = `${stop.slider_item_title}`;
          } else {
            // Translate icon label to tour language for consistent multilingual display
            const translatedLabel = getTranslatedIconLabel(
              stop.icon.label,
              approve_tour.language,
            );
            approve_tour.stops[idx].slider_item_title = translatedLabel;
          }
          approve_tour.stops[idx].icon = stop.icon.name;
        } else if (!stop.icon || (stop.icon && stop.icon.name === "none")) {
          delete approve_tour.stops[idx].icon;
          const slider_item_title =
            title_slider[approve_tour.language.toLowerCase()];
          approve_tour.stops[
            idx
          ].slider_item_title = `${slider_item_title} #${sliderItemCounter}`;

          approve_tour.stops[idx].stop_index = bigStopCnt;
          bigStopCnt++;
          sliderItemCounter++;
        }

        if (stop.type === "parkingStop") {
          approve_tour.parking = {
            latitude: stop.stop_location.latitude,
            longitude: stop.stop_location.longitude,
            name: stop.s_title,
          };
          approve_tour.stops.splice(idx, 1);
          return;
        }

        if (!stop.show_marker && idx !== 0) {
          approve_tour.stops[idx].display_icon = false;
          approve_tour.stops[idx].type = "smallStop";
          // Only set show_on_slider to false if not explicitly defined
          if (stop.show_on_slider === undefined) {
            approve_tour.stops[idx].show_on_slider = false;
          }
          // Don't clear all_media - stops can have content even without markers
          //sagi tour
          //approve_tour.stops[idx].show_on_slider = true;
          return;
        }

        if (stop.include_path) {
          stopInRoute += 1;
          if (stopInRoute > MAXSTOPSINROUTE) {
            approve_tour.stops[idx].include_path = false;
          }
        }

        if (stop.type === "directionStop") {
          approve_tour.stops[idx].type = "smallStop";
          return;
        }
        const tmpTags = approve_tour.stops[idx].tags
          ? approve_tour.stops[idx].tags
          : [];
        approve_tour.stops[idx].tags = [];

        tmpTags.map((tag) => {
          if (tag.icon) {
            /* const convertIcon = convertFaIconName(tag.icon);
  
            approve_tour.stops[idx].tags.push({
              icon: convertIcon,
              text: tag.text,
            }); */
            approve_tour.stops[idx].tags.push(tag.text);
          } else {
            if (!tag.text) {
              if (approve_tour.language === "Hebrew") {
                const tagValue =
                  tagDict[tag.toLowerCase()] !== undefined
                    ? tagDict[tag.toLowerCase()]
                    : tag;
                approve_tour.stops[idx].tags.push(tagValue);
              } else {
                approve_tour.stops[idx].tags.push(tag);
              }
            } else {
              approve_tour.stops[idx].tags.push(tag.text);
            }
          }
        });

        /* if (/* idx === 0 && * / !stop.loc_pics || !stop.loc_pics[0]) {
          approve_tour.stops[idx].loc_pics = [
            {
              name: "direcTmp",
              order: 0,
              title: "title",
              type: "image/jpeg",
              url: "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/0directionPic.png?alt=media&token=9ab51616-61b3-42b9-a7e3-8e3261c6abd1",
            },
          ];
        } */

        if (stop.type.includes("big")) {
          // Only set show_on_slider to true if not explicitly set to false
          if (stop.show_on_slider !== false) {
            approve_tour.stops[idx].show_on_slider = true;
          }

          if (stop.direction_text)
            approve_tour.stops[idx].diraction_text = stop.direction_text;

          let locPicsPromise;
          if (stop.loc_pics && stop.loc_pics[0]) {
            locPicsPromise = getFileStorageUrlWithFormat(
              tour.id,
              stop.id,
              `${stop.loc_pics[0].name}_resize`,
              "jpg",
              "stopMedia",
              qualityMode,
            )
              .then((result) => {
                approve_tour.stops[idx].loc_pics[0].url = result.url;
                approve_tour.stops[idx].loc_pics[0].name = result.fileName;
                console.log(
                  `🎯 Using ${result.format} format for big stop loc_pic (optimized: ${result.isOptimized})`,
                );
              })
              .catch((error) =>
                console.log(
                  "DID NOT GET FUNCTION",
                  error,
                  stop.loc_pics[0].name,
                ),
              );
          } else {
            locPicsPromise = Promise.resolve();
          }

          await locPicsPromise;
        } else {
          let locPicsPromise;
          if (stop.loc_pics && stop.loc_pics[0]) {
            // Only set show_on_slider to true if not explicitly set to false
            if (stop.show_on_slider !== false) {
              approve_tour.stops[idx].show_on_slider = true;
            }
            locPicsPromise = getFileStorageUrlWithFormat(
              tour.id,
              stop.id,
              `${stop.loc_pics[0].name}_resize`,
              "jpg",
              "stopMedia",
              qualityMode,
            )
              .then((result) => {
                approve_tour.stops[idx].loc_pics[0].url = result.url;
                approve_tour.stops[idx].loc_pics[0].name = result.fileName;
                console.log(
                  `🎯 Using ${result.format} format for regular stop loc_pic (optimized: ${result.isOptimized})`,
                );
              })
              .catch((error) =>
                console.log(
                  "DID NOT GET FUNCTION",
                  error,
                  stop.loc_pics[0].name,
                ),
              );
          } else {
            locPicsPromise = Promise.resolve();
          }

          await locPicsPromise;
        }

        if (stop.all_media && stop.all_media.length === 0) {
          if (stop.s_smallDesc && stop.s_smallDesc.length > 0) {
            approve_tour.stops[idx].all_media[0] = {
              content: stop.s_smallDesc,
              type: "text",
              title: "Introduction",
              name: "a2d60303c2374f82aec20770ef6562c1",
              order: 0,
            };
          }
          approve_tour.stops[idx].type = "smallStop";
          // Only set show_on_slider to true if not explicitly set to false
          if (stop.show_on_slider !== false) {
            approve_tour.stops[idx].show_on_slider = true;
          }
        }
        const mediaPromises = stop.all_media.map(async (media, mIdx) => {
          try {
            if (!media.type) {
              approve_tour.stops[idx].all_media.splice(mIdx, 1);
            }

            if (media.type.includes("video")) {
              if (!media.url) {
                // Assuming approve_tour, idx, and mIdx are defined
                approve_tour.stops[idx].all_media.splice(mIdx, 1);
                return;
              }
              if (!better_quality) {
                return getFileStorageUrl(
                  tour.id,
                  stop.id,
                  `${media.name}_compressplus`,
                  "mp4",
                  "stopMedia",
                )
                  .then((resp) => {
                    approve_tour.stops[idx].all_media[mIdx].url = resp;
                    approve_tour.stops[idx].all_media[
                      mIdx
                    ].name = `${media.name}_compressplus`;
                  })
                  .catch((error) => {
                    console.log(
                      "DID NOT GET FUNCTION",
                      `${tour.id} ${media.name}_compressplus`,
                      error,
                    );
                    return getFileStorageUrl(
                      tour.id,
                      stop.id,
                      `${media.name}_compress`,
                      "mp4",
                      "stopMedia",
                    )
                      .then((resp) => {
                        approve_tour.stops[idx].all_media[mIdx].url = resp;
                        approve_tour.stops[idx].all_media[
                          mIdx
                        ].name = `${media.name}_compress`;
                      })
                      .catch((error) =>
                        console.log(
                          "DID NOT GET FUNCTION",
                          `${tour.id} ${media.name}_compress`,
                          error,
                        ),
                      );
                  });
              }
            } else if (media.type.includes("image")) {
              if (!media.url) {
                // Assuming approve_tour, idx, and mIdx are defined
                approve_tour.stops[idx].all_media.splice(mIdx, 1);
                return;
              }
              return getFileStorageUrlWithFormat(
                tour.id,
                stop.id,
                `${media.name}_resize`,
                "jpg",
                "stopMedia",
                qualityMode,
              )
                .then((result) => {
                  approve_tour.stops[idx].all_media[mIdx].url = result.url;
                  approve_tour.stops[idx].all_media[mIdx].name =
                    result.fileName;
                  console.log(
                    `🎯 Using ${result.format} format for stop media ${media.name} (optimized: ${result.isOptimized})`,
                  );
                })
                .catch((error) => console.log("DID NOT GET FUNCTION", error));
            } else if (media.type.includes("audio")) {
              if (!media.url) {
                // Assuming approve_tour, idx, and mIdx are defined
                approve_tour.stops[idx].all_media.splice(mIdx, 1);
                return;
              }
              approve_tour.stops[idx].all_media[mIdx].type = "audio/mpeg";
              return getFileStorageUrl(
                tour.id,
                stop.id,
                `${media.name}_compress`,
                "mp3",
                "stopMedia",
              )
                .then((resp) => {
                  approve_tour.stops[idx].all_media[mIdx].url = resp;
                  approve_tour.stops[idx].all_media[
                    mIdx
                  ].name = `${media.name}_compress`;
                  approve_tour.stops[idx].all_media[mIdx].type = "audio/mpeg";
                })
                .catch((error) => console.log("DID NOT GET FUNCTION", error));
            } else if (media.type.includes("html")) {
              /* const roudedButton = addBorderRadiusIfMissing(
                approve_tour.stops[idx].all_media[mIdx].content
              ); */
              console.log(
                "convertToStickyButton START idx:",
                idx,
                approve_tour.stops[idx].all_media[mIdx].content,
              );
              const roudedButton = await cleanHtmlStylesAsync(
                approve_tour.stops[idx].all_media[mIdx].content,
              );
              const fixHTMLcontent = fixButtonLinks(roudedButton);

              approve_tour.stops[idx].all_media[mIdx].content = fixHTMLcontent;
              const HTMLwithTitle =
                approve_tour.stops[idx].type === "bigStop"
                  ? `<h1>${media.title}</h1>\n${approve_tour.stops[idx].all_media[mIdx].content}`
                  : `${approve_tour.stops[idx].all_media[mIdx].content}`;

              let tmpContent = HTMLwithTitle; // approve_tour.stops[idx].all_media[mIdx].content;

              // Replace </em>" with </u>
              tmpContent = tmpContent.replace(/<\/em>"/g, "</u>");

              // Add <br> between </p><p>
              tmpContent = tmpContent.replace(/<\/p>\s*<p>/g, "</p><br><p>");

              // Convert old buttons to new sticky format
              tmpContent = convertToStickyButton(tmpContent);
              /* const compressed =  */ compressHTML(tmpContent)
                .then((resp) => {
                  // Convert to Base64
                  const base64CompressedData = btoa(
                    String.fromCharCode(...resp),
                  );
                  approve_tour.stops[idx].all_media[mIdx].content =
                    base64CompressedData;
                  return Promise.resolve();
                })
                .catch((error) => {
                  console.log("DID NOT GET FUNCTION", error);
                  approve_tour.stops[idx].all_media[mIdx].content = tmpContent;
                  return Promise.resolve();
                });
            } else if (media.type.includes("audio")) {
              approve_tour.stops[idx].all_media[mIdx].type = "audio/mpeg";
              return Promise.resolve();
            } else if (media.type.includes("coupon")) {
              if (!allCouponStops.includes(approve_tour.stops[idx].id)) {
                allCouponStops.push(approve_tour.stops[idx].id);
              }
              // Normalize hours_range for coupon if present
              if (media.hours_range) {
                const normalized = normalizeHoursRange(media.hours_range);
                if (normalized) {
                  approve_tour.stops[idx].all_media[mIdx].hours_range =
                    normalized;
                } else {
                  delete approve_tour.stops[idx].all_media[mIdx].hours_range;
                }
              }
              return getFileStorageUrlWithFormat(
                tour.id,
                stop.id,
                `${media.name}_resize`,
                "jpg",
                "stopMedia",
                qualityMode,
              )
                .then((result) => {
                  approve_tour.stops[idx].all_media[mIdx].product_pic =
                    result.url;
                  approve_tour.stops[idx].all_media[mIdx].name =
                    result.fileName;
                  console.log(
                    `🎯 Using ${result.format} format for coupon ${media.name} (optimized: ${result.isOptimized})`,
                  );
                })
                .catch((error) => console.log("DID NOT GET FUNCTION", error));
              return Promise.resolve();
            } else {
              return Promise.resolve();
            }
          } catch (error) {
            console.log(
              "error in stop.all_media",
              error,
              "stop idx",
              idx,
              media,
              mIdx,
            );
            approve_tour.stops[idx].all_media.splice(mIdx, 1);
            return Promise.resolve();
          }
        });

        await Promise.all(mediaPromises);

        // Validate smallStop has at least one image in loc_pics or all_media
        // This is called AFTER media processing so compressed image URLs are set
        validateSmallStopImages(approve_tour.stops[idx]);
      });

      // add the AI question to the tour

      await Promise.all([
        startingMediaPromise,
        profileImagePromise,
        ...mediaPromises,
        ...stopPromises,
      ]);
      approve_tour.coupon_stops = allCouponStops;

      // Remove themes from config before saving to approval_saas
      if (approve_tour.config?.themes) {
        delete approve_tour.config.themes;
      }

      // Count unique tags across all stops to determine if filtering should be enabled
      const allTags = new Set();
      approve_tour.stops.forEach(stop => {
        if (stop.tags && Array.isArray(stop.tags)) {
          stop.tags.forEach(tag => {
            if (tag) {
              allTags.add(tag);
            }
          });
        }
      });

      // Disable filtering if there are fewer than 3 unique tags
      if (allTags.size < 3) {
        if (!approve_tour.config) {
          approve_tour.config = {};
        }
        approve_tour.config.active_filter = false;
        console.log(`🔄 Disabled filtering - only ${allTags.size} unique tags found (minimum 3 required)`);
      }

      approve_tour.approve_date = Date();
      console.log("approve_tour", approve_tour);
      console.log(
        "SIZE of the OBJECT before sending ",
        JSON.stringify(approve_tour).length,
      );

      delete approve_tour?.neighboringStops;

      firebase
        .firestore()
        .collection("approval_saas")
        .doc(tour.id)
        .set(approve_tour)
        .then(() => {
          myResolve(approve_tour);
        })
        .catch((err) => {
          console.log("tour Approve ERROR!", err);
          myReject(err);
        });
    } catch (error) {
      console.log("ERROR", error);
      myReject(error);
    }
  });
};

export const promiseApproveTourNew = async function (
  tour,
  better_quality = false,
) {
  console.log("promiseApproveTourNew");
  try {
    validateTour(tour);

    const approve_tour = setupTourConfig(tour);

    await processTourMedia(approve_tour, tour.id);

    const newStops = restructureStops(approve_tour.stops);
    approve_tour.stops = newStops;

    const counters = {
      stopInRoute: 0,
      bigStopCnt: 1,
      sliderItemCounter: 1,
      allCouponStops: [],
    };

    const processedStopsPromises = approve_tour.stops.map((stop, i) =>
      processStop(stop, i, approve_tour, tour.id, better_quality, counters),
    );

    const processedStopsResults = await Promise.all(processedStopsPromises);
    const processedStops = processedStopsResults.filter(
      (stop) => stop !== null,
    );
    approve_tour.stops = processedStops;
    approve_tour.coupon_stops = counters.allCouponStops;
    console.log("Final approve_tour", approve_tour);
    return await saveApprovedTour(approve_tour, tour.id);
  } catch (error) {
    console.log("ERROR", error);
    throw error;
  }
};

/**
 * Batch approve all tours for a specific guide, excluding duplicates
 * @param {string} guideId - The tour guide's user ID
 * @param {boolean} excludeDuplicated - Whether to exclude tours with "DUPLICATED" in title
 * @returns {Promise} - Results of all approval operations
 */
export const batchApproveToursByGuide = async function (
  guideId,
  excludeDuplicated = true,
) {
  try {
    console.log(`🚀 Starting batch approval for guide: ${guideId}`);

    // Query all tours for this guide
    const toursSnapshot = await firebase
      .firestore()
      .collection("tours")
      .where("tour_guide.id", "==", guideId)
      .get();

    if (toursSnapshot.empty) {
      console.log("❌ No tours found for this guide");
      return { success: 0, failed: 0, skipped: 0, results: [] };
    }

    console.log(`📊 Found ${toursSnapshot.size} tours for this guide`);

    const results = {
      success: 0,
      failed: 0,
      skipped: 0,
      results: [],
    };

    // Process each tour
    for (const doc of toursSnapshot.docs) {
      const tour = doc.data();
      const tourTitle = tour.title || "Untitled";

      // Check if tour should be skipped
      if (excludeDuplicated && tourTitle.includes("DUPLICATED")) {
        console.log(`⏭️ Skipping duplicated tour: ${tourTitle} (${tour.id})`);
        results.skipped++;
        results.results.push({
          tourId: tour.id,
          title: tourTitle,
          status: "skipped",
          reason: "Contains DUPLICATED in title",
        });
        continue;
      }

      // Approve the tour
      try {
        console.log(`⏳ Approving tour: ${tourTitle} (${tour.id})`);
        await promiseApproveTour(tour, false);
        console.log(`✅ Successfully approved: ${tourTitle}`);
        results.success++;
        results.results.push({
          tourId: tour.id,
          title: tourTitle,
          status: "success",
        });
      } catch (error) {
        console.error(`❌ Failed to approve: ${tourTitle}`, error);
        results.failed++;
        results.results.push({
          tourId: tour.id,
          title: tourTitle,
          status: "failed",
          error: error.message || error.toString(),
        });
      }
    }

    console.log(`\n📈 Batch Approval Summary:`);
    console.log(`✅ Success: ${results.success}`);
    console.log(`❌ Failed: ${results.failed}`);
    console.log(`⏭️ Skipped: ${results.skipped}`);

    return results;
  } catch (error) {
    console.error("❌ Batch approval error:", error);
    throw error;
  }
};

export const promiseApproveTourNoMedia = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    console.log("promiseApproveTourNoMedia");
    if (tour.stops.length < 2) {
      myReject(
        "Tour most include at least 2 stops.\n Please add stops before tring the demo.",
      );
      return;
    }
    if (!tour.title) {
      myReject(
        "Tour most include title.\n Please fill the basic details of that tour.",
      );
      return;
    }

    let stopInRoute = 0;
    const MAXSTOPSINROUTE = 70;
    let approve_tour = JSON.parse(JSON.stringify(tour));
    let bigStopCnt = 1;

    try {
      //starting_point
      if (approve_tour.stops[0] && approve_tour.stops[0].stop_location) {
        approve_tour.starting_point = {
          latitude: approve_tour.stops[0].stop_location["latitude"],
          longitude: approve_tour.stops[0].stop_location["longitude"],
        };
      }

      if (approve_tour.tour_image) approve_tour.tour_image = "";
      //starting_video
      if (approve_tour.starting_name) {
        approve_tour.starting_video = "";
      }
      if (
        approve_tour.tour_guide.profile_image &&
        !approve_tour.tour_guide.profile_image.includes("lh3")
      ) {
        approve_tour.tour_guide.profile_image = "";
      }

      if (approve_tour.tour_image_obj.url) approve_tour.tour_image_obj.url = "";
      //all_media
      approve_tour.all_media = [];
      approve_tour.id = "NoMediaTour";
      approve_tour.stops.map((stop, idx) => {
        // Apply Theme Data if theme_id exists
        if (stop.theme_id && approve_tour.config?.themes) {
          const theme = approve_tour.config.themes.find(
            (t) => t.id === stop.theme_id,
          );
          if (theme) {
            if (!stop.config) stop.config = {};
            stop.config.color = theme.color;
            if (!stop.slider_item_title || stop.slider_item_title === "") {
              stop.slider_item_title = theme.slider_title;
            }
            // Apply theme marker URL if exists
            if (theme.marker_url) {
              stop.config.marker = theme.marker_url;
            }
          }
        }

        if (stop.type === "parkingStop") {
          approve_tour.parking = {
            latitude: stop.stop_location.latitude,
            longitude: stop.stop_location.longitude,
            name: stop.s_title,
          };
          approve_tour.stops.splice(idx, 1);
          return;
        }

        if (stop.include_path) {
          stopInRoute += 1;
          if (stopInRoute > MAXSTOPSINROUTE) {
            approve_tour.stops[idx].include_path = false;
          }
        }

        if (stop.type === "directionStop") {
          approve_tour.stops[idx].type = "smallStop";
          return;
        }

        if (approve_tour.language === "Hebrew") {
          const tmpTags = approve_tour.stops[idx].tags
            ? approve_tour.stops[idx].tags
            : [];
          approve_tour.stops[idx].tags = [];
          tmpTags.map((tag) => {
            approve_tour.stops[idx].tags.push(tagDict[tag.toLowerCase()]);
          });
        }

        approve_tour.stops[idx].loc_pics = [];

        stop.all_media = [];
        if (idx === 0) {
          approve_tour.stops[idx].loc_pics = [
            {
              name: "direcTmp",
              order: 0,
              title: "title",
              type: "image/jpeg",
              url: "https://firebasestorage.googleapis.com/v0/b/dguidedev.appspot.com/o/direcTmp.jpg?alt=media&token=580c9983-9b39-4b30-a64b-00695c65b8eb",
            },
          ];
        }
      });
      setTimeout(() => {
        // Remove themes from config before saving to approval_saas
        if (approve_tour.config?.themes) {
          delete approve_tour.config.themes;
        }

        approve_tour.approve_date = Date();
        firebase
          .firestore()
          .collection("approval_saas")
          .doc("NoMediaTour")
          .set(approve_tour)
          .then(() => {
            //updateApprovDate(tour)
            myResolve(approve_tour);
          })
          .catch((err) => {
            console.log("tour Approve ERROR!", err);
            myReject(err);
          });
      }, 9000);
    } catch (error) {
      console.log("ERROR", error);
    }
  });
};

export const copyFirestoreDocument = async (
  sourceCollection,
  sourceDocId,
  targetCollection,
  targetDocId = null,
) => {
  try {
    // Get the source document
    const sourceDoc = await firebase
      .firestore()
      .collection(sourceCollection)
      .doc(sourceDocId)
      .get();

    if (!sourceDoc.exists || targetDocId === null) {
      throw new Error(`Source document ${sourceDocId} does not exist`);
    }

    // Get the data
    const data = sourceDoc.data();
    data.id = targetDocId;
    // Create new document (use sourceDocId if targetDocId is not provided)
    const newDocId = targetDocId || sourceDocId;

    // Write to target location
    await firebase
      .firestore()
      .collection(targetCollection)
      .doc(newDocId)
      .set(data);

    console.log(
      `Document copied from ${sourceCollection}/${sourceDocId} to ${targetCollection}/${newDocId}`,
    );
    return newDocId;
  } catch (error) {
    console.error("Error copying document:", error);
    throw error;
  }
};

export const openAIcallNew = function (massage, fromLang, toLang) {
  return new Promise(async function (myResolve, myReject) {
    const key = "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";
    const apiRes = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
      body: JSON.stringify({
        model: "gpt-3.5-turbo",
        messages: [
          {
            role: "user",
            content: `translate from ${
              fromLang ? fromLang : ""
            } to ${toLang} : ${massage}`,
          },
        ],
      }),
      // body: JSON.stringify({
      //   model: "gpt-3.5-turbo",
      //   messages: [
      //     { role: "system", content: "You are a great German teacher." },
      //     {
      //       role: "assistant",
      //       content:
      //         "Yes, I am. I will translate your German sentence and explain the detail about the translated sentence. ",
      //     },
      //     { role: "user", content },
      //   ],
      // }),
    });
  });
};
export const openAIcall = function (massage, fromLang, toLang) {
  return new Promise(async function (myResolve, myReject) {
    const key = "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";
    const apiRes = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
      body: JSON.stringify({
        model: "gpt-3.5-turbo",
        messages: [
          { role: "user", content: `translate to ${toLang} : ${massage}` },
        ],
      }),
      // body: JSON.stringify({
      //   model: "gpt-3.5-turbo",
      //   messages: [
      //     { role: "system", content: "You are a great German teacher." },
      //     {
      //       role: "assistant",
      //       content:
      //         "Yes, I am. I will translate your German sentence and explain the detail about the translated sentence. ",
      //     },
      //     { role: "user", content },
      //   ],
      // }),
    });

    if (apiRes.status !== 200) {
      console.log(`open ai API status code: ${apiRes.status}`);
      myReject(apiRes.status);
    }

    const json = await apiRes.json();

    console.log({
      message: !json.choices?.length ? "" : json.choices[0].message.content,
    });
    myResolve(!json.choices?.length ? "" : json.choices[0].message.content);
  });
};

export const openAILivecall = function (massage) {
  return new Promise(async function (myResolve, myReject) {
    const key = "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";
    const apiRes = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
      body: JSON.stringify({
        model: "gpt-3.5-turbo",
        messages: [{ role: "user", content: `${massage}` }],
      }),
    });

    if (apiRes.status !== 200) {
      console.log(`open ai API status code: ${apiRes.status}`);
      myReject(apiRes.status);
    }

    const json = await apiRes.json();

    console.log({
      message: !json.choices?.length ? "" : json.choices[0].message.content,
    });
    myResolve(!json.choices?.length ? "" : json.choices[0].message.content);
  });
};

export const GetContentByLocation = function (massage) {
  return new Promise(async function (myResolve, myReject) {
    const key = "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";
    console.log("SEND TO chatGPT");
    const apiRes = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${key}`,
      },
      body: JSON.stringify({
        model: "gpt-4",
        messages: [{ role: "user", content: `${massage}` }],
      }),
    });

    if (apiRes.status !== 200) {
      console.log(`open ai API status code: ${apiRes.status}`);
      myReject(apiRes.status);
    }

    const json = await apiRes.json();
    console.log("Got response");
    console.log({
      message: !json.choices?.length ? "0" : json.choices[0].message.content,
    });
    myResolve(!json.choices?.length ? "0" : json.choices[0].message.content);
  });
};

export const createSellingWeb = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    const docRef = firebase.firestore().collection("web_tour").doc(tour.id);

    docRef
      .get()
      .then((doc) => {
        if (!doc.exists) {
          const sellingWeb = {
            id: tour.id,
            title: tour.title,
            tourPriceP: "75 per phone, 3 and more phones in 60 per phone",
            tourTimeInfoP: `The tour is suitable for the hours 8:00-20:00 and it's about ${tour.duration} hours trip`,
            tourTypeP: `${tour.type.join(", ")} tour`,
            tourdescription:
              "Join our exciting tour and discover amazing things! Explore interesting places, learn cool facts, and find surprises around every corner. From old places to new discoveries, every step is full of fun. Come along and see for yourself, it's an adventure you won't forget!",
            tourLocactionP: `Our tour will start in ${tour.location} and will end in ${tour.location}`,
            price: "35",
            color: "green",
            guideProfileImgInput: [""],
            tourImageInput: [""],
            tourImagesArray: [""],
            tourAgeGroupP: "All ages",
            tourVidInput: [""],
          };
          console.log("web_tour", web_tour);
          docRef
            .set(web_tour, { merge: true })
            .then(() => {
              myResolve(tour.id);
            })
            .catch((err) => {
              console.log("tour Approve ERROR!", err);
              myReject(err);
            });
        } else {
          console.log("Document already exists!", doc.data());
          myResolve(tour.id);
        }
      })
      .catch((err) => {
        console.log("Error getting document:", err);
        myReject(err);
      });
  });
};

export const translateTour = function (tour, fromLang, toLang) {
  return new Promise(async function (myResolve, myReject) {
    let translate_tour = JSON.parse(JSON.stringify(tour));

    if (tour.description && tour.description.length > 0)
      openAIcall(tour.description, fromLang, toLang)
        .then((resp) => {
          translate_tour.description = resp;
        })
        .catch((err) => console.log("error in translate", err));

    if (tour.location && tour.location.length > 0)
      openAIcall(tour.location, fromLang, toLang)
        .then((resp) => {
          translate_tour.location = resp;
        })
        .catch((err) => console.log("error in translate", err));

    if (tour.main_sentense && tour.main_sentense.length > 0)
      openAIcall(tour.main_sentense, fromLang, toLang)
        .then((resp) => {
          translate_tour.main_sentense = resp;
        })
        .catch((err) => console.log("error in translate", err));

    if (tour.notes && tour.notes.length > 0) {
      tour.notes.map((note, nIdx) => {
        if (note.question)
          openAIcall(note.question, fromLang, toLang)
            .then((resp) => {
              translate_tour.notes[nIdx].question = resp;
            })
            .catch((err) => console.log("error in translate", err));

        if (note.answer)
          openAIcall(note.answer, fromLang, toLang)
            .then((resp) => {
              translate_tour.notes[nIdx].answer = resp;
            })
            .catch((err) => console.log("error in translate", err));
      });
    }

    if (tour.equipment)
      tour.equipment.map((equi, qIdx) => {
        if (equi)
          openAIcall(equi, fromLang, toLang)
            .then((resp) => {
              translate_tour.equipment[qIdx] = resp;
            })
            .catch((err) => console.log("error in translate", err));
      });

    tour.stops.map((stop, stopIdx) => {
      if (stop.direction_text && stop.direction_text.length > 0) {
        openAIcall(stop.direction_text, fromLang, toLang)
          .then((resp) => {
            translate_tour.stops[stopIdx].direction_text = resp;
          })
          .catch((err) => console.log("error in translate", err));
      }

      if (stop.s_title && stop.s_title.length > 0) {
        openAIcall(stop.s_title, fromLang, toLang)
          .then((resp) => {
            translate_tour.stops[stopIdx].s_title = resp;
          })
          .catch((err) => console.log("error in translate", err));
      }

      if (stop.s_smallDesc && stop.s_smallDesc.length > 0) {
        openAIcall(stop.s_smallDesc, fromLang, toLang)
          .then((resp) => {
            translate_tour.stops[stopIdx].s_smallDesc = resp;
          })
          .catch((err) => console.log("error in translate", err));
      }
      if (stop.slider_item_title && stop.slider_item_title.length > 0) {
        openAIcall(stop.slider_item_title, fromLang, toLang)
          .then((resp) => {
            translate_tour.stops[stopIdx].slider_item_title = resp;
          })
          .catch((err) => console.log("error in translate", err));
      }
      stop.tags.map((tag, tagIdx) => {
        if (tag.icon) {
          openAIcall(tag.text, fromLang, toLang)
            .then((resp) => {
              translate_tour.stops[stopIdx].tags[tagIdx].text = resp;
            })
            .catch((err) => console.log("error in translate", err));
        } else {
          openAIcall(tag, fromLang, toLang)
            .then((resp) => {
              translate_tour.stops[stopIdx].tags[tagIdx] = resp;
            })
            .catch((err) => console.log("error in translate", err));
        }
      });

      stop.all_media.map((media, mediaIdx) => {
        if (media.title.length > 0) {
          openAIcall(media.title, fromLang, toLang)
            .then((resp) => {
              translate_tour.stops[stopIdx].all_media[mediaIdx].title = resp;
            })
            .catch((err) => console.log("error in translate", err));
        }
        if (media.type.includes("text") && media.content) {
          openAIcall(media.content, fromLang, toLang)
            .then((resp) => {
              translate_tour.stops[stopIdx].all_media[mediaIdx].content = resp;
            })
            .catch((err) => console.log("error in translate", err));
        }
        if (media.type.includes("HTNL") && media.content) {
          openAIcall(media.content, fromLang, toLang)
            .then((resp) => {
              translate_tour.stops[stopIdx].all_media[mediaIdx].content = resp;
            })
            .catch((err) => console.log("error in translate", err));
        }
      }); //all_media loop
    }); //stops loop

    setTimeout(() => {
      console.log("translate_tour", translate_tour);
      translate_tour.approve_date = Date();
      firebase
        .firestore()
        .collection("tours")
        .doc(translate_tour.id)
        .set(translate_tour)
        .then(() => {
          //updateApprovDate(tour)
          myResolve(translate_tour);
        })
        .catch((err) => {
          console.log("tour Approve ERROR!", err);
          myReject(err);
        });
    }, 30000);
  });
};

export const translateDirectionText = function (tour, fromLang, toLang) {
  return new Promise(async function (myResolve, myReject) {
    let translate_tour = JSON.parse(JSON.stringify(tour));
    tour.stops.map((stop, stopIdx) => {
      console.log("translate direction text", stop.direction_text, stop);
      if (stop.direction_text && stop.direction_text.length > 0) {
        console.log("translate direction text", stop.direction_text);
        openAIcall(stop.direction_text, fromLang, toLang)
          .then((resp) => {
            translate_tour.stops[stopIdx].direction_text = resp;
          })
          .catch((err) => console.log("error in translate", err));
      }
    }); //stops loop
    setTimeout(() => {
      console.log("translate_tour", translate_tour);
      translate_tour.approve_date = Date();
      firebase
        .firestore()
        .collection("tours")
        .doc(translate_tour.id)
        .set(translate_tour)
        .then(() => {
          //updateApprovDate(tour)
          myResolve(translate_tour);
        })
        .catch((err) => {
          console.log("tour Approve ERROR!", err);
          myReject(err);
        });
    }, 15000);
  });
};

export const calculateDocumentSize = async (collectionName, documentId) => {
  try {
    // Get the document reference
    console.log("collectionName", collectionName);
    console.log("documentId", documentId);
    const docRef = firebase
      .firestore()
      .collection(collectionName)
      .doc(documentId);
    console.log("docRef", docRef);
    docRef
      .get()
      .then((docSnap) => {
        console.log("docSnap", docSnap);
        if (docSnap.exists) {
          const docData = docSnap.data();

          // Convert the document to a JSON string
          const jsonString = JSON.stringify(docData);

          // Calculate the size in bytes
          const sizeInBytes = new Blob([jsonString]).size;

          const bytesToKB = (sizeInBytes) => (sizeInBytes / 1024).toFixed(2);

          const sizeInKB = bytesToKB(sizeInBytes);

          console.log(`${sizeInBytes} bytes is approximately ${sizeInKB} KB.`);
          return sizeInBytes;
        } else {
          console.log("No such document!");
          return 0;
        }
      })
      .catch((err) => {
        console.log("tour Approve ERROR!", err);
        return 0;
      });
  } catch (error) {
    console.error("Error fetching document:", error);
  }
};

export const copyStops = function (tour1, tour2) {
  return new Promise(async function (myResolve, myReject) {
    if (!tour1 || !tour2) {
      myReject("One of the tours is undefined");
      return;
    }

    if (!tour1.stops || !tour2.stops) {
      myReject("One of the tours does not have stops");
      return;
    }
    let dup_tour = JSON.parse(JSON.stringify(tour2));
    await copyFolderFiles(`${tour2.id}/`, `${tour1.id}/`);
    await Promise.all(
      dup_tour.stops.map(async (stop, s_idx) => {
        if (stop.all_media)
          stop.all_media.map(async (media, mediaIdx) => {
            if (media.url) {
              console.log(`ref media ${tour1.id}/${media.name}`);
              await storage
                .ref(`${tour1.id}/${media.name}`)
                .getDownloadURL()
                .then(
                  (url) =>
                    (dup_tour.stops[s_idx].all_media[mediaIdx].url = url),
                )
                .catch((err) => {
                  dup_tour.stops[s_idx].all_media[mediaIdx].url = "";
                });
            }
          }); //all_media loop

        if (stop.loc_pics && stop.loc_pics[0]) {
          console.log(`ref loc_pic ${tour1.id}/${stop.loc_pics[0].name}`);
          await storage
            .ref(`${tour1.id}/${stop.loc_pics[0].name}`)
            .getDownloadURL()
            .then((url) => (dup_tour.stops[s_idx].loc_pics[0].url = url))
            .catch((err) => (dup_tour.stops[s_idx].loc_pics[0].url = ""));
        }
      }), //stops loop
    );
    console.log("dup_tour after update URL", dup_tour);
    let mergedStops = [
      ...tour1.stops,
      ...dup_tour.stops.map((stop) => ({ ...stop })),
    ];
    mergedStops = mergedStops.map((stop, index) => {
      return {
        ...stop,
        order: index,
      };
    });
    const newTour = {
      ...tour1,
      stops: mergedStops,
    };

    console.log("newTour", newTour);
    saveTourFirebase(newTour)
      .then((tour) => {
        console.log("tour1", tour);
        myResolve(tour);
      })
      .catch((error) => {
        console.error("Error saving tour:", error);
        myReject(error);
      });
  });
};

export const deleteStops = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    console.log("deleteStops", tour);
    if (!tour || !tour.stops) {
      myReject("One of the tours does not have stops");
      return;
    }
    let dup_tour = JSON.parse(JSON.stringify(tour));
    dup_tour.stops = dup_tour.stops.slice(0, 53);
    console.log("dup_tour after update URL", dup_tour);
    saveTourFirebase(dup_tour)
      .then((tour) => {
        console.log("tour1", tour);
        myResolve(tour);
      })
      .catch((error) => {
        console.error("Error saving tour:", error);
        myReject(error);
      });
  });
};

// ─── Tour vs Approval diff ─────────────────────────────────────────────────────

function _diffObjects(a, b, path = "") {
  const diffs = [];
  const keys = new Set([
    ...Object.keys(a || {}),
    ...Object.keys(b || {}),
  ]);

  const isPlainObject = (value) =>
    value !== null && typeof value === "object" && !Array.isArray(value);

  const diffArrays = (arrA, arrB, arrPath) => {
    const arrayDiffs = [];
    const maxLen = Math.max(arrA.length, arrB.length);

    if (arrA.length !== arrB.length) {
      arrayDiffs.push({
        path: `${arrPath}.length`,
        tours: arrA.length,
        approval_saas: arrB.length,
      });
    }

    for (let i = 0; i < maxLen; i++) {
      const itemPath = `${arrPath}[${i}]`;
      const av = arrA[i];
      const bv = arrB[i];

      if (Array.isArray(av) && Array.isArray(bv)) {
        arrayDiffs.push(...diffArrays(av, bv, itemPath));
      } else if (isPlainObject(av) && isPlainObject(bv)) {
        arrayDiffs.push(..._diffObjects(av, bv, itemPath));
      } else if (av !== bv) {
        arrayDiffs.push({ path: itemPath, tours: av, approval_saas: bv });
      }
    }

    return arrayDiffs;
  };

  for (const key of keys) {
    const p = path ? `${path}.${key}` : key;
    const av = a ? a[key] : undefined;
    const bv = b ? b[key] : undefined;

    if (Array.isArray(av) && Array.isArray(bv)) {
      diffs.push(...diffArrays(av, bv, p));
    } else if (isPlainObject(av) && isPlainObject(bv)) {
      diffs.push(..._diffObjects(av, bv, p));
    } else if (av !== bv) {
      diffs.push({ path: p, tours: av, approval_saas: bv });
    }
  }
  return diffs;
}

export const compareTourDocs = async (docId) => {
  const [tourSnap, approvalSnap] = await Promise.all([
    db.collection("tours").doc(docId).get(),
    db.collection("approval_saas").doc(docId).get(),
  ]);

  const result = {
    docId,
    toursExists: tourSnap.exists,
    approvalExists: approvalSnap.exists,
    diffs: [],
  };

  if (!tourSnap.exists || !approvalSnap.exists) {
    return result;
  }

  const toursData = JSON.parse(JSON.stringify(tourSnap.data()));
  const approvalData = JSON.parse(JSON.stringify(approvalSnap.data()));
  result.diffs = _diffObjects(toursData, approvalData);
  return result;
};

export const updateAllDocs = async () => {
  try {
    const collectionRef = db.collection("approval_saas");

    console.log("Fetching documents from approval_saas collection...");
    const snapshot = await collectionRef.get();

    console.log(`Found ${snapshot.docs.length} documents in the collection`);

    if (snapshot.docs.length === 0) {
      console.log("No documents found in the collection!");
      return;
    }

    // Limit to first 5 documents for testing
    const docsToUpdate = snapshot.docs.slice(0, 5);
    console.log(
      `Testing update on ${docsToUpdate.length} documents out of ${snapshot.docs.length} total documents`,
    );

    const batch = db.batch();

    console.log("Processing documents...");
    docsToUpdate.forEach((doc, index) => {
      const docRef = collectionRef.doc(doc.id);
      console.log(`${index + 1}. Processing document: ${doc.id}`);

      // Use set with merge instead of update to handle non-existing docs
      batch.set(
        docRef,
        {
          exp_video:
            "https://firebasestorage.googleapis.com/v0/b/tours-app-1579553856346.appspot.com/o/exp_video_compress_v2.mp4?alt=media&token=3159a9ec-c8b2-4f6f-bc6b-92c94462186f",
        },
        { merge: true },
      );
    });

    console.log("Committing batch update...");
    await batch.commit();
    console.log(
      `✅ Successfully updated ${docsToUpdate.length} documents (testing mode).`,
    );
  } catch (error) {
    console.error("❌ Error updating documents:", error);
    throw error;
  }
};

export const fllipStops = function (tour) {
  return new Promise(async function (myResolve, myReject) {
    console.log("fllipStops", tour);
    if (!tour || !tour.stops) {
      myReject("One of the tours does not have stops");
      return;
    }
    dupTour(tour, true)
      .then((dup_tour) => {
        console.log("after Dup", dup_tour);
        dup_tour.title = `Flipped ${tour.title}`;
        dup_tour.stops = dup_tour.stops.reverse();
        dup_tour.stops = dup_tour.stops.map((stop, index) => {
          return {
            ...stop,
            order: index,
          };
        });
        console.log("dup_tour after update URL", dup_tour);
        saveTourFirebase(dup_tour)
          .then((tour) => {
            console.log("tour1", tour);
            myResolve(tour);
          })
          .catch((error) => {
            console.error("Error saving tour:", error);
            myReject(error);
          });
        myResolve(tour);
      })
      .catch((error) => {
        console.error("Error saving tour:", error);
        myReject(error);
      });
  });
};

// ===================== TOUR PACKAGE FUNCTIONS =====================

export const saveTourPackage = function (packageData, userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      if (!packageData || !userID) {
        throw new Error("Package data and user ID are required");
      }

      const packageWithMetadata = {
        ...packageData,
        userID: userID,
        updatedAt: new Date(),
        createdAt: packageData.createdAt || new Date(),
      };

      if (packageData.id) {
        // Update existing package
        await db
          .collection("tourPackage")
          .doc(packageData.id)
          .update(packageWithMetadata);
        console.log("Tour package updated successfully:", packageData.id);
      } else {
        // Create new package
        const newPackageId = `${getUUID()}`;
        packageWithMetadata.id = newPackageId;
        await db
          .collection("tourPackage")
          .doc(newPackageId)
          .set(packageWithMetadata);
        console.log("Tour package created successfully:", newPackageId);
        packageWithMetadata.id = newPackageId;
      }

      myResolve(packageWithMetadata);
    } catch (error) {
      console.error("Error saving tour package:", error);
      myReject(error);
    }
  });
};

export const getUserTourPackages = function (userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      if (!userID) {
        throw new Error("User ID is required");
      }

      const querySnapshot = await db
        .collection("tourPackage")
        .where("userID", "==", userID)
        //.orderBy("updatedAt", "desc")
        .get();

      const packages = [];
      querySnapshot.forEach((doc) => {
        packages.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      console.log(`Found ${packages.length} tour packages for user:`, userID);
      myResolve(packages);
    } catch (error) {
      console.error("Error fetching user tour packages:", error);
      myReject(error);
    }
  });
};

export const deleteTourPackage = function (packageId, userID) {
  return new Promise(async function (myResolve, myReject) {
    try {
      if (!packageId || !userID) {
        throw new Error("Package ID and user ID are required");
      }

      // First verify the package belongs to the user
      const packageDoc = await db
        .collection("tourPackage")
        .doc(packageId)
        .get();

      if (!packageDoc.exists) {
        throw new Error("Package not found");
      }

      const packageData = packageDoc.data();
      if (packageData.userID !== userID) {
        throw new Error("Unauthorized: Package does not belong to user");
      }

      // Delete the package
      await db.collection("tourPackage").doc(packageId).delete();
      console.log("Tour package deleted successfully:", packageId);
      myResolve("Package deleted successfully");
    } catch (error) {
      console.error("Error deleting tour package:", error);
      myReject(error);
    }
  });
};

export const getTourPackageById = function (packageId) {
  return new Promise(async function (myResolve, myReject) {
    try {
      if (!packageId) {
        throw new Error("Package ID is required");
      }

      const packageDoc = await db
        .collection("tourPackage")
        .doc(packageId)
        .get();

      if (!packageDoc.exists) {
        throw new Error("Package not found");
      }

      const packageData = {
        id: packageDoc.id,
        ...packageDoc.data(),
      };

      console.log("Tour package retrieved successfully:", packageId);
      myResolve(packageData);
    } catch (error) {
      console.error("Error fetching tour package:", error);
      myReject(error);
    }
  });
};
